(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/**
 * This is the entry file for the frontend application.
 */ function $94de31091369a6d0$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}


function $b748c2928eb486ff$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $46c5ec7b680f2ebd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $46c5ec7b680f2ebd$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $46c5ec7b680f2ebd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $46c5ec7b680f2ebd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $738e4b1ac50283c3$export$c2c98ac76e997b63(o, p) {
    $738e4b1ac50283c3$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $738e4b1ac50283c3$export$c2c98ac76e997b63(o, p);
}


function $458b276467f5f7f8$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $738e4b1ac50283c3$export$c2c98ac76e997b63)(subClass, superClass);
}


function $9dae7d5532d96567$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $e9043c973c9cd53a$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(target, key, source[key]);
        });
    }
    return target;
}


function $2e3f8a3eedaf0f1d$export$f09211a7d3c496a1(o) {
    $2e3f8a3eedaf0f1d$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2e3f8a3eedaf0f1d$export$f09211a7d3c496a1(o);
}


function $82ed57cad692036f$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}



function $02413262891c7eb5$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $6b39b9b469bf207f$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $02413262891c7eb5$export$5f0017c582d45a2d)(call) === "object" || typeof call === "function")) return call;
    return (0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(self);
}


function $8bb5c09b2c0b5c8b$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $82ed57cad692036f$export$685354647fba1516)();
    return function _createSuperInternal() {
        var Super = (0, $2e3f8a3eedaf0f1d$export$f09211a7d3c496a1)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2e3f8a3eedaf0f1d$export$f09211a7d3c496a1)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6b39b9b469bf207f$export$ef97c660ca164e52)(this, result);
    };
}


var $057c0fd32ae7196f$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

"use strict";
var $057c0fd32ae7196f$var$R = typeof Reflect === "object" ? Reflect : null;
var $057c0fd32ae7196f$var$ReflectApply = $057c0fd32ae7196f$var$R && typeof $057c0fd32ae7196f$var$R.apply === "function" ? $057c0fd32ae7196f$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $057c0fd32ae7196f$var$ReflectOwnKeys;
if ($057c0fd32ae7196f$var$R && typeof $057c0fd32ae7196f$var$R.ownKeys === "function") $057c0fd32ae7196f$var$ReflectOwnKeys = $057c0fd32ae7196f$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $057c0fd32ae7196f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $057c0fd32ae7196f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $057c0fd32ae7196f$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $057c0fd32ae7196f$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $057c0fd32ae7196f$var$EventEmitter() {
    $057c0fd32ae7196f$var$EventEmitter.init.call(this);
}
$057c0fd32ae7196f$exports = $057c0fd32ae7196f$var$EventEmitter;
$057c0fd32ae7196f$exports.once = $057c0fd32ae7196f$var$once;
// Backwards-compat with node 0.10.x
$057c0fd32ae7196f$var$EventEmitter.EventEmitter = $057c0fd32ae7196f$var$EventEmitter;
$057c0fd32ae7196f$var$EventEmitter.prototype._events = undefined;
$057c0fd32ae7196f$var$EventEmitter.prototype._eventsCount = 0;
$057c0fd32ae7196f$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $057c0fd32ae7196f$var$defaultMaxListeners = 10;
function $057c0fd32ae7196f$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + (typeof listener === "undefined" ? "undefined" : (0, $02413262891c7eb5$export$5f0017c582d45a2d)(listener)));
}
Object.defineProperty($057c0fd32ae7196f$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function get() {
        return $057c0fd32ae7196f$var$defaultMaxListeners;
    },
    set: function set(arg) {
        if (typeof arg !== "number" || arg < 0 || $057c0fd32ae7196f$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $057c0fd32ae7196f$var$defaultMaxListeners = arg;
    }
});
$057c0fd32ae7196f$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$057c0fd32ae7196f$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $057c0fd32ae7196f$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $057c0fd32ae7196f$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $057c0fd32ae7196f$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$057c0fd32ae7196f$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $057c0fd32ae7196f$var$_getMaxListeners(this);
};
$057c0fd32ae7196f$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $057c0fd32ae7196f$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $057c0fd32ae7196f$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$057c0fd32ae7196f$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $057c0fd32ae7196f$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $057c0fd32ae7196f$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $057c0fd32ae7196f$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $057c0fd32ae7196f$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$057c0fd32ae7196f$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $057c0fd32ae7196f$var$_addListener(this, type, listener, false);
};
$057c0fd32ae7196f$var$EventEmitter.prototype.on = $057c0fd32ae7196f$var$EventEmitter.prototype.addListener;
$057c0fd32ae7196f$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $057c0fd32ae7196f$var$_addListener(this, type, listener, true);
};
function $057c0fd32ae7196f$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $057c0fd32ae7196f$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $057c0fd32ae7196f$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$057c0fd32ae7196f$var$EventEmitter.prototype.once = function once(type, listener) {
    $057c0fd32ae7196f$var$checkListener(listener);
    this.on(type, $057c0fd32ae7196f$var$_onceWrap(this, type, listener));
    return this;
};
$057c0fd32ae7196f$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $057c0fd32ae7196f$var$checkListener(listener);
    this.prependListener(type, $057c0fd32ae7196f$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$057c0fd32ae7196f$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $057c0fd32ae7196f$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $057c0fd32ae7196f$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$057c0fd32ae7196f$var$EventEmitter.prototype.off = $057c0fd32ae7196f$var$EventEmitter.prototype.removeListener;
$057c0fd32ae7196f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $057c0fd32ae7196f$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $057c0fd32ae7196f$var$unwrapListeners(evlistener) : $057c0fd32ae7196f$var$arrayClone(evlistener, evlistener.length);
}
$057c0fd32ae7196f$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $057c0fd32ae7196f$var$_listeners(this, type, true);
};
$057c0fd32ae7196f$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $057c0fd32ae7196f$var$_listeners(this, type, false);
};
$057c0fd32ae7196f$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $057c0fd32ae7196f$var$listenerCount.call(emitter, type);
};
$057c0fd32ae7196f$var$EventEmitter.prototype.listenerCount = $057c0fd32ae7196f$var$listenerCount;
function $057c0fd32ae7196f$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$057c0fd32ae7196f$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $057c0fd32ae7196f$var$ReflectOwnKeys(this._events) : [];
};
function $057c0fd32ae7196f$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $057c0fd32ae7196f$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $057c0fd32ae7196f$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $057c0fd32ae7196f$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $057c0fd32ae7196f$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $057c0fd32ae7196f$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $057c0fd32ae7196f$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $057c0fd32ae7196f$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $057c0fd32ae7196f$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + (typeof emitter === "undefined" ? "undefined" : (0, $02413262891c7eb5$export$5f0017c582d45a2d)(emitter)));
}


var $236abd3863dac270$export$8b4395497d8b4223 = "change_state";
var $236abd3863dac270$export$dc7e8c09bf56e28f = "state_changed";
var $236abd3863dac270$var$StateHandler = /*#__PURE__*/ function(Emitter) {
    "use strict";
    (0, $458b276467f5f7f8$export$7e4530ad35d3bb8)(StateHandler, Emitter);
    var _super = (0, $8bb5c09b2c0b5c8b$export$8dd05c13f5255580)(StateHandler);
    function StateHandler() {
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, StateHandler);
        var _this;
        _this = _super.call(this);
        _this.changeState = _this.changeState.bind((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this));
        _this._state = {};
        return _this;
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(StateHandler, [
        {
            key: "changeState",
            value: function changeState(state) {
                var previous = (0, $e9043c973c9cd53a$export$581ff339ea0ba762)({}, this._state);
                this._state = (0, $e9043c973c9cd53a$export$581ff339ea0ba762)({}, this._state, state);
                this.emit($236abd3863dac270$export$dc7e8c09bf56e28f, this._state, previous);
            }
        }
    ]);
    return StateHandler;
}((0, (/*@__PURE__*/$parcel$interopDefault($057c0fd32ae7196f$exports))));
var $236abd3863dac270$var$stateHandler = new $236abd3863dac270$var$StateHandler();
var $236abd3863dac270$export$2e2bcd8739ae039 = $236abd3863dac270$var$stateHandler;


var $b72fab8558ef5d54$exports = {};
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */ /**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/ 
var $3ce9c2508a6babe0$exports = {};
// shim for using process in browser
var $3ce9c2508a6babe0$var$process = $3ce9c2508a6babe0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3ce9c2508a6babe0$var$cachedSetTimeout;
var $3ce9c2508a6babe0$var$cachedClearTimeout;
function $3ce9c2508a6babe0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3ce9c2508a6babe0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3ce9c2508a6babe0$var$cachedSetTimeout = setTimeout;
        else $3ce9c2508a6babe0$var$cachedSetTimeout = $3ce9c2508a6babe0$var$defaultSetTimout;
    } catch (e) {
        $3ce9c2508a6babe0$var$cachedSetTimeout = $3ce9c2508a6babe0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3ce9c2508a6babe0$var$cachedClearTimeout = clearTimeout;
        else $3ce9c2508a6babe0$var$cachedClearTimeout = $3ce9c2508a6babe0$var$defaultClearTimeout;
    } catch (e) {
        $3ce9c2508a6babe0$var$cachedClearTimeout = $3ce9c2508a6babe0$var$defaultClearTimeout;
    }
})();
function $3ce9c2508a6babe0$var$runTimeout(fun) {
    if ($3ce9c2508a6babe0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3ce9c2508a6babe0$var$cachedSetTimeout === $3ce9c2508a6babe0$var$defaultSetTimout || !$3ce9c2508a6babe0$var$cachedSetTimeout) && setTimeout) {
        $3ce9c2508a6babe0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3ce9c2508a6babe0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3ce9c2508a6babe0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3ce9c2508a6babe0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3ce9c2508a6babe0$var$runClearTimeout(marker) {
    if ($3ce9c2508a6babe0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3ce9c2508a6babe0$var$cachedClearTimeout === $3ce9c2508a6babe0$var$defaultClearTimeout || !$3ce9c2508a6babe0$var$cachedClearTimeout) && clearTimeout) {
        $3ce9c2508a6babe0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3ce9c2508a6babe0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3ce9c2508a6babe0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3ce9c2508a6babe0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3ce9c2508a6babe0$var$queue = [];
var $3ce9c2508a6babe0$var$draining = false;
var $3ce9c2508a6babe0$var$currentQueue;
var $3ce9c2508a6babe0$var$queueIndex = -1;
function $3ce9c2508a6babe0$var$cleanUpNextTick() {
    if (!$3ce9c2508a6babe0$var$draining || !$3ce9c2508a6babe0$var$currentQueue) return;
    $3ce9c2508a6babe0$var$draining = false;
    if ($3ce9c2508a6babe0$var$currentQueue.length) $3ce9c2508a6babe0$var$queue = $3ce9c2508a6babe0$var$currentQueue.concat($3ce9c2508a6babe0$var$queue);
    else $3ce9c2508a6babe0$var$queueIndex = -1;
    if ($3ce9c2508a6babe0$var$queue.length) $3ce9c2508a6babe0$var$drainQueue();
}
function $3ce9c2508a6babe0$var$drainQueue() {
    if ($3ce9c2508a6babe0$var$draining) return;
    var timeout = $3ce9c2508a6babe0$var$runTimeout($3ce9c2508a6babe0$var$cleanUpNextTick);
    $3ce9c2508a6babe0$var$draining = true;
    var len = $3ce9c2508a6babe0$var$queue.length;
    while(len){
        $3ce9c2508a6babe0$var$currentQueue = $3ce9c2508a6babe0$var$queue;
        $3ce9c2508a6babe0$var$queue = [];
        while(++$3ce9c2508a6babe0$var$queueIndex < len)if ($3ce9c2508a6babe0$var$currentQueue) $3ce9c2508a6babe0$var$currentQueue[$3ce9c2508a6babe0$var$queueIndex].run();
        $3ce9c2508a6babe0$var$queueIndex = -1;
        len = $3ce9c2508a6babe0$var$queue.length;
    }
    $3ce9c2508a6babe0$var$currentQueue = null;
    $3ce9c2508a6babe0$var$draining = false;
    $3ce9c2508a6babe0$var$runClearTimeout(timeout);
}
$3ce9c2508a6babe0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3ce9c2508a6babe0$var$queue.push(new $3ce9c2508a6babe0$var$Item(fun, args));
    if ($3ce9c2508a6babe0$var$queue.length === 1 && !$3ce9c2508a6babe0$var$draining) $3ce9c2508a6babe0$var$runTimeout($3ce9c2508a6babe0$var$drainQueue);
};
// v8 likes predictible objects
function $3ce9c2508a6babe0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3ce9c2508a6babe0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3ce9c2508a6babe0$var$process.title = "browser";
$3ce9c2508a6babe0$var$process.browser = true;
$3ce9c2508a6babe0$var$process.env = {};
$3ce9c2508a6babe0$var$process.argv = [];
$3ce9c2508a6babe0$var$process.version = ""; // empty string to avoid regexp issues
$3ce9c2508a6babe0$var$process.versions = {};
function $3ce9c2508a6babe0$var$noop() {}
$3ce9c2508a6babe0$var$process.on = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.addListener = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.once = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.off = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.removeListener = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.removeAllListeners = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.emit = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.prependListener = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.prependOnceListener = $3ce9c2508a6babe0$var$noop;
$3ce9c2508a6babe0$var$process.listeners = function(name) {
    return [];
};
$3ce9c2508a6babe0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3ce9c2508a6babe0$var$process.cwd = function() {
    return "/";
};
$3ce9c2508a6babe0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3ce9c2508a6babe0$var$process.umask = function() {
    return 0;
};


!function(e) {
    var f;
    $b72fab8558ef5d54$exports = e();
}(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof _dereq_ == "function" && _dereq_;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var _$n = t[o][1][e];
                    return s(_$n ? _$n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = typeof _dereq_ == "function" && _dereq_;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var SomePromiseArray = Promise1._SomePromiseArray;
                    function any(promises) {
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(1);
                        ret.setUnwrap();
                        ret.init();
                        return promise;
                    }
                    Promise1.any = function(promises) {
                        return any(promises);
                    };
                    Promise1.prototype.any = function() {
                        return any(this);
                    };
                };
            },
            {}
        ],
        2: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var firstLineError;
                try {
                    throw new Error();
                } catch (e) {
                    firstLineError = e;
                }
                var schedule = _dereq_1("./schedule");
                var Queue = _dereq_1("./queue");
                function Async() {
                    this._customScheduler = false;
                    this._isTickUsed = false;
                    this._lateQueue = new Queue(16);
                    this._normalQueue = new Queue(16);
                    this._haveDrainedQueues = false;
                    var _$self = this;
                    this.drainQueues = function() {
                        _$self._drainQueues();
                    };
                    this._schedule = schedule;
                }
                Async.prototype.setScheduler = function(fn) {
                    var prev = this._schedule;
                    this._schedule = fn;
                    this._customScheduler = true;
                    return prev;
                };
                Async.prototype.hasCustomScheduler = function() {
                    return this._customScheduler;
                };
                Async.prototype.haveItemsQueued = function() {
                    return this._isTickUsed || this._haveDrainedQueues;
                };
                Async.prototype.fatalError = function(e, isNode) {
                    if (isNode) {
                        $3ce9c2508a6babe0$exports.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
                        $3ce9c2508a6babe0$exports.exit(2);
                    } else this.throwLater(e);
                };
                Async.prototype.throwLater = function(fn, arg) {
                    if (arguments.length === 1) {
                        arg = fn;
                        fn = function fn() {
                            throw arg;
                        };
                    }
                    if (typeof setTimeout !== "undefined") setTimeout(function() {
                        fn(arg);
                    }, 0);
                    else try {
                        this._schedule(function() {
                            fn(arg);
                        });
                    } catch (e) {
                        throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                    }
                };
                function AsyncInvokeLater(fn, receiver, arg) {
                    this._lateQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncInvoke(fn, receiver, arg) {
                    this._normalQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncSettlePromises(promise) {
                    this._normalQueue._pushOne(promise);
                    this._queueTick();
                }
                Async.prototype.invokeLater = AsyncInvokeLater;
                Async.prototype.invoke = AsyncInvoke;
                Async.prototype.settlePromises = AsyncSettlePromises;
                function _drainQueue(queue) {
                    while(queue.length() > 0)_drainQueueStep(queue);
                }
                function _drainQueueStep(queue) {
                    var fn = queue.shift();
                    if (typeof fn !== "function") fn._settlePromises();
                    else {
                        var receiver = queue.shift();
                        var arg = queue.shift();
                        fn.call(receiver, arg);
                    }
                }
                Async.prototype._drainQueues = function() {
                    _drainQueue(this._normalQueue);
                    this._reset();
                    this._haveDrainedQueues = true;
                    _drainQueue(this._lateQueue);
                };
                Async.prototype._queueTick = function() {
                    if (!this._isTickUsed) {
                        this._isTickUsed = true;
                        this._schedule(this.drainQueues);
                    }
                };
                Async.prototype._reset = function() {
                    this._isTickUsed = false;
                };
                module1.exports = Async;
                module1.exports.firstLineError = firstLineError;
            },
            {
                "./queue": 26,
                "./schedule": 29
            }
        ],
        3: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, debug) {
                    var calledBind = false;
                    var rejectThis = function rejectThis(_, e) {
                        this._reject(e);
                    };
                    var targetRejected = function targetRejected(e, context) {
                        context.promiseRejectionQueued = true;
                        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
                    };
                    var bindingResolved = function bindingResolved(thisArg, context) {
                        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
                    };
                    var bindingRejected = function bindingRejected(e, context) {
                        if (!context.promiseRejectionQueued) this._reject(e);
                    };
                    Promise1.prototype.bind = function(thisArg) {
                        if (!calledBind) {
                            calledBind = true;
                            Promise1.prototype._propagateFrom = debug.propagateFromFunction();
                            Promise1.prototype._boundValue = debug.boundValueFunction();
                        }
                        var maybePromise = tryConvertToPromise(thisArg);
                        var ret = new Promise1(INTERNAL);
                        ret._propagateFrom(this, 1);
                        var target = this._target();
                        ret._setBoundTo(maybePromise);
                        if (maybePromise instanceof Promise1) {
                            var context = {
                                promiseRejectionQueued: false,
                                promise: ret,
                                target: target,
                                bindingPromise: maybePromise
                            };
                            target._then(INTERNAL, targetRejected, undefined, ret, context);
                            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
                            ret._setOnCancel(maybePromise);
                        } else ret._resolveCallback(target);
                        return ret;
                    };
                    Promise1.prototype._setBoundTo = function(obj) {
                        if (obj !== undefined) {
                            this._bitField = this._bitField | 2097152;
                            this._boundTo = obj;
                        } else this._bitField = this._bitField & -2097153;
                    };
                    Promise1.prototype._isBound = function() {
                        return (this._bitField & 2097152) === 2097152;
                    };
                    Promise1.bind = function(thisArg, value) {
                        return Promise1.resolve(value).bind(thisArg);
                    };
                };
            },
            {}
        ],
        4: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var old;
                if (typeof Promise !== "undefined") old = Promise;
                function noConflict() {
                    try {
                        if (Promise === bluebird) Promise = old;
                    } catch (e) {}
                    return bluebird;
                }
                var bluebird = _dereq_1("./promise")();
                bluebird.noConflict = noConflict;
                module1.exports = bluebird;
            },
            {
                "./promise": 22
            }
        ],
        5: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var cr = Object.create;
                if (cr) {
                    var callerCache = cr(null);
                    var getterCache = cr(null);
                    callerCache[" size"] = getterCache[" size"] = 0;
                }
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var isIdentifier = util.isIdentifier;
                    var getMethodCaller;
                    var getGetter;
                    var makeMethodCaller, makeGetter, getCompiled;
                    function ensureMethod(obj, methodName) {
                        var fn;
                        if (obj != null) fn = obj[methodName];
                        if (typeof fn !== "function") {
                            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                            throw new Promise1.TypeError(message);
                        }
                        return fn;
                    }
                    function caller(obj) {
                        var methodName = this.pop();
                        var fn = ensureMethod(obj, methodName);
                        return fn.apply(obj, this);
                    }
                    Promise1.prototype.call = function(methodName) {
                        var args = [].slice.call(arguments, 1);
                        var maybeCaller;
                        args.push(methodName);
                        return this._then(caller, undefined, undefined, args, undefined);
                    };
                    function namedGetter(obj) {
                        return obj[this];
                    }
                    function indexedGetter(obj) {
                        var index = +this;
                        if (index < 0) index = Math.max(0, index + obj.length);
                        return obj[index];
                    }
                    Promise1.prototype.get = function(propertyName) {
                        var isIndex = typeof propertyName === "number";
                        var getter;
                        if (!isIndex) {
                            if (canEvaluate) {
                                var maybeGetter = getGetter(propertyName);
                                getter = maybeGetter !== null ? maybeGetter : namedGetter;
                            } else getter = namedGetter;
                        } else getter = indexedGetter;
                        return this._then(getter, undefined, undefined, propertyName, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        6: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    Promise1.prototype["break"] = Promise1.prototype.cancel = function() {
                        if (!debug.cancellation()) return this._warn("cancellation is disabled");
                        var promise = this;
                        var child = promise;
                        while(promise._isCancellable()){
                            if (!promise._cancelBy(child)) {
                                if (child._isFollowing()) child._followee().cancel();
                                else child._cancelBranched();
                                break;
                            }
                            var parent = promise._cancellationParent;
                            if (parent == null || !parent._isCancellable()) {
                                if (promise._isFollowing()) promise._followee().cancel();
                                else promise._cancelBranched();
                                break;
                            } else {
                                if (promise._isFollowing()) promise._followee().cancel();
                                promise._setWillBeCancelled();
                                child = promise;
                                promise = parent;
                            }
                        }
                    };
                    Promise1.prototype._branchHasCancelled = function() {
                        this._branchesRemainingToCancel--;
                    };
                    Promise1.prototype._enoughBranchesHaveCancelled = function() {
                        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
                    };
                    Promise1.prototype._cancelBy = function(canceller) {
                        if (canceller === this) {
                            this._branchesRemainingToCancel = 0;
                            this._invokeOnCancel();
                            return true;
                        } else {
                            this._branchHasCancelled();
                            if (this._enoughBranchesHaveCancelled()) {
                                this._invokeOnCancel();
                                return true;
                            }
                        }
                        return false;
                    };
                    Promise1.prototype._cancelBranched = function() {
                        if (this._enoughBranchesHaveCancelled()) this._cancel();
                    };
                    Promise1.prototype._cancel = function() {
                        if (!this._isCancellable()) return;
                        this._setCancelled();
                        async.invoke(this._cancelPromises, this, undefined);
                    };
                    Promise1.prototype._cancelPromises = function() {
                        if (this._length() > 0) this._settlePromises();
                    };
                    Promise1.prototype._unsetOnCancel = function() {
                        this._onCancelField = undefined;
                    };
                    Promise1.prototype._isCancellable = function() {
                        return this.isPending() && !this._isCancelled();
                    };
                    Promise1.prototype.isCancellable = function() {
                        return this.isPending() && !this.isCancelled();
                    };
                    Promise1.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
                        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                        else if (onCancelCallback !== undefined) {
                            if (typeof onCancelCallback === "function") {
                                if (!internalOnly) {
                                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                                    if (e === errorObj) {
                                        this._attachExtraTrace(e.e);
                                        async.throwLater(e.e);
                                    }
                                }
                            } else onCancelCallback._resultCancelled(this);
                        }
                    };
                    Promise1.prototype._invokeOnCancel = function() {
                        var onCancelCallback = this._onCancel();
                        this._unsetOnCancel();
                        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
                    };
                    Promise1.prototype._invokeInternalOnCancel = function() {
                        if (this._isCancellable()) {
                            this._doInvokeOnCancel(this._onCancel(), true);
                            this._unsetOnCancel();
                        }
                    };
                    Promise1.prototype._resultCancelled = function() {
                        this.cancel();
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        7: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var getKeys = _dereq_1("./es5").keys;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function catchFilter(instances, cb, promise) {
                        return function(e) {
                            var boundTo = promise._boundValue();
                            predicateLoop: for(var i = 0; i < instances.length; ++i){
                                var item = instances[i];
                                if (item === Error || item != null && item.prototype instanceof Error) {
                                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                                } else if (typeof item === "function") {
                                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                                    if (matchesPredicate === errorObj) return matchesPredicate;
                                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                                } else if (util.isObject(e)) {
                                    var keys = getKeys(item);
                                    for(var j = 0; j < keys.length; ++j){
                                        var key = keys[j];
                                        if (item[key] != e[key]) continue predicateLoop;
                                    }
                                    return tryCatch(cb).call(boundTo, e);
                                }
                            }
                            return NEXT_FILTER;
                        };
                    }
                    return catchFilter;
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        8: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var longStackTraces = false;
                    var contextStack = [];
                    Promise1.prototype._promiseCreated = function() {};
                    Promise1.prototype._pushContext = function() {};
                    Promise1.prototype._popContext = function() {
                        return null;
                    };
                    Promise1._peekContext = Promise1.prototype._peekContext = function() {};
                    function Context() {
                        this._trace = new Context.CapturedTrace(peekContext());
                    }
                    Context.prototype._pushContext = function() {
                        if (this._trace !== undefined) {
                            this._trace._promiseCreated = null;
                            contextStack.push(this._trace);
                        }
                    };
                    Context.prototype._popContext = function() {
                        if (this._trace !== undefined) {
                            var trace = contextStack.pop();
                            var ret = trace._promiseCreated;
                            trace._promiseCreated = null;
                            return ret;
                        }
                        return null;
                    };
                    function createContext() {
                        if (longStackTraces) return new Context();
                    }
                    function peekContext() {
                        var lastIndex = contextStack.length - 1;
                        if (lastIndex >= 0) return contextStack[lastIndex];
                        return undefined;
                    }
                    Context.CapturedTrace = null;
                    Context.create = createContext;
                    Context.deactivateLongStackTraces = function() {};
                    Context.activateLongStackTraces = function() {
                        var Promise_pushContext = Promise1.prototype._pushContext;
                        var Promise_popContext = Promise1.prototype._popContext;
                        var Promise_PeekContext = Promise1._peekContext;
                        var Promise_peekContext = Promise1.prototype._peekContext;
                        var Promise_promiseCreated = Promise1.prototype._promiseCreated;
                        Context.deactivateLongStackTraces = function() {
                            Promise1.prototype._pushContext = Promise_pushContext;
                            Promise1.prototype._popContext = Promise_popContext;
                            Promise1._peekContext = Promise_PeekContext;
                            Promise1.prototype._peekContext = Promise_peekContext;
                            Promise1.prototype._promiseCreated = Promise_promiseCreated;
                            longStackTraces = false;
                        };
                        longStackTraces = true;
                        Promise1.prototype._pushContext = Context.prototype._pushContext;
                        Promise1.prototype._popContext = Context.prototype._popContext;
                        Promise1._peekContext = Promise1.prototype._peekContext = peekContext;
                        Promise1.prototype._promiseCreated = function() {
                            var ctx = this._peekContext();
                            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
                        };
                    };
                    return Context;
                };
            },
            {}
        ],
        9: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, Context, enableAsyncHooks, disableAsyncHooks) {
                    var async = Promise1._async;
                    var Warning = _dereq_1("./errors").Warning;
                    var util = _dereq_1("./util");
                    var es5 = _dereq_1("./es5");
                    var canAttachTrace = util.canAttachTrace;
                    var unhandledRejectionHandled;
                    var possiblyUnhandledRejection;
                    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
                    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
                    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
                    var stackFramePattern = null;
                    var formatStack = null;
                    var indentStackFrames = false;
                    var printWarning;
                    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && true);
                    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
                    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
                    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                    var deferUnhandledRejectionCheck;
                    (function() {
                        var promises = [];
                        function unhandledRejectionCheck() {
                            for(var i = 0; i < promises.length; ++i)promises[i]._notifyUnhandledRejection();
                            unhandledRejectionClear();
                        }
                        function unhandledRejectionClear() {
                            promises.length = 0;
                        }
                        deferUnhandledRejectionCheck = function deferUnhandledRejectionCheck(promise) {
                            promises.push(promise);
                            setTimeout(unhandledRejectionCheck, 1);
                        };
                        es5.defineProperty(Promise1, "_unhandledRejectionCheck", {
                            value: unhandledRejectionCheck
                        });
                        es5.defineProperty(Promise1, "_unhandledRejectionClear", {
                            value: unhandledRejectionClear
                        });
                    })();
                    Promise1.prototype.suppressUnhandledRejections = function() {
                        var target = this._target();
                        target._bitField = target._bitField & -1048577 | 524288;
                    };
                    Promise1.prototype._ensurePossibleRejectionHandled = function() {
                        if ((this._bitField & 524288) !== 0) return;
                        this._setRejectionIsUnhandled();
                        deferUnhandledRejectionCheck(this);
                    };
                    Promise1.prototype._notifyUnhandledRejectionIsHandled = function() {
                        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
                    };
                    Promise1.prototype._setReturnedNonUndefined = function() {
                        this._bitField = this._bitField | 268435456;
                    };
                    Promise1.prototype._returnedNonUndefined = function() {
                        return (this._bitField & 268435456) !== 0;
                    };
                    Promise1.prototype._notifyUnhandledRejection = function() {
                        if (this._isRejectionUnhandled()) {
                            var reason = this._settledValue();
                            this._setUnhandledRejectionIsNotified();
                            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
                        }
                    };
                    Promise1.prototype._setUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField | 262144;
                    };
                    Promise1.prototype._unsetUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField & -262145;
                    };
                    Promise1.prototype._isUnhandledRejectionNotified = function() {
                        return (this._bitField & 262144) > 0;
                    };
                    Promise1.prototype._setRejectionIsUnhandled = function() {
                        this._bitField = this._bitField | 1048576;
                    };
                    Promise1.prototype._unsetRejectionIsUnhandled = function() {
                        this._bitField = this._bitField & -1048577;
                        if (this._isUnhandledRejectionNotified()) {
                            this._unsetUnhandledRejectionIsNotified();
                            this._notifyUnhandledRejectionIsHandled();
                        }
                    };
                    Promise1.prototype._isRejectionUnhandled = function() {
                        return (this._bitField & 1048576) > 0;
                    };
                    Promise1.prototype._warn = function(message, shouldUseOwnTrace, promise) {
                        return warn(message, shouldUseOwnTrace, promise || this);
                    };
                    Promise1.onPossiblyUnhandledRejection = function(fn) {
                        var context = Promise1._getContext();
                        possiblyUnhandledRejection = util.contextBind(context, fn);
                    };
                    Promise1.onUnhandledRejectionHandled = function(fn) {
                        var context = Promise1._getContext();
                        unhandledRejectionHandled = util.contextBind(context, fn);
                    };
                    var disableLongStackTraces = function disableLongStackTraces() {};
                    Promise1.longStackTraces = function() {
                        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                        if (!config.longStackTraces && longStackTracesIsSupported()) {
                            var Promise_captureStackTrace = Promise1.prototype._captureStackTrace;
                            var Promise_attachExtraTrace = Promise1.prototype._attachExtraTrace;
                            var Promise_dereferenceTrace = Promise1.prototype._dereferenceTrace;
                            config.longStackTraces = true;
                            disableLongStackTraces = function disableLongStackTraces() {
                                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                                Promise1.prototype._captureStackTrace = Promise_captureStackTrace;
                                Promise1.prototype._attachExtraTrace = Promise_attachExtraTrace;
                                Promise1.prototype._dereferenceTrace = Promise_dereferenceTrace;
                                Context.deactivateLongStackTraces();
                                config.longStackTraces = false;
                            };
                            Promise1.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                            Promise1.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                            Promise1.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                            Context.activateLongStackTraces();
                        }
                    };
                    Promise1.hasLongStackTraces = function() {
                        return config.longStackTraces && longStackTracesIsSupported();
                    };
                    var legacyHandlers = {
                        unhandledrejection: {
                            before: function before() {
                                var ret = util.global.onunhandledrejection;
                                util.global.onunhandledrejection = null;
                                return ret;
                            },
                            after: function after(fn) {
                                util.global.onunhandledrejection = fn;
                            }
                        },
                        rejectionhandled: {
                            before: function before() {
                                var ret = util.global.onrejectionhandled;
                                util.global.onrejectionhandled = null;
                                return ret;
                            },
                            after: function after(fn) {
                                util.global.onrejectionhandled = fn;
                            }
                        }
                    };
                    var fireDomEvent = function() {
                        var dispatch = function dispatch(legacy, e) {
                            if (legacy) {
                                var fn;
                                try {
                                    fn = legacy.before();
                                    return !util.global.dispatchEvent(e);
                                } finally{
                                    legacy.after(fn);
                                }
                            } else return !util.global.dispatchEvent(e);
                        };
                        try {
                            if (typeof CustomEvent === "function") {
                                var event = new CustomEvent("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var eventData = {
                                        detail: event,
                                        cancelable: true
                                    };
                                    var domEvent = new CustomEvent(name, eventData);
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else if (typeof Event === "function") {
                                var event = new Event("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = new Event(name, {
                                        cancelable: true
                                    });
                                    domEvent.detail = event;
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else {
                                var event = document.createEvent("CustomEvent");
                                event.initCustomEvent("testingtheevent", false, true, {});
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = document.createEvent("CustomEvent");
                                    domEvent.initCustomEvent(name, false, true, event);
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            }
                        } catch (e) {}
                        return function() {
                            return false;
                        };
                    }();
                    var fireGlobalEvent = function() {
                        if (util.isNode) return function() {
                            return $3ce9c2508a6babe0$exports.emit.apply($3ce9c2508a6babe0$exports, arguments);
                        };
                        else {
                            if (!util.global) return function() {
                                return false;
                            };
                            return function(name) {
                                var methodName = "on" + name.toLowerCase();
                                var method = util.global[methodName];
                                if (!method) return false;
                                method.apply(util.global, [].slice.call(arguments, 1));
                                return true;
                            };
                        }
                    }();
                    function generatePromiseLifecycleEventObject(name, promise) {
                        return {
                            promise: promise
                        };
                    }
                    var eventToObjectGenerator = {
                        promiseCreated: generatePromiseLifecycleEventObject,
                        promiseFulfilled: generatePromiseLifecycleEventObject,
                        promiseRejected: generatePromiseLifecycleEventObject,
                        promiseResolved: generatePromiseLifecycleEventObject,
                        promiseCancelled: generatePromiseLifecycleEventObject,
                        promiseChained: function promiseChained(name, promise, child) {
                            return {
                                promise: promise,
                                child: child
                            };
                        },
                        warning: function warning(name, warning) {
                            return {
                                warning: warning
                            };
                        },
                        unhandledRejection: function unhandledRejection(name, reason, promise) {
                            return {
                                reason: reason,
                                promise: promise
                            };
                        },
                        rejectionHandled: generatePromiseLifecycleEventObject
                    };
                    var activeFireEvent = function activeFireEvent(name) {
                        var globalEventFired = false;
                        try {
                            globalEventFired = fireGlobalEvent.apply(null, arguments);
                        } catch (e) {
                            async.throwLater(e);
                            globalEventFired = true;
                        }
                        var domEventFired = false;
                        try {
                            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
                        } catch (e) {
                            async.throwLater(e);
                            domEventFired = true;
                        }
                        return domEventFired || globalEventFired;
                    };
                    Promise1.config = function(opts) {
                        opts = Object(opts);
                        if ("longStackTraces" in opts) {
                            if (opts.longStackTraces) Promise1.longStackTraces();
                            else if (!opts.longStackTraces && Promise1.hasLongStackTraces()) disableLongStackTraces();
                        }
                        if ("warnings" in opts) {
                            var warningsOption = opts.warnings;
                            config.warnings = !!warningsOption;
                            wForgottenReturn = config.warnings;
                            if (util.isObject(warningsOption)) {
                                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
                            }
                        }
                        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                            Promise1.prototype._clearCancellationData = cancellationClearCancellationData;
                            Promise1.prototype._propagateFrom = cancellationPropagateFrom;
                            Promise1.prototype._onCancel = cancellationOnCancel;
                            Promise1.prototype._setOnCancel = cancellationSetOnCancel;
                            Promise1.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                            Promise1.prototype._execute = cancellationExecute;
                            propagateFromFunction = cancellationPropagateFrom;
                            config.cancellation = true;
                        }
                        if ("monitoring" in opts) {
                            if (opts.monitoring && !config.monitoring) {
                                config.monitoring = true;
                                Promise1.prototype._fireEvent = activeFireEvent;
                            } else if (!opts.monitoring && config.monitoring) {
                                config.monitoring = false;
                                Promise1.prototype._fireEvent = defaultFireEvent;
                            }
                        }
                        if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                            var prev = config.asyncHooks;
                            var cur = !!opts.asyncHooks;
                            if (prev !== cur) {
                                config.asyncHooks = cur;
                                if (cur) enableAsyncHooks();
                                else disableAsyncHooks();
                            }
                        }
                        return Promise1;
                    };
                    function defaultFireEvent() {
                        return false;
                    }
                    Promise1.prototype._fireEvent = defaultFireEvent;
                    Promise1.prototype._execute = function(executor, resolve, reject) {
                        try {
                            executor(resolve, reject);
                        } catch (e) {
                            return e;
                        }
                    };
                    Promise1.prototype._onCancel = function() {};
                    Promise1.prototype._setOnCancel = function(handler) {};
                    Promise1.prototype._attachCancellationCallback = function(onCancel) {};
                    Promise1.prototype._captureStackTrace = function() {};
                    Promise1.prototype._attachExtraTrace = function() {};
                    Promise1.prototype._dereferenceTrace = function() {};
                    Promise1.prototype._clearCancellationData = function() {};
                    Promise1.prototype._propagateFrom = function(parent, flags) {};
                    function cancellationExecute(executor, resolve, reject) {
                        var promise = this;
                        try {
                            executor(resolve, reject, function(onCancel) {
                                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                                promise._attachCancellationCallback(onCancel);
                            });
                        } catch (e) {
                            return e;
                        }
                    }
                    function cancellationAttachCancellationCallback(onCancel) {
                        if (!this._isCancellable()) return this;
                        var previousOnCancel = this._onCancel();
                        if (previousOnCancel !== undefined) {
                            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
                            else this._setOnCancel([
                                previousOnCancel,
                                onCancel
                            ]);
                        } else this._setOnCancel(onCancel);
                    }
                    function cancellationOnCancel() {
                        return this._onCancelField;
                    }
                    function cancellationSetOnCancel(onCancel) {
                        this._onCancelField = onCancel;
                    }
                    function cancellationClearCancellationData() {
                        this._cancellationParent = undefined;
                        this._onCancelField = undefined;
                    }
                    function cancellationPropagateFrom(parent, flags) {
                        if ((flags & 1) !== 0) {
                            this._cancellationParent = parent;
                            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
                            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
                            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
                        }
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    function bindingPropagateFrom(parent, flags) {
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    var propagateFromFunction = bindingPropagateFrom;
                    function boundValueFunction() {
                        var ret = this._boundTo;
                        if (ret !== undefined) {
                            if (ret instanceof Promise1) {
                                if (ret.isFulfilled()) return ret.value();
                                else return undefined;
                            }
                        }
                        return ret;
                    }
                    function longStackTracesCaptureStackTrace() {
                        this._trace = new CapturedTrace(this._peekContext());
                    }
                    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
                        if (canAttachTrace(error)) {
                            var trace = this._trace;
                            if (trace !== undefined) {
                                if (ignoreSelf) trace = trace._parent;
                            }
                            if (trace !== undefined) trace.attachExtraTrace(error);
                            else if (!error.__stackCleaned__) {
                                var parsed = parseStackAndMessage(error);
                                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                                util.notEnumerableProp(error, "__stackCleaned__", true);
                            }
                        }
                    }
                    function longStackTracesDereferenceTrace() {
                        this._trace = undefined;
                    }
                    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
                        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                            if (parent !== undefined && parent._returnedNonUndefined()) return;
                            if ((promise._bitField & 65535) === 0) return;
                            if (name) name = name + " ";
                            var handlerLine = "";
                            var creatorLine = "";
                            if (promiseCreated._trace) {
                                var traceLines = promiseCreated._trace.stack.split("\n");
                                var stack = cleanStack(traceLines);
                                for(var i = stack.length - 1; i >= 0; --i){
                                    var line = stack[i];
                                    if (!nodeFramePattern.test(line)) {
                                        var lineMatches = line.match(parseLinePattern);
                                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                                        break;
                                    }
                                }
                                if (stack.length > 0) {
                                    var firstUserLine = stack[0];
                                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                                        break;
                                    }
                                }
                            }
                            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
                            promise._warn(msg, true, promiseCreated);
                        }
                    }
                    function deprecated(name, replacement) {
                        var message = name + " is deprecated and will be removed in a future version.";
                        if (replacement) message += " Use " + replacement + " instead.";
                        return warn(message);
                    }
                    function warn(message, shouldUseOwnTrace, promise) {
                        if (!config.warnings) return;
                        var warning = new Warning(message);
                        var ctx;
                        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
                        else if (config.longStackTraces && (ctx = Promise1._peekContext())) ctx.attachExtraTrace(warning);
                        else {
                            var parsed = parseStackAndMessage(warning);
                            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
                        }
                        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
                    }
                    function reconstructStack(message, stacks) {
                        for(var i = 0; i < stacks.length - 1; ++i){
                            stacks[i].push("From previous event:");
                            stacks[i] = stacks[i].join("\n");
                        }
                        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
                        return message + "\n" + stacks.join("\n");
                    }
                    function removeDuplicateOrEmptyJumps(stacks) {
                        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                            stacks.splice(i, 1);
                            i--;
                        }
                    }
                    function removeCommonRoots(stacks) {
                        var current = stacks[0];
                        for(var i = 1; i < stacks.length; ++i){
                            var prev = stacks[i];
                            var currentLastIndex = current.length - 1;
                            var currentLastLine = current[currentLastIndex];
                            var commonRootMeetPoint = -1;
                            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                                commonRootMeetPoint = j;
                                break;
                            }
                            for(var j = commonRootMeetPoint; j >= 0; --j){
                                var line = prev[j];
                                if (current[currentLastIndex] === line) {
                                    current.pop();
                                    currentLastIndex--;
                                } else break;
                            }
                            current = prev;
                        }
                    }
                    function cleanStack(stack) {
                        var ret = [];
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                            var isInternalFrame = isTraceLine && shouldIgnore(line);
                            if (isTraceLine && !isInternalFrame) {
                                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                                ret.push(line);
                            }
                        }
                        return ret;
                    }
                    function stackFramesAsArray(error) {
                        var stack = error.stack.replace(/\s+$/g, "").split("\n");
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
                        }
                        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
                        return stack;
                    }
                    function parseStackAndMessage(error) {
                        var stack = error.stack;
                        var message = error.toString();
                        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
                            "    (No stack trace)"
                        ];
                        return {
                            message: message,
                            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
                        };
                    }
                    function formatAndLogError(error, title, isSoft) {
                        if (typeof console !== "undefined") {
                            var message;
                            if (util.isObject(error)) {
                                var stack = error.stack;
                                message = title + formatStack(stack, error);
                            } else message = title + String(error);
                            if (typeof printWarning === "function") printWarning(message, isSoft);
                            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
                        }
                    }
                    function fireRejectionEvent(name, localHandler, reason, promise) {
                        var localEventFired = false;
                        try {
                            if (typeof localHandler === "function") {
                                localEventFired = true;
                                if (name === "rejectionHandled") localHandler(promise);
                                else localHandler(reason, promise);
                            }
                        } catch (e) {
                            async.throwLater(e);
                        }
                        if (name === "unhandledRejection") {
                            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
                        } else activeFireEvent(name, promise);
                    }
                    function formatNonError(obj) {
                        var str;
                        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
                        else {
                            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
                            if (ruselessToString.test(str)) try {
                                var newStr = JSON.stringify(obj);
                                str = newStr;
                            } catch (e) {}
                            if (str.length === 0) str = "(empty array)";
                        }
                        return "(<" + snip(str) + ">, no stack trace)";
                    }
                    function snip(str) {
                        var maxChars = 41;
                        if (str.length < maxChars) return str;
                        return str.substr(0, maxChars - 3) + "...";
                    }
                    function longStackTracesIsSupported() {
                        return typeof captureStackTrace === "function";
                    }
                    var shouldIgnore = function shouldIgnore() {
                        return false;
                    };
                    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                    function parseLineInfo(line) {
                        var matches = line.match(parseLineInfoRegex);
                        if (matches) return {
                            fileName: matches[1],
                            line: parseInt(matches[2], 10)
                        };
                    }
                    function setBounds(firstLineError, lastLineError) {
                        if (!longStackTracesIsSupported()) return;
                        var firstStackLines = (firstLineError.stack || "").split("\n");
                        var lastStackLines = (lastLineError.stack || "").split("\n");
                        var firstIndex = -1;
                        var lastIndex = -1;
                        var firstFileName;
                        var lastFileName;
                        for(var i = 0; i < firstStackLines.length; ++i){
                            var result = parseLineInfo(firstStackLines[i]);
                            if (result) {
                                firstFileName = result.fileName;
                                firstIndex = result.line;
                                break;
                            }
                        }
                        for(var i = 0; i < lastStackLines.length; ++i){
                            var result = parseLineInfo(lastStackLines[i]);
                            if (result) {
                                lastFileName = result.fileName;
                                lastIndex = result.line;
                                break;
                            }
                        }
                        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
                        shouldIgnore = function shouldIgnore(line) {
                            if (bluebirdFramePattern.test(line)) return true;
                            var info = parseLineInfo(line);
                            if (info) {
                                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
                            }
                            return false;
                        };
                    }
                    function CapturedTrace(parent) {
                        this._parent = parent;
                        this._promisesCreated = 0;
                        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
                        captureStackTrace(this, CapturedTrace);
                        if (length > 32) this.uncycle();
                    }
                    util.inherits(CapturedTrace, Error);
                    Context.CapturedTrace = CapturedTrace;
                    CapturedTrace.prototype.uncycle = function() {
                        var length = this._length;
                        if (length < 2) return;
                        var nodes = [];
                        var stackToIndex = {};
                        for(var i = 0, node = this; node !== undefined; ++i){
                            nodes.push(node);
                            node = node._parent;
                        }
                        length = this._length = i;
                        for(var i = length - 1; i >= 0; --i){
                            var stack = nodes[i].stack;
                            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
                        }
                        for(var i = 0; i < length; ++i){
                            var currentStack = nodes[i].stack;
                            var index = stackToIndex[currentStack];
                            if (index !== undefined && index !== i) {
                                if (index > 0) {
                                    nodes[index - 1]._parent = undefined;
                                    nodes[index - 1]._length = 1;
                                }
                                nodes[i]._parent = undefined;
                                nodes[i]._length = 1;
                                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                                if (index < length - 1) {
                                    cycleEdgeNode._parent = nodes[index + 1];
                                    cycleEdgeNode._parent.uncycle();
                                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                                } else {
                                    cycleEdgeNode._parent = undefined;
                                    cycleEdgeNode._length = 1;
                                }
                                var currentChildLength = cycleEdgeNode._length + 1;
                                for(var j = i - 2; j >= 0; --j){
                                    nodes[j]._length = currentChildLength;
                                    currentChildLength++;
                                }
                                return;
                            }
                        }
                    };
                    CapturedTrace.prototype.attachExtraTrace = function(error) {
                        if (error.__stackCleaned__) return;
                        this.uncycle();
                        var parsed = parseStackAndMessage(error);
                        var message = parsed.message;
                        var stacks = [
                            parsed.stack
                        ];
                        var trace = this;
                        while(trace !== undefined){
                            stacks.push(cleanStack(trace.stack.split("\n")));
                            trace = trace._parent;
                        }
                        removeCommonRoots(stacks);
                        removeDuplicateOrEmptyJumps(stacks);
                        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
                        util.notEnumerableProp(error, "__stackCleaned__", true);
                    };
                    var captureStackTrace = function stackDetection() {
                        var v8stackFramePattern = /^\s*at\s*/;
                        var v8stackFormatter = function v8stackFormatter(stack, error) {
                            if (typeof stack === "string") return stack;
                            if (error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                            Error.stackTraceLimit += 6;
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            var captureStackTrace = Error.captureStackTrace;
                            shouldIgnore = function shouldIgnore(line) {
                                return bluebirdFramePattern.test(line);
                            };
                            return function(receiver, ignoreUntil) {
                                Error.stackTraceLimit += 6;
                                captureStackTrace(receiver, ignoreUntil);
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        var err = new Error();
                        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                            stackFramePattern = /@/;
                            formatStack = v8stackFormatter;
                            indentStackFrames = true;
                            return function captureStackTrace(o) {
                                o.stack = new Error().stack;
                            };
                        }
                        var hasStackAfterThrow;
                        try {
                            throw new Error();
                        } catch (e) {
                            hasStackAfterThrow = "stack" in e;
                        }
                        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            return function captureStackTrace(o) {
                                Error.stackTraceLimit += 6;
                                try {
                                    throw new Error();
                                } catch (e) {
                                    o.stack = e.stack;
                                }
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        formatStack = function formatStack(stack, error) {
                            if (typeof stack === "string") return stack;
                            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        return null;
                    }([]);
                    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                        printWarning = function printWarning(message) {
                            console.warn(message);
                        };
                        if (util.isNode && $3ce9c2508a6babe0$exports.stderr.isTTY) printWarning = function printWarning(message, isSoft) {
                            var color = isSoft ? "\x1b[33m" : "\x1b[31m";
                            console.warn(color + message + "\x1b[0m\n");
                        };
                        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function printWarning(message, isSoft) {
                            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                        };
                    }
                    var config = {
                        warnings: warnings,
                        longStackTraces: false,
                        cancellation: false,
                        monitoring: false,
                        asyncHooks: false
                    };
                    if (longStackTraces) Promise1.longStackTraces();
                    return {
                        asyncHooks: function asyncHooks() {
                            return config.asyncHooks;
                        },
                        longStackTraces: function longStackTraces() {
                            return config.longStackTraces;
                        },
                        warnings: function warnings() {
                            return config.warnings;
                        },
                        cancellation: function cancellation() {
                            return config.cancellation;
                        },
                        monitoring: function monitoring() {
                            return config.monitoring;
                        },
                        propagateFromFunction: function propagateFromFunction1() {
                            return propagateFromFunction;
                        },
                        boundValueFunction: function boundValueFunction1() {
                            return boundValueFunction;
                        },
                        checkForgottenReturns: checkForgottenReturns,
                        setBounds: setBounds,
                        warn: warn,
                        deprecated: deprecated,
                        CapturedTrace: CapturedTrace,
                        fireDomEvent: fireDomEvent,
                        fireGlobalEvent: fireGlobalEvent
                    };
                };
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        10: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function returner() {
                        return this.value;
                    }
                    function thrower() {
                        throw this.reason;
                    }
                    Promise1.prototype["return"] = Promise1.prototype.thenReturn = function(value) {
                        if (value instanceof Promise1) value.suppressUnhandledRejections();
                        return this._then(returner, undefined, undefined, {
                            value: value
                        }, undefined);
                    };
                    Promise1.prototype["throw"] = Promise1.prototype.thenThrow = function(reason) {
                        return this._then(thrower, undefined, undefined, {
                            reason: reason
                        }, undefined);
                    };
                    Promise1.prototype.catchThrow = function(reason) {
                        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
                            reason: reason
                        }, undefined);
                        else {
                            var _reason = arguments[1];
                            var handler = function handler() {
                                throw _reason;
                            };
                            return this.caught(reason, handler);
                        }
                    };
                    Promise1.prototype.catchReturn = function(value) {
                        if (arguments.length <= 1) {
                            if (value instanceof Promise1) value.suppressUnhandledRejections();
                            return this._then(undefined, returner, undefined, {
                                value: value
                            }, undefined);
                        } else {
                            var _value = arguments[1];
                            if (_value instanceof Promise1) _value.suppressUnhandledRejections();
                            var handler = function handler() {
                                return _value;
                            };
                            return this.caught(value, handler);
                        }
                    };
                };
            },
            {}
        ],
        11: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseReduce = Promise1.reduce;
                    var PromiseAll = Promise1.all;
                    function promiseAllThis() {
                        return PromiseAll(this);
                    }
                    function PromiseMapSeries(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
                    }
                    Promise1.prototype.each = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
                    };
                    Promise1.prototype.mapSeries = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
                    };
                    Promise1.each = function(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
                    };
                    Promise1.mapSeries = PromiseMapSeries;
                };
            },
            {}
        ],
        12: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var Objectfreeze = es5.freeze;
                var util = _dereq_1("./util");
                var inherits = util.inherits;
                var notEnumerableProp = util.notEnumerableProp;
                function subError(nameProperty, defaultMessage) {
                    function SubError(message) {
                        if (!(this instanceof SubError)) return new SubError(message);
                        notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
                        notEnumerableProp(this, "name", nameProperty);
                        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        else Error.call(this);
                    }
                    inherits(SubError, Error);
                    return SubError;
                }
                var _TypeError, _RangeError;
                var Warning = subError("Warning", "warning");
                var CancellationError = subError("CancellationError", "cancellation error");
                var TimeoutError = subError("TimeoutError", "timeout error");
                var AggregateError = subError("AggregateError", "aggregate error");
                try {
                    _TypeError = TypeError;
                    _RangeError = RangeError;
                } catch (e) {
                    _TypeError = subError("TypeError", "type error");
                    _RangeError = subError("RangeError", "range error");
                }
                var methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
                for(var i = 0; i < methods.length; ++i)if (typeof Array.prototype[methods[i]] === "function") AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
                es5.defineProperty(AggregateError.prototype, "length", {
                    value: 0,
                    configurable: false,
                    writable: true,
                    enumerable: true
                });
                AggregateError.prototype["isOperational"] = true;
                var level = 0;
                AggregateError.prototype.toString = function() {
                    var indent = Array(level * 4 + 1).join(" ");
                    var ret = "\n" + indent + "AggregateError of:" + "\n";
                    level++;
                    indent = Array(level * 4 + 1).join(" ");
                    for(var i = 0; i < this.length; ++i){
                        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
                        var lines = str.split("\n");
                        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
                        str = lines.join("\n");
                        ret += str + "\n";
                    }
                    level--;
                    return ret;
                };
                function OperationalError(message) {
                    if (!(this instanceof OperationalError)) return new OperationalError(message);
                    notEnumerableProp(this, "name", "OperationalError");
                    notEnumerableProp(this, "message", message);
                    this.cause = message;
                    this["isOperational"] = true;
                    if (message instanceof Error) {
                        notEnumerableProp(this, "message", message.message);
                        notEnumerableProp(this, "stack", message.stack);
                    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                }
                inherits(OperationalError, Error);
                var errorTypes = Error["__BluebirdErrorTypes__"];
                if (!errorTypes) {
                    errorTypes = Objectfreeze({
                        CancellationError: CancellationError,
                        TimeoutError: TimeoutError,
                        OperationalError: OperationalError,
                        RejectionError: OperationalError,
                        AggregateError: AggregateError
                    });
                    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
                        value: errorTypes,
                        writable: false,
                        enumerable: false,
                        configurable: false
                    });
                }
                module1.exports = {
                    Error: Error,
                    TypeError: _TypeError,
                    RangeError: _RangeError,
                    CancellationError: errorTypes.CancellationError,
                    OperationalError: errorTypes.OperationalError,
                    TimeoutError: errorTypes.TimeoutError,
                    AggregateError: errorTypes.AggregateError,
                    Warning: Warning
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        13: [
            function(_dereq_1, module1, exports) {
                var isES5 = function() {
                    "use strict";
                    return this === undefined;
                }();
                if (isES5) module1.exports = {
                    freeze: Object.freeze,
                    defineProperty: Object.defineProperty,
                    getDescriptor: Object.getOwnPropertyDescriptor,
                    keys: Object.keys,
                    names: Object.getOwnPropertyNames,
                    getPrototypeOf: Object.getPrototypeOf,
                    isArray: Array.isArray,
                    isES5: isES5,
                    propertyIsWritable: function propertyIsWritable(obj, prop) {
                        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                        return !!(!descriptor || descriptor.writable || descriptor.set);
                    }
                };
                else {
                    var has = {}.hasOwnProperty;
                    var str = {}.toString;
                    var proto = {}.constructor.prototype;
                    var ObjectKeys = function ObjectKeys(o) {
                        var ret = [];
                        for(var key in o)if (has.call(o, key)) ret.push(key);
                        return ret;
                    };
                    var ObjectGetDescriptor = function ObjectGetDescriptor(o, key) {
                        return {
                            value: o[key]
                        };
                    };
                    var ObjectDefineProperty = function ObjectDefineProperty(o, key, desc) {
                        o[key] = desc.value;
                        return o;
                    };
                    var ObjectFreeze = function ObjectFreeze(obj) {
                        return obj;
                    };
                    var ObjectGetPrototypeOf = function ObjectGetPrototypeOf(obj) {
                        try {
                            return Object(obj).constructor.prototype;
                        } catch (e) {
                            return proto;
                        }
                    };
                    var ArrayIsArray = function ArrayIsArray(obj) {
                        try {
                            return str.call(obj) === "[object Array]";
                        } catch (e) {
                            return false;
                        }
                    };
                    module1.exports = {
                        isArray: ArrayIsArray,
                        keys: ObjectKeys,
                        names: ObjectKeys,
                        defineProperty: ObjectDefineProperty,
                        getDescriptor: ObjectGetDescriptor,
                        freeze: ObjectFreeze,
                        getPrototypeOf: ObjectGetPrototypeOf,
                        isES5: isES5,
                        propertyIsWritable: function propertyIsWritable() {
                            return true;
                        }
                    };
                }
            },
            {}
        ],
        14: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseMap = Promise1.map;
                    Promise1.prototype.filter = function(fn, options) {
                        return PromiseMap(this, fn, options, INTERNAL);
                    };
                    Promise1.filter = function(promises, fn, options) {
                        return PromiseMap(promises, fn, options, INTERNAL);
                    };
                };
            },
            {}
        ],
        15: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, tryConvertToPromise, NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var CancellationError = Promise1.CancellationError;
                    var errorObj = util.errorObj;
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    function PassThroughHandlerContext(promise, type, handler) {
                        this.promise = promise;
                        this.type = type;
                        this.handler = handler;
                        this.called = false;
                        this.cancelPromise = null;
                    }
                    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
                        return this.type === 0;
                    };
                    function FinallyHandlerCancelReaction(finallyHandler) {
                        this.finallyHandler = finallyHandler;
                    }
                    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
                        checkCancel(this.finallyHandler);
                    };
                    function checkCancel(ctx, reason) {
                        if (ctx.cancelPromise != null) {
                            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
                            else ctx.cancelPromise._cancel();
                            ctx.cancelPromise = null;
                            return true;
                        }
                        return false;
                    }
                    function succeed() {
                        return finallyHandler.call(this, this.promise._target()._settledValue());
                    }
                    function fail(reason) {
                        if (checkCancel(this, reason)) return;
                        errorObj.e = reason;
                        return errorObj;
                    }
                    function finallyHandler(reasonOrValue) {
                        var promise = this.promise;
                        var handler = this.handler;
                        if (!this.called) {
                            this.called = true;
                            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
                            if (ret === NEXT_FILTER) return ret;
                            else if (ret !== undefined) {
                                promise._setReturnedNonUndefined();
                                var maybePromise = tryConvertToPromise(ret, promise);
                                if (maybePromise instanceof Promise1) {
                                    if (this.cancelPromise != null) {
                                        if (maybePromise._isCancelled()) {
                                            var reason = new CancellationError("late cancellation observer");
                                            promise._attachExtraTrace(reason);
                                            errorObj.e = reason;
                                            return errorObj;
                                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                                    }
                                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                                }
                            }
                        }
                        if (promise.isRejected()) {
                            checkCancel(this);
                            errorObj.e = reasonOrValue;
                            return errorObj;
                        } else {
                            checkCancel(this);
                            return reasonOrValue;
                        }
                    }
                    Promise1.prototype._passThrough = function(handler, type, success, fail) {
                        if (typeof handler !== "function") return this.then();
                        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
                    };
                    Promise1.prototype.lastly = Promise1.prototype["finally"] = function(handler) {
                        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
                    };
                    Promise1.prototype.tap = function(handler) {
                        return this._passThrough(handler, 1, finallyHandler);
                    };
                    Promise1.prototype.tapCatch = function(handlerOrPredicate) {
                        var len = arguments.length;
                        if (len === 1) return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
                        else {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return Promise1.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + util.classString(item)));
                            }
                            catchInstances.length = j;
                            var handler = arguments[i];
                            return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
                        }
                    };
                    return PassThroughHandlerContext;
                };
            },
            {
                "./catch_filter": 7,
                "./util": 36
            }
        ],
        16: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
                    var errors = _dereq_1("./errors");
                    var TypeError1 = errors.TypeError;
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var yieldHandlers = [];
                    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
                        for(var i = 0; i < yieldHandlers.length; ++i){
                            traceParent._pushContext();
                            var result = tryCatch(yieldHandlers[i])(value);
                            traceParent._popContext();
                            if (result === errorObj) {
                                traceParent._pushContext();
                                var ret = Promise1.reject(errorObj.e);
                                traceParent._popContext();
                                return ret;
                            }
                            var maybePromise = tryConvertToPromise(result, traceParent);
                            if (maybePromise instanceof Promise1) return maybePromise;
                        }
                        return null;
                    }
                    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
                        if (debug.cancellation()) {
                            var internal = new Promise1(INTERNAL);
                            var _finallyPromise = this._finallyPromise = new Promise1(INTERNAL);
                            this._promise = internal.lastly(function() {
                                return _finallyPromise;
                            });
                            internal._captureStackTrace();
                            internal._setOnCancel(this);
                        } else {
                            var promise = this._promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                        }
                        this._stack = stack;
                        this._generatorFunction = generatorFunction;
                        this._receiver = receiver;
                        this._generator = undefined;
                        this._yieldHandlers = typeof yieldHandler === "function" ? [
                            yieldHandler
                        ].concat(yieldHandlers) : yieldHandlers;
                        this._yieldedPromise = null;
                        this._cancellationPhase = false;
                    }
                    util.inherits(PromiseSpawn, Proxyable);
                    PromiseSpawn.prototype._isResolved = function() {
                        return this._promise === null;
                    };
                    PromiseSpawn.prototype._cleanup = function() {
                        this._promise = this._generator = null;
                        if (debug.cancellation() && this._finallyPromise !== null) {
                            this._finallyPromise._fulfill();
                            this._finallyPromise = null;
                        }
                    };
                    PromiseSpawn.prototype._promiseCancelled = function() {
                        if (this._isResolved()) return;
                        var implementsReturn = typeof this._generator["return"] !== "undefined";
                        var result;
                        if (!implementsReturn) {
                            var reason = new Promise1.CancellationError("generator .return() sentinel");
                            Promise1.coroutine.returnSentinel = reason;
                            this._promise._attachExtraTrace(reason);
                            this._promise._pushContext();
                            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                            this._promise._popContext();
                        } else {
                            this._promise._pushContext();
                            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
                            this._promise._popContext();
                        }
                        this._cancellationPhase = true;
                        this._yieldedPromise = null;
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseFulfilled = function(value) {
                        this._yieldedPromise = null;
                        this._promise._pushContext();
                        var result = tryCatch(this._generator.next).call(this._generator, value);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseRejected = function(reason) {
                        this._yieldedPromise = null;
                        this._promise._attachExtraTrace(reason);
                        this._promise._pushContext();
                        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._resultCancelled = function() {
                        if (this._yieldedPromise instanceof Promise1) {
                            var promise = this._yieldedPromise;
                            this._yieldedPromise = null;
                            promise.cancel();
                        }
                    };
                    PromiseSpawn.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseSpawn.prototype._run = function() {
                        this._generator = this._generatorFunction.call(this._receiver);
                        this._receiver = this._generatorFunction = undefined;
                        this._promiseFulfilled(undefined);
                    };
                    PromiseSpawn.prototype._continue = function(result) {
                        var promise = this._promise;
                        if (result === errorObj) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._rejectCallback(result.e, false);
                        }
                        var value = result.value;
                        if (result.done === true) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._resolveCallback(value);
                        } else {
                            var maybePromise = tryConvertToPromise(value, this._promise);
                            if (!(maybePromise instanceof Promise1)) {
                                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                                if (maybePromise === null) {
                                    this._promiseRejected(new TypeError1("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));
                                    return;
                                }
                            }
                            maybePromise = maybePromise._target();
                            var bitField = maybePromise._bitField;
                            if ((bitField & 50397184) === 0) {
                                this._yieldedPromise = maybePromise;
                                maybePromise._proxy(this, null);
                            } else if ((bitField & 33554432) !== 0) Promise1._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                            else if ((bitField & 16777216) !== 0) Promise1._async.invoke(this._promiseRejected, this, maybePromise._reason());
                            else this._promiseCancelled();
                        }
                    };
                    Promise1.coroutine = function(generatorFunction, options) {
                        if (typeof generatorFunction !== "function") throw new TypeError1("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                        var yieldHandler = Object(options).yieldHandler;
                        var PromiseSpawn$ = PromiseSpawn;
                        var stack = new Error().stack;
                        return function() {
                            var generator = generatorFunction.apply(this, arguments);
                            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                            var ret = spawn.promise();
                            spawn._generator = generator;
                            spawn._promiseFulfilled(undefined);
                            return ret;
                        };
                    };
                    Promise1.coroutine.addYieldHandler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        yieldHandlers.push(fn);
                    };
                    Promise1.spawn = function(generatorFunction) {
                        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
                        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
                        var spawn = new PromiseSpawn(generatorFunction, this);
                        var ret = spawn.promise();
                        spawn._run(Promise1.spawn);
                        return ret;
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        17: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var reject;
                    var thenCallback, promiseSetter, generateHolderClass, holderClasses, thenCallbacks, promiseSetters, i;
                    Promise1.join = function() {
                        var last = arguments.length - 1;
                        var fn;
                        if (last > 0 && typeof arguments[last] === "function") {
                            fn = arguments[last];
                            var ret, HolderClass, holder, callbacks, i, maybePromise, bitField, context;
                        }
                        var args = [].slice.call(arguments);
                        if (fn) args.pop();
                        var ret = new PromiseArray(args).promise();
                        return fn !== undefined ? ret.spread(fn) : ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        18: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    function MappingPromiseArray(promises, fn, limit, _filter) {
                        this.constructor$(promises);
                        this._promise._captureStackTrace();
                        var context = Promise1._getContext();
                        this._callback = util.contextBind(context, fn);
                        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
                        this._limit = limit;
                        this._inFlight = 0;
                        this._queue = [];
                        async.invoke(this._asyncInit, this, undefined);
                        if (util.isArray(promises)) for(var i = 0; i < promises.length; ++i){
                            var maybePromise = promises[i];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                    }
                    util.inherits(MappingPromiseArray, PromiseArray);
                    MappingPromiseArray.prototype._asyncInit = function() {
                        this._init$(undefined, -2);
                    };
                    MappingPromiseArray.prototype._init = function() {};
                    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var values = this._values;
                        var length = this.length();
                        var preservedValues = this._preservedValues;
                        var limit = this._limit;
                        if (index < 0) {
                            index = index * -1 - 1;
                            values[index] = value;
                            if (limit >= 1) {
                                this._inFlight--;
                                this._drainQueue();
                                if (this._isResolved()) return true;
                            }
                        } else {
                            if (limit >= 1 && this._inFlight >= limit) {
                                values[index] = value;
                                this._queue.push(index);
                                return false;
                            }
                            if (preservedValues !== null) preservedValues[index] = value;
                            var promise = this._promise;
                            var callback = this._callback;
                            var receiver = promise._boundValue();
                            promise._pushContext();
                            var ret = tryCatch(callback).call(receiver, value, index, length);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
                            if (ret === errorObj) {
                                this._reject(ret.e);
                                return true;
                            }
                            var maybePromise = tryConvertToPromise(ret, this._promise);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                var bitField = maybePromise._bitField;
                                if ((bitField & 50397184) === 0) {
                                    if (limit >= 1) this._inFlight++;
                                    values[index] = maybePromise;
                                    maybePromise._proxy(this, (index + 1) * -1);
                                    return false;
                                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                                else if ((bitField & 16777216) !== 0) {
                                    this._reject(maybePromise._reason());
                                    return true;
                                } else {
                                    this._cancel();
                                    return true;
                                }
                            }
                            values[index] = ret;
                        }
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= length) {
                            if (preservedValues !== null) this._filter(values, preservedValues);
                            else this._resolve(values);
                            return true;
                        }
                        return false;
                    };
                    MappingPromiseArray.prototype._drainQueue = function() {
                        var queue = this._queue;
                        var limit = this._limit;
                        var values = this._values;
                        while(queue.length > 0 && this._inFlight < limit){
                            if (this._isResolved()) return;
                            var index = queue.pop();
                            this._promiseFulfilled(values[index], index);
                        }
                    };
                    MappingPromiseArray.prototype._filter = function(booleans, values) {
                        var len = values.length;
                        var ret = new Array(len);
                        var j = 0;
                        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
                        ret.length = j;
                        this._resolve(ret);
                    };
                    MappingPromiseArray.prototype.preservedValues = function() {
                        return this._preservedValues;
                    };
                    function map(promises, fn, options, _filter) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var limit = 0;
                        if (options !== undefined) {
                            if (typeof options === "object" && options !== null) {
                                if (typeof options.concurrency !== "number") return Promise1.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                                limit = options.concurrency;
                            } else return Promise1.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                        }
                        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
                        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
                    }
                    Promise1.prototype.map = function(fn, options) {
                        return map(this, fn, options, null);
                    };
                    Promise1.map = function(promises, fn, options, _filter) {
                        return map(promises, fn, options, _filter);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        19: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    Promise1.method = function(fn) {
                        if (typeof fn !== "function") throw new Promise1.TypeError("expecting a function but got " + util.classString(fn));
                        return function() {
                            var ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._pushContext();
                            var value = tryCatch(fn).apply(this, arguments);
                            var promiseCreated = ret._popContext();
                            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
                            ret._resolveFromSyncValue(value);
                            return ret;
                        };
                    };
                    Promise1.attempt = Promise1["try"] = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._pushContext();
                        var value;
                        if (arguments.length > 1) {
                            debug.deprecated("calling Promise.try with more than 1 argument");
                            var arg = arguments[1];
                            var ctx = arguments[2];
                            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
                        } else value = tryCatch(fn)();
                        var promiseCreated = ret._popContext();
                        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
                        ret._resolveFromSyncValue(value);
                        return ret;
                    };
                    Promise1.prototype._resolveFromSyncValue = function(value) {
                        if (value === util.errorObj) this._rejectCallback(value.e, false);
                        else this._resolveCallback(value, true);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        20: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var maybeWrapAsError = util.maybeWrapAsError;
                var errors = _dereq_1("./errors");
                var OperationalError = errors.OperationalError;
                var es5 = _dereq_1("./es5");
                function isUntypedError(obj) {
                    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
                }
                var rErrorKey = /^(?:name|message|stack|cause)$/;
                function wrapAsOperationalError(obj) {
                    var ret;
                    if (isUntypedError(obj)) {
                        ret = new OperationalError(obj);
                        ret.name = obj.name;
                        ret.message = obj.message;
                        ret.stack = obj.stack;
                        var keys = es5.keys(obj);
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            if (!rErrorKey.test(key)) ret[key] = obj[key];
                        }
                        return ret;
                    }
                    util.markAsOriginatingFromRejection(obj);
                    return obj;
                }
                function nodebackForPromise(promise, multiArgs) {
                    return function(err, value) {
                        if (promise === null) return;
                        if (err) {
                            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
                            promise._attachExtraTrace(wrapped);
                            promise._reject(wrapped);
                        } else if (!multiArgs) promise._fulfill(value);
                        else {
                            var args = [].slice.call(arguments, 1);
                            promise._fulfill(args);
                        }
                        promise = null;
                    };
                }
                module1.exports = nodebackForPromise;
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        21: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var async = Promise1._async;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function spreadAdapter(val, nodeback) {
                        var promise = this;
                        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
                        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
                            null
                        ].concat(val));
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function successAdapter(val, nodeback) {
                        var promise = this;
                        var receiver = promise._boundValue();
                        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function errorAdapter(reason, nodeback) {
                        var promise = this;
                        if (!reason) {
                            var newReason = new Error(reason + "");
                            newReason.cause = reason;
                            reason = newReason;
                        }
                        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    Promise1.prototype.asCallback = Promise1.prototype.nodeify = function(nodeback, options) {
                        if (typeof nodeback == "function") {
                            var adapter = successAdapter;
                            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
                            this._then(adapter, errorAdapter, undefined, this, nodeback);
                        }
                        return this;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        22: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function() {
                    var makeSelfResolutionError = function makeSelfResolutionError() {
                        return new TypeError1("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
                    };
                    var reflectHandler = function reflectHandler() {
                        return new Promise1.PromiseInspection(this._target());
                    };
                    var apiRejection = function apiRejection(msg) {
                        return Promise1.reject(new TypeError1(msg));
                    };
                    function Proxyable() {}
                    var UNDEFINED_BINDING = {};
                    var util = _dereq_1("./util");
                    util.setReflectHandler(reflectHandler);
                    var getDomain = function getDomain() {
                        var domain = $3ce9c2508a6babe0$exports.domain;
                        if (domain === undefined) return null;
                        return domain;
                    };
                    var getContextDefault = function getContextDefault() {
                        return null;
                    };
                    var getContextDomain = function getContextDomain() {
                        return {
                            domain: getDomain(),
                            async: null
                        };
                    };
                    var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_1("async_hooks").AsyncResource : null;
                    var getContextAsyncHooks = function getContextAsyncHooks() {
                        return {
                            domain: getDomain(),
                            async: new AsyncResource("Bluebird::Promise")
                        };
                    };
                    var getContext = util.isNode ? getContextDomain : getContextDefault;
                    util.notEnumerableProp(Promise1, "_getContext", getContext);
                    var enableAsyncHooks = function enableAsyncHooks() {
                        getContext = getContextAsyncHooks;
                        util.notEnumerableProp(Promise1, "_getContext", getContextAsyncHooks);
                    };
                    var disableAsyncHooks = function disableAsyncHooks() {
                        getContext = getContextDomain;
                        util.notEnumerableProp(Promise1, "_getContext", getContextDomain);
                    };
                    var es5 = _dereq_1("./es5");
                    var Async = _dereq_1("./async");
                    var async = new Async();
                    es5.defineProperty(Promise1, "_async", {
                        value: async
                    });
                    var errors = _dereq_1("./errors");
                    var TypeError1 = Promise1.TypeError = errors.TypeError;
                    Promise1.RangeError = errors.RangeError;
                    var CancellationError = Promise1.CancellationError = errors.CancellationError;
                    Promise1.TimeoutError = errors.TimeoutError;
                    Promise1.OperationalError = errors.OperationalError;
                    Promise1.RejectionError = errors.OperationalError;
                    Promise1.AggregateError = errors.AggregateError;
                    var INTERNAL = function INTERNAL() {};
                    var APPLY = {};
                    var NEXT_FILTER = {};
                    var tryConvertToPromise = _dereq_1("./thenables")(Promise1, INTERNAL);
                    var PromiseArray = _dereq_1("./promise_array")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
                    var Context = _dereq_1("./context")(Promise1);
                    /*jshint unused:false*/ var createContext = Context.create;
                    var debug = _dereq_1("./debuggability")(Promise1, Context, enableAsyncHooks, disableAsyncHooks);
                    var CapturedTrace = debug.CapturedTrace;
                    var PassThroughHandlerContext = _dereq_1("./finally")(Promise1, tryConvertToPromise, NEXT_FILTER);
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    function check(self1, executor) {
                        if (self1 == null || self1.constructor !== Promise1) throw new TypeError1("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
                        if (typeof executor !== "function") throw new TypeError1("expecting a function but got " + util.classString(executor));
                    }
                    function Promise1(executor) {
                        if (executor !== INTERNAL) check(this, executor);
                        this._bitField = 0;
                        this._fulfillmentHandler0 = undefined;
                        this._rejectionHandler0 = undefined;
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._resolveFromExecutor(executor);
                        this._promiseCreated();
                        this._fireEvent("promiseCreated", this);
                    }
                    Promise1.prototype.toString = function() {
                        return "[object Promise]";
                    };
                    Promise1.prototype.caught = Promise1.prototype["catch"] = function(fn) {
                        var len = arguments.length;
                        if (len > 1) {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return apiRejection("Catch statement predicate: expecting an object but got " + util.classString(item));
                            }
                            catchInstances.length = j;
                            fn = arguments[i];
                            if (typeof fn !== "function") throw new TypeError1("The last argument to .catch() must be a function, got " + util.toString(fn));
                            return this.then(undefined, catchFilter(catchInstances, fn, this));
                        }
                        return this.then(undefined, fn);
                    };
                    Promise1.prototype.reflect = function() {
                        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
                    };
                    Promise1.prototype.then = function(didFulfill, didReject) {
                        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
                            if (arguments.length > 1) msg += ", " + util.classString(didReject);
                            this._warn(msg);
                        }
                        return this._then(didFulfill, didReject, undefined, undefined, undefined);
                    };
                    Promise1.prototype.done = function(didFulfill, didReject) {
                        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
                        promise._setIsFinal();
                    };
                    Promise1.prototype.spread = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
                    };
                    Promise1.prototype.toJSON = function() {
                        var ret = {
                            isFulfilled: false,
                            isRejected: false,
                            fulfillmentValue: undefined,
                            rejectionReason: undefined
                        };
                        if (this.isFulfilled()) {
                            ret.fulfillmentValue = this.value();
                            ret.isFulfilled = true;
                        } else if (this.isRejected()) {
                            ret.rejectionReason = this.reason();
                            ret.isRejected = true;
                        }
                        return ret;
                    };
                    Promise1.prototype.all = function() {
                        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
                        return new PromiseArray(this).promise();
                    };
                    Promise1.prototype.error = function(fn) {
                        return this.caught(util.originatesFromRejection, fn);
                    };
                    Promise1.getNewLibraryCopy = module1.exports;
                    Promise1.is = function(val) {
                        return val instanceof Promise1;
                    };
                    Promise1.fromNode = Promise1.fromCallback = function(fn) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
                        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
                        if (result === errorObj) ret._rejectCallback(result.e, true);
                        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.all = function(promises) {
                        return new PromiseArray(promises).promise();
                    };
                    Promise1.cast = function(obj) {
                        var ret = tryConvertToPromise(obj);
                        if (!(ret instanceof Promise1)) {
                            ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._setFulfilled();
                            ret._rejectionHandler0 = obj;
                        }
                        return ret;
                    };
                    Promise1.resolve = Promise1.fulfilled = Promise1.cast;
                    Promise1.reject = Promise1.rejected = function(reason) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._rejectCallback(reason, true);
                        return ret;
                    };
                    Promise1.setScheduler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        return async.setScheduler(fn);
                    };
                    Promise1.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
                        var haveInternalData = internalData !== undefined;
                        var promise = haveInternalData ? internalData : new Promise1(INTERNAL);
                        var target = this._target();
                        var bitField = target._bitField;
                        if (!haveInternalData) {
                            promise._propagateFrom(this, 3);
                            promise._captureStackTrace();
                            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                                else receiver = target === this ? undefined : this._boundTo;
                            }
                            this._fireEvent("promiseChained", this, promise);
                        }
                        var context = getContext();
                        if (!((bitField & 50397184) === 0)) {
                            var handler, value, settler = target._settlePromiseCtx;
                            if ((bitField & 33554432) !== 0) {
                                value = target._rejectionHandler0;
                                handler = didFulfill;
                            } else if ((bitField & 16777216) !== 0) {
                                value = target._fulfillmentHandler0;
                                handler = didReject;
                                target._unsetRejectionIsUnhandled();
                            } else {
                                settler = target._settlePromiseLateCancellationObserver;
                                value = new CancellationError("late cancellation observer");
                                target._attachExtraTrace(value);
                                handler = didReject;
                            }
                            async.invoke(settler, target, {
                                handler: util.contextBind(context, handler),
                                promise: promise,
                                receiver: receiver,
                                value: value
                            });
                        } else target._addCallbacks(didFulfill, didReject, promise, receiver, context);
                        return promise;
                    };
                    Promise1.prototype._length = function() {
                        return this._bitField & 65535;
                    };
                    Promise1.prototype._isFateSealed = function() {
                        return (this._bitField & 117506048) !== 0;
                    };
                    Promise1.prototype._isFollowing = function() {
                        return (this._bitField & 67108864) === 67108864;
                    };
                    Promise1.prototype._setLength = function(len) {
                        this._bitField = this._bitField & -65536 | len & 65535;
                    };
                    Promise1.prototype._setFulfilled = function() {
                        this._bitField = this._bitField | 33554432;
                        this._fireEvent("promiseFulfilled", this);
                    };
                    Promise1.prototype._setRejected = function() {
                        this._bitField = this._bitField | 16777216;
                        this._fireEvent("promiseRejected", this);
                    };
                    Promise1.prototype._setFollowing = function() {
                        this._bitField = this._bitField | 67108864;
                        this._fireEvent("promiseResolved", this);
                    };
                    Promise1.prototype._setIsFinal = function() {
                        this._bitField = this._bitField | 4194304;
                    };
                    Promise1.prototype._isFinal = function() {
                        return (this._bitField & 4194304) > 0;
                    };
                    Promise1.prototype._unsetCancelled = function() {
                        this._bitField = this._bitField & -65537;
                    };
                    Promise1.prototype._setCancelled = function() {
                        this._bitField = this._bitField | 65536;
                        this._fireEvent("promiseCancelled", this);
                    };
                    Promise1.prototype._setWillBeCancelled = function() {
                        this._bitField = this._bitField | 8388608;
                    };
                    Promise1.prototype._setAsyncGuaranteed = function() {
                        if (async.hasCustomScheduler()) return;
                        var bitField = this._bitField;
                        this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
                    };
                    Promise1.prototype._setNoAsyncGuarantee = function() {
                        this._bitField = (this._bitField | 536870912) & -134217729;
                    };
                    Promise1.prototype._receiverAt = function(index) {
                        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
                        if (ret === UNDEFINED_BINDING) return undefined;
                        else if (ret === undefined && this._isBound()) return this._boundValue();
                        return ret;
                    };
                    Promise1.prototype._promiseAt = function(index) {
                        return this[index * 4 - 4 + 2];
                    };
                    Promise1.prototype._fulfillmentHandlerAt = function(index) {
                        return this[index * 4 - 4 + 0];
                    };
                    Promise1.prototype._rejectionHandlerAt = function(index) {
                        return this[index * 4 - 4 + 1];
                    };
                    Promise1.prototype._boundValue = function() {};
                    Promise1.prototype._migrateCallback0 = function(follower) {
                        var bitField = follower._bitField;
                        var fulfill = follower._fulfillmentHandler0;
                        var reject = follower._rejectionHandler0;
                        var promise = follower._promise0;
                        var receiver = follower._receiverAt(0);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._migrateCallbackAt = function(follower, index) {
                        var fulfill = follower._fulfillmentHandlerAt(index);
                        var reject = follower._rejectionHandlerAt(index);
                        var promise = follower._promiseAt(index);
                        var receiver = follower._receiverAt(index);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._addCallbacks = function(fulfill, reject, promise, receiver, context) {
                        var index = this._length();
                        if (index >= 65531) {
                            index = 0;
                            this._setLength(0);
                        }
                        if (index === 0) {
                            this._promise0 = promise;
                            this._receiver0 = receiver;
                            if (typeof fulfill === "function") this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this._rejectionHandler0 = util.contextBind(context, reject);
                        } else {
                            var base = index * 4 - 4;
                            this[base + 2] = promise;
                            this[base + 3] = receiver;
                            if (typeof fulfill === "function") this[base + 0] = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this[base + 1] = util.contextBind(context, reject);
                        }
                        this._setLength(index + 1);
                        return index;
                    };
                    Promise1.prototype._proxy = function(proxyable, arg) {
                        this._addCallbacks(undefined, undefined, arg, proxyable, null);
                    };
                    Promise1.prototype._resolveCallback = function(value, shouldBind) {
                        if ((this._bitField & 117506048) !== 0) return;
                        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
                        var maybePromise = tryConvertToPromise(value, this);
                        if (!(maybePromise instanceof Promise1)) return this._fulfill(value);
                        if (shouldBind) this._propagateFrom(maybePromise, 2);
                        var promise = maybePromise._target();
                        if (promise === this) {
                            this._reject(makeSelfResolutionError());
                            return;
                        }
                        var bitField = promise._bitField;
                        if ((bitField & 50397184) === 0) {
                            var len = this._length();
                            if (len > 0) promise._migrateCallback0(this);
                            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
                            this._setFollowing();
                            this._setLength(0);
                            this._setFollowee(maybePromise);
                        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
                        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
                        else {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            this._reject(reason);
                        }
                    };
                    Promise1.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
                        var trace = util.ensureErrorObject(reason);
                        var hasStack = trace === reason;
                        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                            var message = "a promise was rejected with a non-error: " + util.classString(reason);
                            this._warn(message, true);
                        }
                        this._attachExtraTrace(trace, synchronous ? hasStack : false);
                        this._reject(reason);
                    };
                    Promise1.prototype._resolveFromExecutor = function(executor) {
                        if (executor === INTERNAL) return;
                        var promise = this;
                        this._captureStackTrace();
                        this._pushContext();
                        var synchronous = true;
                        var r = this._execute(executor, function(value) {
                            promise._resolveCallback(value);
                        }, function(reason) {
                            promise._rejectCallback(reason, synchronous);
                        });
                        synchronous = false;
                        this._popContext();
                        if (r !== undefined) promise._rejectCallback(r, true);
                    };
                    Promise1.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
                        var bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        promise._pushContext();
                        var x;
                        if (receiver === APPLY) {
                            if (!value || typeof value.length !== "number") {
                                x = errorObj;
                                x.e = new TypeError1("cannot .spread() a non-array: " + util.classString(value));
                            } else x = tryCatch(handler).apply(this._boundValue(), value);
                        } else x = tryCatch(handler).call(receiver, value);
                        var promiseCreated = promise._popContext();
                        bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        if (x === NEXT_FILTER) promise._reject(value);
                        else if (x === errorObj) promise._rejectCallback(x.e, false);
                        else {
                            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
                            promise._resolveCallback(x);
                        }
                    };
                    Promise1.prototype._target = function() {
                        var ret = this;
                        while(ret._isFollowing())ret = ret._followee();
                        return ret;
                    };
                    Promise1.prototype._followee = function() {
                        return this._rejectionHandler0;
                    };
                    Promise1.prototype._setFollowee = function(promise) {
                        this._rejectionHandler0 = promise;
                    };
                    Promise1.prototype._settlePromise = function(promise, handler, receiver, value) {
                        var isPromise = promise instanceof Promise1;
                        var bitField = this._bitField;
                        var asyncGuaranteed = (bitField & 134217728) !== 0;
                        if ((bitField & 65536) !== 0) {
                            if (isPromise) promise._invokeInternalOnCancel();
                            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                                receiver.cancelPromise = promise;
                                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
                            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
                            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
                            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
                            else receiver.cancel();
                        } else if (typeof handler === "function") {
                            if (!isPromise) handler.call(receiver, value, promise);
                            else {
                                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                this._settlePromiseFromHandler(handler, receiver, value, promise);
                            }
                        } else if (receiver instanceof Proxyable) {
                            if (!receiver._isResolved()) {
                                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                                else receiver._promiseRejected(value, promise);
                            }
                        } else if (isPromise) {
                            if (asyncGuaranteed) promise._setAsyncGuaranteed();
                            if ((bitField & 33554432) !== 0) promise._fulfill(value);
                            else promise._reject(value);
                        }
                    };
                    Promise1.prototype._settlePromiseLateCancellationObserver = function(ctx) {
                        var handler = ctx.handler;
                        var promise = ctx.promise;
                        var receiver = ctx.receiver;
                        var value = ctx.value;
                        if (typeof handler === "function") {
                            if (!(promise instanceof Promise1)) handler.call(receiver, value, promise);
                            else this._settlePromiseFromHandler(handler, receiver, value, promise);
                        } else if (promise instanceof Promise1) promise._reject(value);
                    };
                    Promise1.prototype._settlePromiseCtx = function(ctx) {
                        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
                    };
                    Promise1.prototype._settlePromise0 = function(handler, value, bitField) {
                        var promise = this._promise0;
                        var receiver = this._receiverAt(0);
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._settlePromise(promise, handler, receiver, value);
                    };
                    Promise1.prototype._clearCallbackDataAtIndex = function(index) {
                        var base = index * 4 - 4;
                        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
                    };
                    Promise1.prototype._fulfill = function(value) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        if (value === this) {
                            var err = makeSelfResolutionError();
                            this._attachExtraTrace(err);
                            return this._reject(err);
                        }
                        this._setFulfilled();
                        this._rejectionHandler0 = value;
                        if ((bitField & 65535) > 0) {
                            if ((bitField & 134217728) !== 0) this._settlePromises();
                            else async.settlePromises(this);
                            this._dereferenceTrace();
                        }
                    };
                    Promise1.prototype._reject = function(reason) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        this._setRejected();
                        this._fulfillmentHandler0 = reason;
                        if (this._isFinal()) return async.fatalError(reason, util.isNode);
                        if ((bitField & 65535) > 0) async.settlePromises(this);
                        else this._ensurePossibleRejectionHandled();
                    };
                    Promise1.prototype._fulfillPromises = function(len, value) {
                        for(var i = 1; i < len; i++){
                            var handler = this._fulfillmentHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, value);
                        }
                    };
                    Promise1.prototype._rejectPromises = function(len, reason) {
                        for(var i = 1; i < len; i++){
                            var handler = this._rejectionHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, reason);
                        }
                    };
                    Promise1.prototype._settlePromises = function() {
                        var bitField = this._bitField;
                        var len = bitField & 65535;
                        if (len > 0) {
                            if ((bitField & 16842752) !== 0) {
                                var reason = this._fulfillmentHandler0;
                                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                                this._rejectPromises(len, reason);
                            } else {
                                var value = this._rejectionHandler0;
                                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                                this._fulfillPromises(len, value);
                            }
                            this._setLength(0);
                        }
                        this._clearCancellationData();
                    };
                    Promise1.prototype._settledValue = function() {
                        var bitField = this._bitField;
                        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
                        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
                    };
                    if (typeof Symbol !== "undefined" && Symbol.toStringTag) es5.defineProperty(Promise1.prototype, Symbol.toStringTag, {
                        get: function get() {
                            return "Object";
                        }
                    });
                    function deferResolve(v) {
                        this.promise._resolveCallback(v);
                    }
                    function deferReject(v) {
                        this.promise._rejectCallback(v, false);
                    }
                    Promise1.defer = Promise1.pending = function() {
                        debug.deprecated("Promise.defer", "new Promise");
                        var promise = new Promise1(INTERNAL);
                        return {
                            promise: promise,
                            resolve: deferResolve,
                            reject: deferReject
                        };
                    };
                    util.notEnumerableProp(Promise1, "_makeSelfResolutionError", makeSelfResolutionError);
                    _dereq_1("./method")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug);
                    _dereq_1("./bind")(Promise1, INTERNAL, tryConvertToPromise, debug);
                    _dereq_1("./cancel")(Promise1, PromiseArray, apiRejection, debug);
                    _dereq_1("./direct_resolve")(Promise1);
                    _dereq_1("./synchronous_inspection")(Promise1);
                    _dereq_1("./join")(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async);
                    Promise1.Promise = Promise1;
                    Promise1.version = "3.7.2";
                    _dereq_1("./call_get.js")(Promise1);
                    _dereq_1("./generators.js")(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
                    _dereq_1("./map.js")(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1("./nodeify.js")(Promise1);
                    _dereq_1("./promisify.js")(Promise1, INTERNAL);
                    _dereq_1("./props.js")(Promise1, PromiseArray, tryConvertToPromise, apiRejection);
                    _dereq_1("./race.js")(Promise1, INTERNAL, tryConvertToPromise, apiRejection);
                    _dereq_1("./reduce.js")(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1("./settle.js")(Promise1, PromiseArray, debug);
                    _dereq_1("./some.js")(Promise1, PromiseArray, apiRejection);
                    _dereq_1("./timers.js")(Promise1, INTERNAL, debug);
                    _dereq_1("./using.js")(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
                    _dereq_1("./any.js")(Promise1);
                    _dereq_1("./each.js")(Promise1, INTERNAL);
                    _dereq_1("./filter.js")(Promise1, INTERNAL);
                    util.toFastProperties(Promise1);
                    util.toFastProperties(Promise1.prototype);
                    function fillTypes(value) {
                        var p = new Promise1(INTERNAL);
                        p._fulfillmentHandler0 = value;
                        p._rejectionHandler0 = value;
                        p._promise0 = value;
                        p._receiver0 = value;
                    }
                    // Complete slack tracking, opt out of field-type tracking and           
                    // stabilize map                                                         
                    fillTypes({
                        a: 1
                    });
                    fillTypes({
                        b: 2
                    });
                    fillTypes({
                        c: 3
                    });
                    fillTypes(1);
                    fillTypes(function() {});
                    fillTypes(undefined);
                    fillTypes(false);
                    fillTypes(new Promise1(INTERNAL));
                    debug.setBounds(Async.firstLineError, util.lastLineError);
                    return Promise1;
                };
            },
            {
                "./any.js": 1,
                "./async": 2,
                "./bind": 3,
                "./call_get.js": 5,
                "./cancel": 6,
                "./catch_filter": 7,
                "./context": 8,
                "./debuggability": 9,
                "./direct_resolve": 10,
                "./each.js": 11,
                "./errors": 12,
                "./es5": 13,
                "./filter.js": 14,
                "./finally": 15,
                "./generators.js": 16,
                "./join": 17,
                "./map.js": 18,
                "./method": 19,
                "./nodeback": 20,
                "./nodeify.js": 21,
                "./promise_array": 23,
                "./promisify.js": 24,
                "./props.js": 25,
                "./race.js": 27,
                "./reduce.js": 28,
                "./settle.js": 30,
                "./some.js": 31,
                "./synchronous_inspection": 32,
                "./thenables": 33,
                "./timers.js": 34,
                "./using.js": 35,
                "./util": 36,
                "async_hooks": undefined
            }
        ],
        23: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
                    var util = _dereq_1("./util");
                    var isArray = util.isArray;
                    function toResolutionValue(val) {
                        switch(val){
                            case -2:
                                return [];
                            case -3:
                                return {};
                            case -6:
                                return new Map();
                        }
                    }
                    function PromiseArray(values) {
                        var promise = this._promise = new Promise1(INTERNAL);
                        if (values instanceof Promise1) {
                            promise._propagateFrom(values, 3);
                            values.suppressUnhandledRejections();
                        }
                        promise._setOnCancel(this);
                        this._values = values;
                        this._length = 0;
                        this._totalResolved = 0;
                        this._init(undefined, -2);
                    }
                    util.inherits(PromiseArray, Proxyable);
                    PromiseArray.prototype.length = function() {
                        return this._length;
                    };
                    PromiseArray.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
                        var values = tryConvertToPromise(this._values, this._promise);
                        if (values instanceof Promise1) {
                            values = values._target();
                            var bitField = values._bitField;
                            this._values = values;
                            if ((bitField & 50397184) === 0) {
                                this._promise._setAsyncGuaranteed();
                                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                            } else if ((bitField & 33554432) !== 0) values = values._value();
                            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
                            else return this._cancel();
                        }
                        values = util.asArray(values);
                        if (values === null) {
                            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
                            this._promise._rejectCallback(err, false);
                            return;
                        }
                        if (values.length === 0) {
                            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
                            else this._resolve(toResolutionValue(resolveValueIfEmpty));
                            return;
                        }
                        this._iterate(values);
                    };
                    PromiseArray.prototype._iterate = function(values) {
                        var len = this.getActualLength(values.length);
                        this._length = len;
                        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
                        var result = this._promise;
                        var isResolved = false;
                        var bitField = null;
                        for(var i = 0; i < len; ++i){
                            var maybePromise = tryConvertToPromise(values[i], result);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                bitField = maybePromise._bitField;
                            } else bitField = null;
                            if (isResolved) {
                                if (bitField !== null) maybePromise.suppressUnhandledRejections();
                            } else if (bitField !== null) {
                                if ((bitField & 50397184) === 0) {
                                    maybePromise._proxy(this, i);
                                    this._values[i] = maybePromise;
                                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                                else isResolved = this._promiseCancelled(i);
                            } else isResolved = this._promiseFulfilled(maybePromise, i);
                        }
                        if (!isResolved) result._setAsyncGuaranteed();
                    };
                    PromiseArray.prototype._isResolved = function() {
                        return this._values === null;
                    };
                    PromiseArray.prototype._resolve = function(value) {
                        this._values = null;
                        this._promise._fulfill(value);
                    };
                    PromiseArray.prototype._cancel = function() {
                        if (this._isResolved() || !this._promise._isCancellable()) return;
                        this._values = null;
                        this._promise._cancel();
                    };
                    PromiseArray.prototype._reject = function(reason) {
                        this._values = null;
                        this._promise._rejectCallback(reason, false);
                    };
                    PromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    PromiseArray.prototype._promiseCancelled = function() {
                        this._cancel();
                        return true;
                    };
                    PromiseArray.prototype._promiseRejected = function(reason) {
                        this._totalResolved++;
                        this._reject(reason);
                        return true;
                    };
                    PromiseArray.prototype._resultCancelled = function() {
                        if (this._isResolved()) return;
                        var values = this._values;
                        this._cancel();
                        if (values instanceof Promise1) values.cancel();
                        else {
                            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise1) values[i].cancel();
                        }
                    };
                    PromiseArray.prototype.shouldCopyValues = function() {
                        return true;
                    };
                    PromiseArray.prototype.getActualLength = function(len) {
                        return len;
                    };
                    return PromiseArray;
                };
            },
            {
                "./util": 36
            }
        ],
        24: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var THIS = {};
                    var util = _dereq_1("./util");
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var withAppended = util.withAppended;
                    var maybeWrapAsError = util.maybeWrapAsError;
                    var canEvaluate = util.canEvaluate;
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var defaultSuffix = "Async";
                    var defaultPromisified = {
                        __isPromisified__: true
                    };
                    var noCopyProps = [
                        "arity",
                        "length",
                        "name",
                        "arguments",
                        "caller",
                        "callee",
                        "prototype",
                        "__isPromisified__"
                    ];
                    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
                    var defaultFilter = function defaultFilter(name) {
                        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
                    };
                    function propsFilter(key) {
                        return !noCopyPropsPattern.test(key);
                    }
                    function isPromisified(fn) {
                        try {
                            return fn.__isPromisified__ === true;
                        } catch (e) {
                            return false;
                        }
                    }
                    function hasPromisified(obj, key, suffix) {
                        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
                        return val ? isPromisified(val) : false;
                    }
                    function checkValid(ret, suffix, suffixRegexp) {
                        for(var i = 0; i < ret.length; i += 2){
                            var key = ret[i];
                            if (suffixRegexp.test(key)) {
                                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                                for(var j = 0; j < ret.length; j += 2){
                                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError1("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
                                }
                            }
                        }
                    }
                    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
                        var keys = util.inheritedDataKeys(obj);
                        var ret = [];
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            var value = obj[key];
                            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
                            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
                        }
                        checkValid(ret, suffix, suffixRegexp);
                        return ret;
                    }
                    var escapeIdentRegex = function escapeIdentRegex(str) {
                        return str.replace(/([$])/, "\\$");
                    };
                    var makeNodePromisifiedEval;
                    var switchCaseArgumentOrder, argumentSequence, parameterDeclaration, parameterCount;
                    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
                        var defaultThis = function() {
                            return this;
                        }();
                        var method = callback;
                        if (typeof method === "string") callback = fn;
                        function promisified() {
                            var _receiver = receiver;
                            if (receiver === THIS) _receiver = this;
                            var promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                            var _$fn = nodebackForPromise(promise, multiArgs);
                            try {
                                cb.apply(_receiver, withAppended(arguments, _$fn));
                            } catch (e) {
                                promise._rejectCallback(maybeWrapAsError(e), true, true);
                            }
                            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                            return promise;
                        }
                        util.notEnumerableProp(promisified, "__isPromisified__", true);
                        return promisified;
                    }
                    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
                    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
                        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
                        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
                        for(var i = 0, len = methods.length; i < len; i += 2){
                            var key = methods[i];
                            var fn = methods[i + 1];
                            var promisifiedKey = key + suffix;
                            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                            else {
                                var promisified = promisifier(fn, function() {
                                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                });
                                util.notEnumerableProp(promisified, "__isPromisified__", true);
                                obj[promisifiedKey] = promisified;
                            }
                        }
                        util.toFastProperties(obj);
                        return obj;
                    }
                    function promisify(callback, receiver, multiArgs) {
                        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
                    }
                    Promise1.promisify = function(fn, options) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        if (isPromisified(fn)) return fn;
                        options = Object(options);
                        var receiver = options.context === undefined ? THIS : options.context;
                        var multiArgs = !!options.multiArgs;
                        var ret = promisify(fn, receiver, multiArgs);
                        util.copyDescriptors(fn, ret, propsFilter);
                        return ret;
                    };
                    Promise1.promisifyAll = function(target, options) {
                        if (typeof target !== "function" && typeof target !== "object") throw new TypeError1("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
                        options = Object(options);
                        var multiArgs = !!options.multiArgs;
                        var suffix = options.suffix;
                        if (typeof suffix !== "string") suffix = defaultSuffix;
                        var filter = options.filter;
                        if (typeof filter !== "function") filter = defaultFilter;
                        var promisifier = options.promisifier;
                        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
                        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
                        var keys = util.inheritedDataKeys(target);
                        for(var i = 0; i < keys.length; ++i){
                            var value = target[keys[i]];
                            if (keys[i] !== "constructor" && util.isClass(value)) {
                                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                                promisifyAll(value, suffix, filter, promisifier, multiArgs);
                            }
                        }
                        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
                    };
                };
            },
            {
                "./errors": 12,
                "./nodeback": 20,
                "./util": 36
            }
        ],
        25: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var isObject = util.isObject;
                    var es5 = _dereq_1("./es5");
                    var Es6Map;
                    if (typeof Map === "function") Es6Map = Map;
                    var mapToEntries = function() {
                        var index = 0;
                        var size = 0;
                        function extractEntry(value, key) {
                            this[index] = value;
                            this[index + size] = key;
                            index++;
                        }
                        return function mapToEntries(map) {
                            size = map.size;
                            index = 0;
                            var ret = new Array(map.size * 2);
                            map.forEach(extractEntry, ret);
                            return ret;
                        };
                    }();
                    var entriesToMap = function entriesToMap(entries) {
                        var ret = new Es6Map();
                        var length = entries.length / 2 | 0;
                        for(var i = 0; i < length; ++i){
                            var key = entries[length + i];
                            var value = entries[i];
                            ret.set(key, value);
                        }
                        return ret;
                    };
                    function PropertiesPromiseArray(obj) {
                        var isMap = false;
                        var entries;
                        if (Es6Map !== undefined && obj instanceof Es6Map) {
                            entries = mapToEntries(obj);
                            isMap = true;
                        } else {
                            var keys = es5.keys(obj);
                            var len = keys.length;
                            entries = new Array(len * 2);
                            for(var i = 0; i < len; ++i){
                                var key = keys[i];
                                entries[i] = obj[key];
                                entries[i + len] = key;
                            }
                        }
                        this.constructor$(entries);
                        this._isMap = isMap;
                        this._init$(undefined, isMap ? -6 : -3);
                    }
                    util.inherits(PropertiesPromiseArray, PromiseArray);
                    PropertiesPromiseArray.prototype._init = function() {};
                    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            var val;
                            if (this._isMap) val = entriesToMap(this._values);
                            else {
                                val = {};
                                var keyOffset = this.length();
                                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
                            }
                            this._resolve(val);
                            return true;
                        }
                        return false;
                    };
                    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    PropertiesPromiseArray.prototype.getActualLength = function(len) {
                        return len >> 1;
                    };
                    function props(promises) {
                        var ret;
                        var castValue = tryConvertToPromise(promises);
                        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
                        else if (castValue instanceof Promise1) ret = castValue._then(Promise1.props, undefined, undefined, undefined, undefined);
                        else ret = new PropertiesPromiseArray(castValue).promise();
                        if (castValue instanceof Promise1) ret._propagateFrom(castValue, 2);
                        return ret;
                    }
                    Promise1.prototype.props = function() {
                        return props(this);
                    };
                    Promise1.props = function(promises) {
                        return props(promises);
                    };
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        26: [
            function(_dereq_1, module1, exports) {
                "use strict";
                function arrayMove(src, srcIndex, dst, dstIndex, len) {
                    for(var j = 0; j < len; ++j){
                        dst[j + dstIndex] = src[j + srcIndex];
                        src[j + srcIndex] = void 0;
                    }
                }
                function Queue(capacity) {
                    this._capacity = capacity;
                    this._length = 0;
                    this._front = 0;
                }
                Queue.prototype._willBeOverCapacity = function(size) {
                    return this._capacity < size;
                };
                Queue.prototype._pushOne = function(arg) {
                    var length = this.length();
                    this._checkCapacity(length + 1);
                    var i = this._front + length & this._capacity - 1;
                    this[i] = arg;
                    this._length = length + 1;
                };
                Queue.prototype.push = function(fn, receiver, arg) {
                    var length = this.length() + 3;
                    if (this._willBeOverCapacity(length)) {
                        this._pushOne(fn);
                        this._pushOne(receiver);
                        this._pushOne(arg);
                        return;
                    }
                    var j = this._front + length - 3;
                    this._checkCapacity(length);
                    var wrapMask = this._capacity - 1;
                    this[j + 0 & wrapMask] = fn;
                    this[j + 1 & wrapMask] = receiver;
                    this[j + 2 & wrapMask] = arg;
                    this._length = length;
                };
                Queue.prototype.shift = function() {
                    var front = this._front, ret = this[front];
                    this[front] = undefined;
                    this._front = front + 1 & this._capacity - 1;
                    this._length--;
                    return ret;
                };
                Queue.prototype.length = function() {
                    return this._length;
                };
                Queue.prototype._checkCapacity = function(size) {
                    if (this._capacity < size) this._resizeTo(this._capacity << 1);
                };
                Queue.prototype._resizeTo = function(capacity) {
                    var oldCapacity = this._capacity;
                    this._capacity = capacity;
                    var front = this._front;
                    var length = this._length;
                    var moveItemsCount = front + length & oldCapacity - 1;
                    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
                };
                module1.exports = Queue;
            },
            {}
        ],
        27: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var raceLater = function raceLater(promise) {
                        return promise.then(function(array) {
                            return race(array, promise);
                        });
                    };
                    function race(promises, parent) {
                        var maybePromise = tryConvertToPromise(promises);
                        if (maybePromise instanceof Promise1) return raceLater(maybePromise);
                        else {
                            promises = util.asArray(promises);
                            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
                        }
                        var ret = new Promise1(INTERNAL);
                        if (parent !== undefined) ret._propagateFrom(parent, 3);
                        var fulfill = ret._fulfill;
                        var reject = ret._reject;
                        for(var i = 0, len = promises.length; i < len; ++i){
                            var val = promises[i];
                            if (val === undefined && !(i in promises)) continue;
                            Promise1.cast(val)._then(fulfill, reject, undefined, ret, null);
                        }
                        return ret;
                    }
                    Promise1.race = function(promises) {
                        return race(promises, undefined);
                    };
                    Promise1.prototype.race = function() {
                        return race(this, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        28: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    function ReductionPromiseArray(promises, fn, initialValue, _each) {
                        this.constructor$(promises);
                        var context = Promise1._getContext();
                        this._fn = util.contextBind(context, fn);
                        if (initialValue !== undefined) {
                            initialValue = Promise1.resolve(initialValue);
                            initialValue._attachCancellationCallback(this);
                        }
                        this._initialValue = initialValue;
                        this._currentCancellable = null;
                        if (_each === INTERNAL) this._eachValues = Array(this._length);
                        else if (_each === 0) this._eachValues = null;
                        else this._eachValues = undefined;
                        this._promise._captureStackTrace();
                        this._init$(undefined, -5);
                    }
                    util.inherits(ReductionPromiseArray, PromiseArray);
                    ReductionPromiseArray.prototype._gotAccum = function(accum) {
                        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
                    };
                    ReductionPromiseArray.prototype._eachComplete = function(value) {
                        if (this._eachValues !== null) this._eachValues.push(value);
                        return this._eachValues;
                    };
                    ReductionPromiseArray.prototype._init = function() {};
                    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
                        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
                    };
                    ReductionPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    ReductionPromiseArray.prototype._resolve = function(value) {
                        this._promise._resolveCallback(value);
                        this._values = null;
                    };
                    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
                        if (sender === this._initialValue) return this._cancel();
                        if (this._isResolved()) return;
                        this._resultCancelled$();
                        if (this._currentCancellable instanceof Promise1) this._currentCancellable.cancel();
                        if (this._initialValue instanceof Promise1) this._initialValue.cancel();
                    };
                    ReductionPromiseArray.prototype._iterate = function(values) {
                        this._values = values;
                        var value;
                        var i;
                        var length = values.length;
                        if (this._initialValue !== undefined) {
                            value = this._initialValue;
                            i = 0;
                        } else {
                            value = Promise1.resolve(values[0]);
                            i = 1;
                        }
                        this._currentCancellable = value;
                        for(var j = i; j < length; ++j){
                            var maybePromise = values[j];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                        if (!value.isRejected()) for(; i < length; ++i){
                            var ctx = {
                                accum: null,
                                value: values[i],
                                index: i,
                                length: length,
                                array: this
                            };
                            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
                            if ((i & 127) === 0) value._setNoAsyncGuarantee();
                        }
                        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
                        value._then(completed, completed, undefined, value, this);
                    };
                    Promise1.prototype.reduce = function(fn, initialValue) {
                        return reduce(this, fn, initialValue, null);
                    };
                    Promise1.reduce = function(promises, fn, initialValue, _each) {
                        return reduce(promises, fn, initialValue, _each);
                    };
                    function completed(valueOrReason, array) {
                        if (this.isFulfilled()) array._resolve(valueOrReason);
                        else array._reject(valueOrReason);
                    }
                    function reduce(promises, fn, initialValue, _each) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
                        return array.promise();
                    }
                    function gotAccum(accum) {
                        this.accum = accum;
                        this.array._gotAccum(accum);
                        var value = tryConvertToPromise(this.value, this.array._promise);
                        if (value instanceof Promise1) {
                            this.array._currentCancellable = value;
                            return value._then(gotValue, undefined, undefined, this, undefined);
                        } else return gotValue.call(this, value);
                    }
                    function gotValue(value) {
                        var array = this.array;
                        var promise = array._promise;
                        var fn = tryCatch(array._fn);
                        promise._pushContext();
                        var ret;
                        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
                        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
                        if (ret instanceof Promise1) array._currentCancellable = ret;
                        var promiseCreated = promise._popContext();
                        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
                        return ret;
                    }
                };
            },
            {
                "./util": 36
            }
        ],
        29: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var schedule;
                var noAsyncScheduler = function noAsyncScheduler() {
                    throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
                };
                var NativePromise = util.getNativePromise();
                if (util.isNode && typeof MutationObserver === "undefined") {
                    var GlobalSetImmediate = $parcel$global.setImmediate;
                    var ProcessNextTick = $3ce9c2508a6babe0$exports.nextTick;
                    schedule = util.isRecentNode ? function schedule(fn) {
                        GlobalSetImmediate.call($parcel$global, fn);
                    } : function(fn) {
                        ProcessNextTick.call($3ce9c2508a6babe0$exports, fn);
                    };
                } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
                    var nativePromise = NativePromise.resolve();
                    schedule = function schedule(fn) {
                        nativePromise.then(fn);
                    };
                } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) schedule = function() {
                    var div = document.createElement("div");
                    var opts = {
                        attributes: true
                    };
                    var toggleScheduled = false;
                    var div2 = document.createElement("div");
                    var o2 = new MutationObserver(function() {
                        div.classList.toggle("foo");
                        toggleScheduled = false;
                    });
                    o2.observe(div2, opts);
                    var scheduleToggle = function scheduleToggle() {
                        if (toggleScheduled) return;
                        toggleScheduled = true;
                        div2.classList.toggle("foo");
                    };
                    return function schedule(fn) {
                        var o = new MutationObserver(function() {
                            o.disconnect();
                            fn();
                        });
                        o.observe(div, opts);
                        scheduleToggle();
                    };
                }();
                else if (typeof setImmediate !== "undefined") schedule = function schedule(fn) {
                    setImmediate(fn);
                };
                else if (typeof setTimeout !== "undefined") schedule = function schedule(fn) {
                    setTimeout(fn, 0);
                };
                else schedule = noAsyncScheduler;
                module1.exports = schedule;
            },
            {
                "./util": 36
            }
        ],
        30: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, debug) {
                    var PromiseInspection = Promise1.PromiseInspection;
                    var util = _dereq_1("./util");
                    function SettledPromiseArray(values) {
                        this.constructor$(values);
                    }
                    util.inherits(SettledPromiseArray, PromiseArray);
                    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
                        this._values[index] = inspection;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 33554432;
                        ret._settledValueField = value;
                        return this._promiseResolved(index, ret);
                    };
                    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 16777216;
                        ret._settledValueField = reason;
                        return this._promiseResolved(index, ret);
                    };
                    Promise1.settle = function(promises) {
                        debug.deprecated(".settle()", ".reflect()");
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.allSettled = function(promises) {
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.prototype.settle = function() {
                        return Promise1.settle(this);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        31: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection) {
                    var util = _dereq_1("./util");
                    var RangeError1 = _dereq_1("./errors").RangeError;
                    var AggregateError = _dereq_1("./errors").AggregateError;
                    var isArray = util.isArray;
                    var CANCELLATION = {};
                    function SomePromiseArray(values) {
                        this.constructor$(values);
                        this._howMany = 0;
                        this._unwrap = false;
                        this._initialized = false;
                    }
                    util.inherits(SomePromiseArray, PromiseArray);
                    SomePromiseArray.prototype._init = function() {
                        if (!this._initialized) return;
                        if (this._howMany === 0) {
                            this._resolve([]);
                            return;
                        }
                        this._init$(undefined, -5);
                        var isArrayResolved = isArray(this._values);
                        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
                    };
                    SomePromiseArray.prototype.init = function() {
                        this._initialized = true;
                        this._init();
                    };
                    SomePromiseArray.prototype.setUnwrap = function() {
                        this._unwrap = true;
                    };
                    SomePromiseArray.prototype.howMany = function() {
                        return this._howMany;
                    };
                    SomePromiseArray.prototype.setHowMany = function(count) {
                        this._howMany = count;
                    };
                    SomePromiseArray.prototype._promiseFulfilled = function(value) {
                        this._addFulfilled(value);
                        if (this._fulfilled() === this.howMany()) {
                            this._values.length = this.howMany();
                            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
                            else this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._promiseRejected = function(reason) {
                        this._addRejected(reason);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._promiseCancelled = function() {
                        if (this._values instanceof Promise1 || this._values == null) return this._cancel();
                        this._addRejected(CANCELLATION);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._checkOutcome = function() {
                        if (this.howMany() > this._canPossiblyFulfill()) {
                            var e = new AggregateError();
                            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
                            if (e.length > 0) this._reject(e);
                            else this._cancel();
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._fulfilled = function() {
                        return this._totalResolved;
                    };
                    SomePromiseArray.prototype._rejected = function() {
                        return this._values.length - this.length();
                    };
                    SomePromiseArray.prototype._addRejected = function(reason) {
                        this._values.push(reason);
                    };
                    SomePromiseArray.prototype._addFulfilled = function(value) {
                        this._values[this._totalResolved++] = value;
                    };
                    SomePromiseArray.prototype._canPossiblyFulfill = function() {
                        return this.length() - this._rejected();
                    };
                    SomePromiseArray.prototype._getRangeError = function(count) {
                        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
                        return new RangeError1(message);
                    };
                    SomePromiseArray.prototype._resolveEmptyArray = function() {
                        this._reject(this._getRangeError(0));
                    };
                    function some(promises, howMany) {
                        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(howMany);
                        ret.init();
                        return promise;
                    }
                    Promise1.some = function(promises, howMany) {
                        return some(promises, howMany);
                    };
                    Promise1.prototype.some = function(howMany) {
                        return some(this, howMany);
                    };
                    Promise1._SomePromiseArray = SomePromiseArray;
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        32: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function PromiseInspection(promise) {
                        if (promise !== undefined) {
                            promise = promise._target();
                            this._bitField = promise._bitField;
                            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
                        } else {
                            this._bitField = 0;
                            this._settledValueField = undefined;
                        }
                    }
                    PromiseInspection.prototype._settledValue = function() {
                        return this._settledValueField;
                    };
                    var value = PromiseInspection.prototype.value = function value() {
                        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
                        return this._settledValue();
                    };
                    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function reason() {
                        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
                        return this._settledValue();
                    };
                    var isFulfilled = PromiseInspection.prototype.isFulfilled = function isFulfilled() {
                        return (this._bitField & 33554432) !== 0;
                    };
                    var isRejected = PromiseInspection.prototype.isRejected = function isRejected() {
                        return (this._bitField & 16777216) !== 0;
                    };
                    var isPending = PromiseInspection.prototype.isPending = function isPending() {
                        return (this._bitField & 50397184) === 0;
                    };
                    var isResolved = PromiseInspection.prototype.isResolved = function isResolved() {
                        return (this._bitField & 50331648) !== 0;
                    };
                    PromiseInspection.prototype.isCancelled = function() {
                        return (this._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.__isCancelled = function() {
                        return (this._bitField & 65536) === 65536;
                    };
                    Promise1.prototype._isCancelled = function() {
                        return this._target().__isCancelled();
                    };
                    Promise1.prototype.isCancelled = function() {
                        return (this._target()._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.isPending = function() {
                        return isPending.call(this._target());
                    };
                    Promise1.prototype.isRejected = function() {
                        return isRejected.call(this._target());
                    };
                    Promise1.prototype.isFulfilled = function() {
                        return isFulfilled.call(this._target());
                    };
                    Promise1.prototype.isResolved = function() {
                        return isResolved.call(this._target());
                    };
                    Promise1.prototype.value = function() {
                        return value.call(this._target());
                    };
                    Promise1.prototype.reason = function() {
                        var target = this._target();
                        target._unsetRejectionIsUnhandled();
                        return reason.call(target);
                    };
                    Promise1.prototype._value = function() {
                        return this._settledValue();
                    };
                    Promise1.prototype._reason = function() {
                        this._unsetRejectionIsUnhandled();
                        return this._settledValue();
                    };
                    Promise1.PromiseInspection = PromiseInspection;
                };
            },
            {}
        ],
        33: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var isObject = util.isObject;
                    function tryConvertToPromise(obj, context) {
                        if (isObject(obj)) {
                            if (obj instanceof Promise1) return obj;
                            var then = getThen(obj);
                            if (then === errorObj) {
                                if (context) context._pushContext();
                                var ret = Promise1.reject(then.e);
                                if (context) context._popContext();
                                return ret;
                            } else if (typeof then === "function") {
                                if (isAnyBluebirdPromise(obj)) {
                                    var ret = new Promise1(INTERNAL);
                                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                                    return ret;
                                }
                                return doThenable(obj, then, context);
                            }
                        }
                        return obj;
                    }
                    function doGetThen(obj) {
                        return obj.then;
                    }
                    function getThen(obj) {
                        try {
                            return doGetThen(obj);
                        } catch (e) {
                            errorObj.e = e;
                            return errorObj;
                        }
                    }
                    var hasProp = {}.hasOwnProperty;
                    function isAnyBluebirdPromise(obj) {
                        try {
                            return hasProp.call(obj, "_promise0");
                        } catch (e) {
                            return false;
                        }
                    }
                    function doThenable(x, then, context) {
                        var promise = new Promise1(INTERNAL);
                        var ret = promise;
                        if (context) context._pushContext();
                        promise._captureStackTrace();
                        if (context) context._popContext();
                        var synchronous = true;
                        var result = util.tryCatch(then).call(x, resolve, reject);
                        synchronous = false;
                        if (promise && result === errorObj) {
                            promise._rejectCallback(result.e, true, true);
                            promise = null;
                        }
                        function resolve(value) {
                            if (!promise) return;
                            promise._resolveCallback(value);
                            promise = null;
                        }
                        function reject(reason) {
                            if (!promise) return;
                            promise._rejectCallback(reason, synchronous, true);
                            promise = null;
                        }
                        return ret;
                    }
                    return tryConvertToPromise;
                };
            },
            {
                "./util": 36
            }
        ],
        34: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TimeoutError = Promise1.TimeoutError;
                    function HandleWrapper(handle) {
                        this.handle = handle;
                    }
                    HandleWrapper.prototype._resultCancelled = function() {
                        clearTimeout(this.handle);
                    };
                    var afterValue = function afterValue(value) {
                        return delay(+this).thenReturn(value);
                    };
                    var delay = Promise1.delay = function delay(ms, value) {
                        var ret;
                        var handle;
                        if (value !== undefined) {
                            ret = Promise1.resolve(value)._then(afterValue, null, null, ms, undefined);
                            if (debug.cancellation() && value instanceof Promise1) ret._setOnCancel(value);
                        } else {
                            ret = new Promise1(INTERNAL);
                            handle = setTimeout(function() {
                                ret._fulfill();
                            }, +ms);
                            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
                            ret._captureStackTrace();
                        }
                        ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.prototype.delay = function(ms) {
                        return delay(ms, this);
                    };
                    var afterTimeout = function afterTimeout(promise, message, parent) {
                        var err;
                        if (typeof message !== "string") {
                            if (message instanceof Error) err = message;
                            else err = new TimeoutError("operation timed out");
                        } else err = new TimeoutError(message);
                        util.markAsOriginatingFromRejection(err);
                        promise._attachExtraTrace(err);
                        promise._reject(err);
                        if (parent != null) parent.cancel();
                    };
                    function successClear(value) {
                        clearTimeout(this.handle);
                        return value;
                    }
                    function failureClear(reason) {
                        clearTimeout(this.handle);
                        throw reason;
                    }
                    Promise1.prototype.timeout = function(ms, message) {
                        ms = +ms;
                        var ret, parent;
                        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
                            if (ret.isPending()) afterTimeout(ret, message, parent);
                        }, ms));
                        if (debug.cancellation()) {
                            parent = this.then();
                            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
                            ret._setOnCancel(handleWrapper);
                        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
                        return ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        35: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var inherits = _dereq_1("./util").inherits;
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var NULL = {};
                    function thrower(e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                    function castPreservingDisposable(thenable) {
                        var maybePromise = tryConvertToPromise(thenable);
                        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
                        return maybePromise;
                    }
                    function dispose(resources, inspection) {
                        var i = 0;
                        var len = resources.length;
                        var ret = new Promise1(INTERNAL);
                        function iterator() {
                            if (i >= len) return ret._fulfill();
                            var maybePromise = castPreservingDisposable(resources[i++]);
                            if (maybePromise instanceof Promise1 && maybePromise._isDisposable()) {
                                try {
                                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                                } catch (e) {
                                    return thrower(e);
                                }
                                if (maybePromise instanceof Promise1) return maybePromise._then(iterator, thrower, null, null, null);
                            }
                            iterator();
                        }
                        iterator();
                        return ret;
                    }
                    function Disposer(data, promise, context) {
                        this._data = data;
                        this._promise = promise;
                        this._context = context;
                    }
                    Disposer.prototype.data = function() {
                        return this._data;
                    };
                    Disposer.prototype.promise = function() {
                        return this._promise;
                    };
                    Disposer.prototype.resource = function() {
                        if (this.promise().isFulfilled()) return this.promise().value();
                        return NULL;
                    };
                    Disposer.prototype.tryDispose = function(inspection) {
                        var resource = this.resource();
                        var context = this._context;
                        if (context !== undefined) context._pushContext();
                        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
                        if (context !== undefined) context._popContext();
                        this._promise._unsetDisposable();
                        this._data = null;
                        return ret;
                    };
                    Disposer.isDisposer = function(d) {
                        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
                    };
                    function FunctionDisposer(fn, promise, context) {
                        this.constructor$(fn, promise, context);
                    }
                    inherits(FunctionDisposer, Disposer);
                    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
                        var fn = this.data();
                        return fn.call(resource, resource, inspection);
                    };
                    function maybeUnwrapDisposer(value) {
                        if (Disposer.isDisposer(value)) {
                            this.resources[this.index]._setDisposable(value);
                            return value.promise();
                        }
                        return value;
                    }
                    function ResourceList(length) {
                        this.length = length;
                        this.promise = null;
                        this[length - 1] = null;
                    }
                    ResourceList.prototype._resultCancelled = function() {
                        var len = this.length;
                        for(var i = 0; i < len; ++i){
                            var item = this[i];
                            if (item instanceof Promise1) item.cancel();
                        }
                    };
                    Promise1.using = function() {
                        var len = arguments.length;
                        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
                        var fn = arguments[len - 1];
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var input;
                        var spreadArgs = true;
                        if (len === 2 && Array.isArray(arguments[0])) {
                            input = arguments[0];
                            len = input.length;
                            spreadArgs = false;
                        } else {
                            input = arguments;
                            len--;
                        }
                        var resources = new ResourceList(len);
                        for(var i = 0; i < len; ++i){
                            var resource = input[i];
                            if (Disposer.isDisposer(resource)) {
                                var disposer = resource;
                                resource = resource.promise();
                                resource._setDisposable(disposer);
                            } else {
                                var maybePromise = tryConvertToPromise(resource);
                                if (maybePromise instanceof Promise1) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                                    resources: resources,
                                    index: i
                                }, undefined);
                            }
                            resources[i] = resource;
                        }
                        var reflectedResources = new Array(resources.length);
                        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise1.resolve(resources[i]).reflect();
                        var resultPromise = Promise1.all(reflectedResources).then(function(inspections) {
                            for(var i = 0; i < inspections.length; ++i){
                                var inspection = inspections[i];
                                if (inspection.isRejected()) {
                                    errorObj.e = inspection.error();
                                    return errorObj;
                                } else if (!inspection.isFulfilled()) {
                                    resultPromise.cancel();
                                    return;
                                }
                                inspections[i] = inspection.value();
                            }
                            promise._pushContext();
                            fn = tryCatch(fn);
                            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                            return ret;
                        });
                        var promise = resultPromise.lastly(function() {
                            var inspection = new Promise1.PromiseInspection(resultPromise);
                            return dispose(resources, inspection);
                        });
                        resources.promise = promise;
                        promise._setOnCancel(resources);
                        return promise;
                    };
                    Promise1.prototype._setDisposable = function(disposer) {
                        this._bitField = this._bitField | 131072;
                        this._disposer = disposer;
                    };
                    Promise1.prototype._isDisposable = function() {
                        return (this._bitField & 131072) > 0;
                    };
                    Promise1.prototype._getDisposer = function() {
                        return this._disposer;
                    };
                    Promise1.prototype._unsetDisposable = function() {
                        this._bitField = this._bitField & -131073;
                        this._disposer = undefined;
                    };
                    Promise1.prototype.disposer = function(fn) {
                        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
                        throw new TypeError1();
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        36: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var canEvaluate = typeof navigator == "undefined";
                var errorObj = {
                    e: {}
                };
                var tryCatchTarget;
                var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : this !== undefined ? this : null;
                function tryCatcher() {
                    try {
                        var target = tryCatchTarget;
                        tryCatchTarget = null;
                        return target.apply(this, arguments);
                    } catch (e) {
                        errorObj.e = e;
                        return errorObj;
                    }
                }
                function tryCatch(fn) {
                    tryCatchTarget = fn;
                    return tryCatcher;
                }
                var inherits = function inherits(Child, Parent) {
                    var hasProp = {}.hasOwnProperty;
                    function T() {
                        this.constructor = Child;
                        this.constructor$ = Parent;
                        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
                    }
                    T.prototype = Parent.prototype;
                    Child.prototype = new T();
                    return Child.prototype;
                };
                function isPrimitive(val) {
                    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
                }
                function isObject(value) {
                    return typeof value === "function" || typeof value === "object" && value !== null;
                }
                function maybeWrapAsError(maybeError) {
                    if (!isPrimitive(maybeError)) return maybeError;
                    return new Error(safeToString(maybeError));
                }
                function withAppended(target, appendee) {
                    var len = target.length;
                    var ret = new Array(len + 1);
                    var i;
                    for(i = 0; i < len; ++i)ret[i] = target[i];
                    ret[i] = appendee;
                    return ret;
                }
                function getDataPropertyOrDefault(obj, key, defaultValue) {
                    if (es5.isES5) {
                        var desc = Object.getOwnPropertyDescriptor(obj, key);
                        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
                    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
                }
                function notEnumerableProp(obj, name, value) {
                    if (isPrimitive(obj)) return obj;
                    var descriptor = {
                        value: value,
                        configurable: true,
                        enumerable: false,
                        writable: true
                    };
                    es5.defineProperty(obj, name, descriptor);
                    return obj;
                }
                function thrower(r) {
                    throw r;
                }
                var inheritedDataKeys = function() {
                    var excludedPrototypes = [
                        Array.prototype,
                        Object.prototype,
                        Function.prototype
                    ];
                    var isExcludedProto = function isExcludedProto(val) {
                        for(var i = 0; i < excludedPrototypes.length; ++i){
                            if (excludedPrototypes[i] === val) return true;
                        }
                        return false;
                    };
                    if (es5.isES5) {
                        var getKeys = Object.getOwnPropertyNames;
                        return function(obj) {
                            var ret = [];
                            var visitedKeys = Object.create(null);
                            while(obj != null && !isExcludedProto(obj)){
                                var keys;
                                try {
                                    keys = getKeys(obj);
                                } catch (e) {
                                    return ret;
                                }
                                for(var i = 0; i < keys.length; ++i){
                                    var key = keys[i];
                                    if (visitedKeys[key]) continue;
                                    visitedKeys[key] = true;
                                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                                }
                                obj = es5.getPrototypeOf(obj);
                            }
                            return ret;
                        };
                    } else {
                        var hasProp = {}.hasOwnProperty;
                        return function(obj) {
                            if (isExcludedProto(obj)) return [];
                            var ret = [];
                            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
                            else {
                                for(var i = 0; i < excludedPrototypes.length; ++i){
                                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                                }
                                ret.push(key);
                            }
                            return ret;
                        };
                    }
                }();
                var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
                function isClass(fn) {
                    try {
                        if (typeof fn === "function") {
                            var keys = es5.names(fn.prototype);
                            var hasMethods = es5.isES5 && keys.length > 1;
                            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
                            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
                        }
                        return false;
                    } catch (e) {
                        return false;
                    }
                }
                function toFastProperties(obj) {
                    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
                    FakeConstructor.prototype = obj;
                    var receiver = new FakeConstructor();
                    function ic() {
                        return (0, $02413262891c7eb5$export$5f0017c582d45a2d)(receiver.foo);
                    }
                    ic();
                    ic();
                    return obj;
                }
                var rident = /^[a-z$_][a-z$_0-9]*$/i;
                function isIdentifier(str) {
                    return rident.test(str);
                }
                function filledRange(count, prefix, suffix) {
                    var ret = new Array(count);
                    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
                    return ret;
                }
                function safeToString(obj) {
                    try {
                        return obj + "";
                    } catch (e) {
                        return "[no string representation]";
                    }
                }
                function isError(obj) {
                    return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
                }
                function markAsOriginatingFromRejection(e) {
                    try {
                        notEnumerableProp(e, "isOperational", true);
                    } catch (ignore) {}
                }
                function originatesFromRejection(e) {
                    if (e == null) return false;
                    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
                }
                function canAttachTrace(obj) {
                    return isError(obj) && es5.propertyIsWritable(obj, "stack");
                }
                var ensureErrorObject = function() {
                    if (!("stack" in new Error())) return function(value) {
                        if (canAttachTrace(value)) return value;
                        try {
                            throw new Error(safeToString(value));
                        } catch (err) {
                            return err;
                        }
                    };
                    else return function(value) {
                        if (canAttachTrace(value)) return value;
                        return new Error(safeToString(value));
                    };
                }();
                function classString(obj) {
                    return ({}).toString.call(obj);
                }
                function copyDescriptors(from, to, filter) {
                    var keys = es5.names(from);
                    for(var i = 0; i < keys.length; ++i){
                        var key = keys[i];
                        if (filter(key)) try {
                            es5.defineProperty(to, key, es5.getDescriptor(from, key));
                        } catch (ignore) {}
                    }
                }
                var asArray = function asArray(v) {
                    if (es5.isArray(v)) return v;
                    return null;
                };
                if (typeof Symbol !== "undefined" && Symbol.iterator) {
                    var ArrayFrom = typeof Array.from === "function" ? function ArrayFrom(v) {
                        return Array.from(v);
                    } : function(v) {
                        var ret = [];
                        var it = v[Symbol.iterator]();
                        var itResult;
                        while(!(itResult = it.next()).done)ret.push(itResult.value);
                        return ret;
                    };
                    asArray = function asArray(v) {
                        if (es5.isArray(v)) return v;
                        else if (v != null && typeof v[Symbol.iterator] === "function") return ArrayFrom(v);
                        return null;
                    };
                }
                var isNode = typeof $3ce9c2508a6babe0$exports !== "undefined" && classString($3ce9c2508a6babe0$exports).toLowerCase() === "[object process]";
                var hasEnvVariables = typeof $3ce9c2508a6babe0$exports !== "undefined" && typeof $3ce9c2508a6babe0$exports.env !== "undefined";
                function env(key) {
                    return hasEnvVariables ? $3ce9c2508a6babe0$exports.env[key] : undefined;
                }
                function getNativePromise() {
                    if (typeof Promise === "function") try {
                        var promise = new Promise(function() {});
                        if (classString(promise) === "[object Promise]") return Promise;
                    } catch (e) {}
                }
                var reflectHandler;
                function contextBind(ctx, cb) {
                    if (ctx === null || typeof cb !== "function" || cb === reflectHandler) return cb;
                    if (ctx.domain !== null) cb = ctx.domain.bind(cb);
                    var async = ctx.async;
                    if (async !== null) {
                        var old = cb;
                        cb = function cb() {
                            var args = new Array(2).concat([].slice.call(arguments));
                            args[0] = old;
                            args[1] = this;
                            return async.runInAsyncScope.apply(async, args);
                        };
                    }
                    return cb;
                }
                var ret = {
                    setReflectHandler: function setReflectHandler(fn) {
                        reflectHandler = fn;
                    },
                    isClass: isClass,
                    isIdentifier: isIdentifier,
                    inheritedDataKeys: inheritedDataKeys,
                    getDataPropertyOrDefault: getDataPropertyOrDefault,
                    thrower: thrower,
                    isArray: es5.isArray,
                    asArray: asArray,
                    notEnumerableProp: notEnumerableProp,
                    isPrimitive: isPrimitive,
                    isObject: isObject,
                    isError: isError,
                    canEvaluate: canEvaluate,
                    errorObj: errorObj,
                    tryCatch: tryCatch,
                    inherits: inherits,
                    withAppended: withAppended,
                    maybeWrapAsError: maybeWrapAsError,
                    toFastProperties: toFastProperties,
                    filledRange: filledRange,
                    toString: safeToString,
                    canAttachTrace: canAttachTrace,
                    ensureErrorObject: ensureErrorObject,
                    originatesFromRejection: originatesFromRejection,
                    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
                    classString: classString,
                    copyDescriptors: copyDescriptors,
                    isNode: isNode,
                    hasEnvVariables: hasEnvVariables,
                    env: env,
                    global: globalObject,
                    getNativePromise: getNativePromise,
                    contextBind: contextBind
                };
                ret.isRecentNode = ret.isNode && function() {
                    var version;
                    if ($3ce9c2508a6babe0$exports.versions && $3ce9c2508a6babe0$exports.versions.node) version = $3ce9c2508a6babe0$exports.versions.node.split(".").map(Number);
                    else if ($3ce9c2508a6babe0$exports.version) version = $3ce9c2508a6babe0$exports.version.split(".").map(Number);
                    return version[0] === 0 && version[1] > 10 || version[0] > 0;
                }();
                ret.nodeSupportsAsyncResource = ret.isNode && function() {
                    var supportsAsync = false;
                    try {
                        var res = _dereq_1("async_hooks").AsyncResource;
                        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
                    } catch (e) {
                        supportsAsync = false;
                    }
                    return supportsAsync;
                }();
                if (ret.isNode) ret.toFastProperties($3ce9c2508a6babe0$exports);
                try {
                    throw new Error();
                } catch (e) {
                    ret.lastLineError = e;
                }
                module1.exports = ret;
            },
            {
                "./es5": 13,
                "async_hooks": undefined
            }
        ]
    }, {}, [
        4
    ])(4);
});
if (typeof window !== "undefined" && window !== null) window.P = window.Promise;
else if (typeof self !== "undefined" && self !== null) self.P = self.Promise;


var $028104993e391016$exports = {};
/*!
 * smooth-scroll v14.2.1: Animate scrolling to anchor links
 * (c) 2018 Chris Ferdinandi
 * MIT License
 * http://github.com/cferdinandi/smooth-scroll
 */ /**
 * closest() polyfill
 * @link https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
 */ if (window.Element && !Element.prototype.closest) Element.prototype.closest = function(s) {
    var matches = (this.document || this.ownerDocument).querySelectorAll(s), i, el = this;
    do {
        i = matches.length;
        while(--i >= 0 && matches.item(i) !== el);
    }while (i < 0 && (el = el.parentElement));
    return el;
};
/**
 * CustomEvent() polyfill
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
 */ (function() {
    if (typeof window.CustomEvent === "function") return false;
    function CustomEvent1(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: undefined
        };
        var evt = document.createEvent("CustomEvent");
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }
    CustomEvent1.prototype = window.Event.prototype;
    window.CustomEvent = CustomEvent1;
})();
/**
 * requestAnimationFrame() polyfill
 * By Erik Möller. Fixes from Paul Irish and Tino Zijdel.
 * @link http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * @link http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * @license MIT
 */ (function() {
    var lastTime = 0;
    var vendors = [
        "ms",
        "moz",
        "webkit",
        "o"
    ];
    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x){
        window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
        window.cancelAnimationFrame = window[vendors[x] + "CancelAnimationFrame"] || window[vendors[x] + "CancelRequestAnimationFrame"];
    }
    if (!window.requestAnimationFrame) window.requestAnimationFrame = function(callback, element) {
        var currTime = new Date().getTime();
        var timeToCall = Math.max(0, 16 - (currTime - lastTime));
        var id = window.setTimeout(function() {
            callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
    };
    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function(id) {
        clearTimeout(id);
    };
})();
(function(root, factory) {
    if (typeof define === "function" && define.amd) define([], function() {
        return factory(root);
    });
    else $028104993e391016$exports = factory(root);
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : $028104993e391016$exports, function(window1) {
    "use strict";
    //
    // Default settings
    //
    var defaults = {
        // Selectors
        ignore: "[data-scroll-ignore]",
        header: null,
        topOnEmptyHash: true,
        // Speed & Easing
        speed: 500,
        clip: true,
        offset: 0,
        easing: "easeInOutCubic",
        customEasing: null,
        // History
        updateURL: true,
        popstate: true,
        // Custom Events
        emitEvents: true
    };
    //
    // Utility Methods
    //
    /**
	 * Check if browser supports required methods
	 * @return {Boolean} Returns true if all required methods are supported
	 */ var supports = function supports() {
        return "querySelector" in document && "addEventListener" in window1 && "requestAnimationFrame" in window1 && "closest" in window1.Element.prototype;
    };
    /**
	 * Merge two or more objects. Returns a new object.
	 * @param {Object}   objects  The objects to merge together
	 * @returns {Object}          Merged values of defaults and options
	 */ var extend = function extend() {
        // Variables
        var extended = {};
        // Merge the object into the extended object
        var merge = function merge(obj) {
            for(var prop in obj)if (obj.hasOwnProperty(prop)) extended[prop] = obj[prop];
        };
        // Loop through each object and conduct a merge
        for(var i = 0; i < arguments.length; i++)merge(arguments[i]);
        return extended;
    };
    /**
	 * Check to see if user prefers reduced motion
	 * @param  {Object} settings Script settings
	 */ var reduceMotion = function reduceMotion(settings) {
        if ("matchMedia" in window1 && window1.matchMedia("(prefers-reduced-motion)").matches) return true;
        return false;
    };
    /**
	 * Get the height of an element.
	 * @param  {Node} elem The element to get the height of
	 * @return {Number}    The element's height in pixels
	 */ var getHeight = function getHeight(elem) {
        return parseInt(window1.getComputedStyle(elem).height, 10);
    };
    /**
	 * Decode a URI, with error check
	 * @param  {String} hash The URI to decode
	 * @return {String}      A decoded URI (or the original string if an error is thrown)
	 */ var decode = function decode(hash) {
        var decoded;
        try {
            decoded = decodeURIComponent(hash);
        } catch (e) {
            decoded = hash;
        }
        return decoded;
    };
    /**
	 * Escape special characters for use with querySelector
	 * @author Mathias Bynens
	 * @link https://github.com/mathiasbynens/CSS.escape
	 * @param {String} id The anchor ID to escape
	 */ var escapeCharacters = function escapeCharacters(id) {
        // Remove leading hash
        if (id.charAt(0) === "#") id = id.substr(1);
        var string = String(id);
        var length = string.length;
        var index = -1;
        var codeUnit;
        var result = "";
        var firstCodeUnit = string.charCodeAt(0);
        while(++index < length){
            codeUnit = string.charCodeAt(index);
            // Note: there’s no need to special-case astral symbols, surrogate
            // pairs, or lone surrogates.
            // If the character is NULL (U+0000), then throw an
            // `InvalidCharacterError` exception and terminate these steps.
            if (codeUnit === 0x0000) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
            if (// If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
            // U+007F, […]
            codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F || // If the character is the first character and is in the range [0-9]
            // (U+0030 to U+0039), […]
            index === 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 || // If the character is the second character and is in the range [0-9]
            // (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
            index === 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit === 0x002D) {
                // http://dev.w3.org/csswg/cssom/#escape-a-character-as-code-point
                result += "\\" + codeUnit.toString(16) + " ";
                continue;
            }
            // If the character is not handled by one of the above rules and is
            // greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
            // is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
            // U+005A), or [a-z] (U+0061 to U+007A), […]
            if (codeUnit >= 0x0080 || codeUnit === 0x002D || codeUnit === 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
                // the character itself
                result += string.charAt(index);
                continue;
            }
            // Otherwise, the escaped character.
            // http://dev.w3.org/csswg/cssom/#escape-a-character
            result += "\\" + string.charAt(index);
        }
        // Return sanitized hash
        var hash;
        try {
            hash = decodeURIComponent("#" + result);
        } catch (e) {
            hash = "#" + result;
        }
        return hash;
    };
    /**
	 * Calculate the easing pattern
	 * @link https://gist.github.com/gre/1650294
	 * @param {String} type Easing pattern
	 * @param {Number} time Time animation should take to complete
	 * @returns {Number}
	 */ var easingPattern = function easingPattern(settings, time) {
        var pattern;
        // Default Easing Patterns
        if (settings.easing === "easeInQuad") pattern = time * time; // accelerating from zero velocity
        if (settings.easing === "easeOutQuad") pattern = time * (2 - time); // decelerating to zero velocity
        if (settings.easing === "easeInOutQuad") pattern = time < 0.5 ? 2 * time * time : -1 + (4 - 2 * time) * time; // acceleration until halfway, then deceleration
        if (settings.easing === "easeInCubic") pattern = time * time * time; // accelerating from zero velocity
        if (settings.easing === "easeOutCubic") pattern = --time * time * time + 1; // decelerating to zero velocity
        if (settings.easing === "easeInOutCubic") pattern = time < 0.5 ? 4 * time * time * time : (time - 1) * (2 * time - 2) * (2 * time - 2) + 1; // acceleration until halfway, then deceleration
        if (settings.easing === "easeInQuart") pattern = time * time * time * time; // accelerating from zero velocity
        if (settings.easing === "easeOutQuart") pattern = 1 - --time * time * time * time; // decelerating to zero velocity
        if (settings.easing === "easeInOutQuart") pattern = time < 0.5 ? 8 * time * time * time * time : 1 - 8 * --time * time * time * time; // acceleration until halfway, then deceleration
        if (settings.easing === "easeInQuint") pattern = time * time * time * time * time; // accelerating from zero velocity
        if (settings.easing === "easeOutQuint") pattern = 1 + --time * time * time * time * time; // decelerating to zero velocity
        if (settings.easing === "easeInOutQuint") pattern = time < 0.5 ? 16 * time * time * time * time * time : 1 + 16 * --time * time * time * time * time; // acceleration until halfway, then deceleration
        // Custom Easing Patterns
        if (!!settings.customEasing) pattern = settings.customEasing(time);
        return pattern || time; // no easing, no acceleration
    };
    /**
	 * Determine the document's height
	 * @returns {Number}
	 */ var getDocumentHeight = function getDocumentHeight() {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    };
    /**
	 * Calculate how far to scroll
	 * Clip support added by robjtede - https://github.com/cferdinandi/smooth-scroll/issues/405
	 * @param {Element} anchor       The anchor element to scroll to
	 * @param {Number}  headerHeight Height of a fixed header, if any
	 * @param {Number}  offset       Number of pixels by which to offset scroll
	 * @param {Boolean} clip         If true, adjust scroll distance to prevent abrupt stops near the bottom of the page
	 * @returns {Number}
	 */ var getEndLocation = function getEndLocation(anchor, headerHeight, offset, clip) {
        var location = 0;
        if (anchor.offsetParent) do {
            location += anchor.offsetTop;
            anchor = anchor.offsetParent;
        }while (anchor);
        location = Math.max(location - headerHeight - offset, 0);
        if (clip) location = Math.min(location, getDocumentHeight() - window1.innerHeight);
        return location;
    };
    /**
	 * Get the height of the fixed header
	 * @param  {Node}   header The header
	 * @return {Number}        The height of the header
	 */ var getHeaderHeight = function getHeaderHeight(header) {
        return !header ? 0 : getHeight(header) + header.offsetTop;
    };
    /**
	 * Update the URL
	 * @param  {Node}    anchor  The anchor that was scrolled to
	 * @param  {Boolean} isNum   If true, anchor is a number
	 * @param  {Object}  options Settings for Smooth Scroll
	 */ var updateURL = function updateURL(anchor, isNum, options) {
        // Bail if the anchor is a number
        if (isNum) return;
        // Verify that pushState is supported and the updateURL option is enabled
        if (!history.pushState || !options.updateURL) return;
        // Update URL
        history.pushState({
            smoothScroll: JSON.stringify(options),
            anchor: anchor.id
        }, document.title, anchor === document.documentElement ? "#top" : "#" + anchor.id);
    };
    /**
	 * Bring the anchored element into focus
	 * @param {Node}     anchor      The anchor element
	 * @param {Number}   endLocation The end location to scroll to
	 * @param {Boolean}  isNum       If true, scroll is to a position rather than an element
	 */ var adjustFocus = function adjustFocus(anchor, endLocation, isNum) {
        // Is scrolling to top of page, blur
        if (anchor === 0) document.body.focus();
        // Don't run if scrolling to a number on the page
        if (isNum) return;
        // Otherwise, bring anchor element into focus
        anchor.focus();
        if (document.activeElement !== anchor) {
            anchor.setAttribute("tabindex", "-1");
            anchor.focus();
            anchor.style.outline = "none";
        }
        window1.scrollTo(0, endLocation);
    };
    /**
	 * Emit a custom event
	 * @param  {String} type    The event type
	 * @param  {Object} options The settings object
	 * @param  {Node}   anchor  The anchor element
	 * @param  {Node}   toggle  The toggle element
	 */ var emitEvent = function emitEvent(type, options, anchor, toggle) {
        if (!options.emitEvents || typeof window1.CustomEvent !== "function") return;
        var event = new CustomEvent(type, {
            bubbles: true,
            detail: {
                anchor: anchor,
                toggle: toggle
            }
        });
        document.dispatchEvent(event);
    };
    //
    // SmoothScroll Constructor
    //
    var SmoothScroll = function SmoothScroll(selector, options) {
        //
        // Variables
        //
        var smoothScroll = {}; // Object for public APIs
        var settings, anchor, toggle, fixedHeader, headerHeight, eventTimeout, animationInterval;
        //
        // Methods
        //
        /**
		 * Cancel a scroll-in-progress
		 */ smoothScroll.cancelScroll = function(noEvent) {
            cancelAnimationFrame(animationInterval);
            animationInterval = null;
            if (noEvent) return;
            emitEvent("scrollCancel", settings);
        };
        /**
		 * Start/stop the scrolling animation
		 * @param {Node|Number} anchor  The element or position to scroll to
		 * @param {Element}     toggle  The element that toggled the scroll event
		 * @param {Object}      options
		 */ smoothScroll.animateScroll = function(anchor, toggle, options) {
            // Local settings
            var animateSettings = extend(settings || defaults, options || {}); // Merge user options with defaults
            // Selectors and variables
            var isNum = Object.prototype.toString.call(anchor) === "[object Number]" ? true : false;
            var anchorElem = isNum || !anchor.tagName ? null : anchor;
            if (!isNum && !anchorElem) return;
            var startLocation = window1.pageYOffset; // Current location on the page
            if (animateSettings.header && !fixedHeader) // Get the fixed header if not already set
            fixedHeader = document.querySelector(animateSettings.header);
            if (!headerHeight) // Get the height of a fixed header if one exists and not already set
            headerHeight = getHeaderHeight(fixedHeader);
            var endLocation = isNum ? anchor : getEndLocation(anchorElem, headerHeight, parseInt(typeof animateSettings.offset === "function" ? animateSettings.offset(anchor, toggle) : animateSettings.offset, 10), animateSettings.clip); // Location to scroll to
            var distance = endLocation - startLocation; // distance to travel
            var documentHeight = getDocumentHeight();
            var timeLapsed = 0;
            var start, percentage, position;
            /**
			 * Stop the scroll animation when it reaches its target (or the bottom/top of page)
			 * @param {Number} position Current position on the page
			 * @param {Number} endLocation Scroll to location
			 * @param {Number} animationInterval How much to scroll on this loop
			 */ var stopAnimateScroll = function stopAnimateScroll(position, endLocation) {
                // Get the current location
                var currentLocation = window1.pageYOffset;
                // Check if the end location has been reached yet (or we've hit the end of the document)
                if (position == endLocation || currentLocation == endLocation || (startLocation < endLocation && window1.innerHeight + currentLocation) >= documentHeight) {
                    // Clear the animation timer
                    smoothScroll.cancelScroll(true);
                    // Bring the anchored element into focus
                    adjustFocus(anchor, endLocation, isNum);
                    // Emit a custom event
                    emitEvent("scrollStop", animateSettings, anchor, toggle);
                    // Reset start
                    start = null;
                    animationInterval = null;
                    return true;
                }
            };
            /**
			 * Loop scrolling animation
			 */ var loopAnimateScroll = function loopAnimateScroll1(timestamp) {
                if (!start) start = timestamp;
                timeLapsed += timestamp - start;
                percentage = timeLapsed / parseInt(animateSettings.speed, 10);
                percentage = percentage > 1 ? 1 : percentage;
                position = startLocation + distance * easingPattern(animateSettings, percentage);
                window1.scrollTo(0, Math.floor(position));
                if (!stopAnimateScroll(position, endLocation)) {
                    animationInterval = window1.requestAnimationFrame(loopAnimateScroll);
                    start = timestamp;
                }
            };
            /**
			 * Reset position to fix weird iOS bug
			 * @link https://github.com/cferdinandi/smooth-scroll/issues/45
			 */ if (window1.pageYOffset === 0) window1.scrollTo(0, 0);
            // Update the URL
            updateURL(anchor, isNum, animateSettings);
            // Emit a custom event
            emitEvent("scrollStart", animateSettings, anchor, toggle);
            // Start scrolling animation
            smoothScroll.cancelScroll(true);
            window1.requestAnimationFrame(loopAnimateScroll);
        };
        /**
		 * If smooth scroll element clicked, animate scroll
		 */ var clickHandler = function clickHandler(event) {
            // Don't run if the user prefers reduced motion
            if (reduceMotion(settings)) return;
            // Don't run if right-click or command/control + click
            if (event.button !== 0 || event.metaKey || event.ctrlKey) return;
            // Check if event.target has closest() method
            // By @totegi - https://github.com/cferdinandi/smooth-scroll/pull/401/
            if (!("closest" in event.target)) return;
            // Check if a smooth scroll link was clicked
            toggle = event.target.closest(selector);
            if (!toggle || toggle.tagName.toLowerCase() !== "a" || event.target.closest(settings.ignore)) return;
            // Only run if link is an anchor and points to the current page
            if (toggle.hostname !== window1.location.hostname || toggle.pathname !== window1.location.pathname || !/#/.test(toggle.href)) return;
            // Get an escaped version of the hash
            var hash = escapeCharacters(decode(toggle.hash));
            // Get the anchored element
            var anchor = settings.topOnEmptyHash && hash === "#" ? document.documentElement : document.querySelector(hash);
            anchor = !anchor && hash === "#top" ? document.documentElement : anchor;
            // If anchored element exists, scroll to it
            if (!anchor) return;
            event.preventDefault();
            smoothScroll.animateScroll(anchor, toggle);
        };
        /**
		 * Animate scroll on popstate events
		 */ var popstateHandler = function popstateHandler(event) {
            // Stop if history.state doesn't exist (ex. if clicking on a broken anchor link).
            // fixes `Cannot read property 'smoothScroll' of null` error getting thrown.
            if (history.state === null) return;
            // Only run if state is a popstate record for this instantiation
            if (!history.state.smoothScroll || history.state.smoothScroll !== JSON.stringify(settings)) return;
            // Only run if state includes an anchor
            if (!history.state.anchor) return;
            // Get the anchor
            var anchor = document.querySelector(escapeCharacters(decode(history.state.anchor)));
            if (!anchor) return;
            // Animate scroll to anchor link
            smoothScroll.animateScroll(anchor, null, {
                updateURL: false
            });
        };
        /**
		 * On window scroll and resize, only run events at a rate of 15fps for better performance
		 */ var resizeThrottler = function resizeThrottler(event) {
            if (!eventTimeout) eventTimeout = setTimeout(function() {
                eventTimeout = null; // Reset timeout
                headerHeight = getHeaderHeight(fixedHeader); // Get the height of a fixed header if one exists
            }, 66);
        };
        /**
		 * Destroy the current initialization.
		 */ smoothScroll.destroy = function() {
            // If plugin isn't already initialized, stop
            if (!settings) return;
            // Remove event listeners
            document.removeEventListener("click", clickHandler, false);
            window1.removeEventListener("resize", resizeThrottler, false);
            window1.removeEventListener("popstate", popstateHandler, false);
            // Cancel any scrolls-in-progress
            smoothScroll.cancelScroll();
            // Reset variables
            settings = null;
            anchor = null;
            toggle = null;
            fixedHeader = null;
            headerHeight = null;
            eventTimeout = null;
            animationInterval = null;
        };
        /**
		 * Initialize Smooth Scroll
		 * @param {Object} options User settings
		 */ smoothScroll.init = function(options) {
            // feature test
            if (!supports()) throw "Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";
            // Destroy any existing initializations
            smoothScroll.destroy();
            // Selectors and variables
            settings = extend(defaults, options || {}); // Merge user options with defaults
            fixedHeader = settings.header ? document.querySelector(settings.header) : null; // Get the fixed header
            headerHeight = getHeaderHeight(fixedHeader);
            // When a toggle is clicked, run the click handler
            document.addEventListener("click", clickHandler, false);
            // If window is resized and there's a fixed header, recalculate its size
            if (fixedHeader) window1.addEventListener("resize", resizeThrottler, false);
            // If updateURL and popState are enabled, listen for pop events
            if (settings.updateURL && settings.popstate) window1.addEventListener("popstate", popstateHandler, false);
        };
        //
        // Initialize plugin
        //
        smoothScroll.init(options);
        //
        // Public APIs
        //
        return smoothScroll;
    };
    return SmoothScroll;
});


// --------------------------------------------------------------
// Components
// --------------------------------------------------------------
// --------------------------------------------------------------
// Styles
// --------------------------------------------------------------


var $80772200608a50ba$export$2e2bcd8739ae039 = function GridLayout() {
    "use strict";
    (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, GridLayout);
};


// Modified codes from CRA
var $5c14791898ae9094$var$isLocalhost = Boolean(window.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
window.location.hostname === "[::1]" || // 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));
function $5c14791898ae9094$export$2e2bcd8739ae039() {}
function $5c14791898ae9094$var$registerValidSW(swUrl) {
    navigator.serviceWorker.register(swUrl).then(function(registration) {
        registration.onupdatefound = function() {
            var installingWorker = registration.installing;
            installingWorker.onstatechange = function() {
                if (installingWorker.state === "installed") {
                    if (navigator.serviceWorker.controller) // At this point, the old content will have been purged and
                    // the fresh content will have been added to the cache.
                    // It's the perfect time to display a "New content is
                    // available; please refresh." message in your web app.
                    console.log("New content is available; please refresh.");
                    else // At this point, everything has been precached.
                    // It's the perfect time to display a
                    // "Content is cached for offline use." message.
                    console.log("Content is cached for offline use.");
                }
            };
        };
    }).catch(function(error) {
        console.error("Error during service worker registration:", error);
    });
}
function $5c14791898ae9094$var$checkValidServiceWorker(swUrl) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl).then(function(response) {
        // Ensure service worker exists, and that we really are getting a JS file.
        if (response.status === 404 || response.headers.get("content-type").indexOf("javascript") === -1) // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(function(registration) {
            registration.unregister().then(function() {
                window.location.reload();
            });
        });
        else // Service worker found. Proceed as normal.
        $5c14791898ae9094$var$registerValidSW(swUrl);
    }).catch(function() {
        console.log("No internet connection found. App is running in offline mode.");
    });
}



/**
 * This file is auto-generated. Don't make any changes here — they will be owerwritten.
 */ // --------------------------------------------------------------
// Components
// --------------------------------------------------------------










































/**
 * This file is auto-generated. Don't make any changes here — they will be owerwritten.
 */ // --------------------------------------------------------------
// Components
// --------------------------------------------------------------


var $75bb565976f344da$export$2e2bcd8739ae039 = function Carousel() {
    "use strict";
    var _this = this;
    (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Carousel);
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "carouselSelector", "[data-js-carousel]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "itemClassName", "carousel__item");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "itemSelector", "[data-js-content]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "totalSelector", "[data-js-total]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "buttonNextSelector", "[data-js-next]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "buttonPrevSelector", "[data-js-prev]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "slide", 0);
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "moving", true);
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "setInitialClasses", function() {
        var carousels = $75bb565976f344da$var$getElementList(document, _this.carouselSelector);
        if (carousels) carousels.forEach(function(carousel) {
            var items = $75bb565976f344da$var$getElementList(carousel, _this.itemSelector);
            var totalItems = items.length;
            var total = carousel.querySelector(_this.totalSelector);
            if (total) total.textContent = "".concat(_this.slide + 1, " / ").concat(totalItems);
            if (totalItems >= 1) {
                if (totalItems >= 3) {
                    items[totalItems - 1].classList.add("prev");
                    items[0].classList.add("active");
                    items[1].classList.add("next");
                }
                if (totalItems === 1) items[0].classList.add("active");
                else {
                    items[0].classList.add("active");
                    items[1].classList.add("next");
                }
            }
            if (totalItems > 1) _this.setEventListeners(carousel, items, totalItems);
        });
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "addWAI", function(carousel) {
        var liveregion = document.createElement("div");
        liveregion.setAttribute("aria-live", "polite");
        liveregion.setAttribute("aria-atomic", "true");
        liveregion.setAttribute("class", "liveregion sr-only");
        carousel.appendChild(liveregion);
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "setEventListeners", function(carousel, items, totalItems) {
        if (carousel) {
            var next = carousel.querySelector(_this.buttonNextSelector);
            var prev = carousel.querySelector(_this.buttonPrevSelector);
            next.addEventListener("click", function() {
                _this.moveNext(carousel, items, totalItems);
            });
            prev.addEventListener("click", function() {
                _this.movePrev(carousel, items, totalItems);
            });
            _this.addWAI(carousel, items, totalItems);
        }
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "moveNext", function(carousel, items, totalItems) {
        if (!_this.moving) {
            if (_this.slide === 0) _this.slide = totalItems - 1;
            else _this.slide--;
        }
        _this.moveCarouselTo(carousel, items, totalItems);
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "movePrev", function(carousel, items, totalItems) {
        if (!_this.moving) {
            if (_this.slide === totalItems - 1) _this.slide = 0;
            else _this.slide++;
        }
        _this.moveCarouselTo(carousel, items, totalItems);
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "disableInteraction", function() {
        _this.moving = true;
        setTimeout(function() {
            _this.moving = false;
        }, 500);
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "moveCarouselTo", function(carousel, items, totalItems) {
        if (!_this.moving) {
            _this.disableInteraction();
            if (carousel) {
                var newPrevious = _this.slide - 1, newNext = _this.slide + 1, oldPrevious = _this.slide - 2, oldNext = _this.slide + 2;
                if (totalItems - 1 > 3) {
                    if (newPrevious <= 0) oldPrevious = totalItems - 1;
                    else if (newNext >= totalItems - 1) oldNext = 0;
                }
                if (_this.slide === 0) {
                    newPrevious = totalItems - 1;
                    oldPrevious = totalItems - 2;
                    oldNext = _this.slide + 1;
                } else if (_this.slide === totalItems - 1) {
                    newPrevious = _this.slide - 1;
                    newNext = 0;
                    oldNext = 1;
                }
                items[newPrevious].className = _this.itemClassName + " prev";
                items[_this.slide].className = _this.itemClassName + " active";
                items[newNext].className = _this.itemClassName + " next";
                var liveregion = carousel.querySelector(".liveregion");
                liveregion.textContent = "Item " + (_this.slide + 1) + " of " + totalItems;
                var total = carousel.querySelector(_this.totalSelector);
                if (total) total.textContent = "".concat(_this.slide + 1, " / ").concat(totalItems);
            }
        }
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "initCarousel", function() {
        _this.setInitialClasses();
        _this.setEventListeners();
        _this.moving = false;
    });
    this.initCarousel();
};
function $75bb565976f344da$var$getElementList(parent, query) {
    var elements = parent.querySelectorAll(query);
    return Array.from(elements);
}





var $d1a9fb261fb4bdcb$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Accordion() {
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Accordion);
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "listSelector", "[data-js-accordion]");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "itemSelector", "[data-js-accordion-item]");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "itemButtonSelector", ".content-accordion__item__title > button");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "expandedClass", "content-accordion__item--expanded");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "initExpandedClass", "content-accordion__item--init-expansion");
        this.setupAccordions();
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(Accordion, [
        {
            key: "setupAccordions",
            value: function setupAccordions() {
                var _this = this;
                var elements = $d1a9fb261fb4bdcb$var$getElementList(document, this.listSelector);
                elements.forEach(function(element) {
                    _this.setupAccordion(element);
                });
            }
        },
        {
            key: "setupAccordion",
            value: function setupAccordion(list) {
                var _this = this;
                var elements = $d1a9fb261fb4bdcb$var$getElementList(list, this.itemSelector);
                elements.forEach(function(element) {
                    var button = element.querySelector(_this.itemButtonSelector);
                    button.addEventListener("click", function() {
                        if (element.classList.contains(_this.expandedClass)) _this.collapseItem(element);
                        else {
                            _this.collpaseAllItems(list);
                            _this.expandItem(element);
                        }
                    });
                });
            }
        },
        {
            key: "expandItem",
            value: function expandItem(element) {
                var _this = this;
                var button = element.querySelector(".content-accordion__item button");
                if (button) button.setAttribute("aria-expanded", "true");
                element.classList.add(this.expandedClass, this.initExpandedClass);
                setTimeout(function() {
                    element.classList.remove(_this.initExpandedClass);
                }, 100);
            }
        },
        {
            key: "collapseItem",
            value: function collapseItem(element) {
                element.classList.remove(this.expandedClass);
                var button = element.querySelector(".content-accordion__item button");
                if (button) button.setAttribute("aria-expanded", "false");
            }
        },
        {
            key: "collpaseAllItems",
            value: function collpaseAllItems(list) {
                var _this = this;
                var expandedElements = $d1a9fb261fb4bdcb$var$getElementList(list, ".".concat(this.expandedClass));
                expandedElements.forEach(function(expandedElement) {
                    expandedElement.classList.remove(_this.expandedClass);
                });
            }
        }
    ]);
    return Accordion;
}();
function $d1a9fb261fb4bdcb$var$getElementList(parent, query) {
    var elements = parent.querySelectorAll(query);
    return Array.from(elements);
}





var $e5fba8c51b82c4b4$exports = {};
(function(global, factory) {
    $e5fba8c51b82c4b4$exports = factory();
})($e5fba8c51b82c4b4$exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function read(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function write(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function remove(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function withAttributes(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function withConverter(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});




var $4e44526c1b2f2bf0$var$TagManagerHandler = /*#__PURE__*/ function() {
    "use strict";
    function TagManagerHandler() {
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, TagManagerHandler);
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(TagManagerHandler, [
        {
            key: "dispatchEventsOnPageLoad",
            value: function dispatchEventsOnPageLoad(state, eventValue) {
                this.dispatchAnalyticsEvent(state, eventValue);
            }
        },
        {
            key: "dispatchAnalyticsEvent",
            value: function dispatchAnalyticsEvent(state, eventValue) {
                if (window && window.dataLayer && window.dataLayer.push && state && eventValue) window.dataLayer.push({
                    event: eventValue
                });
            }
        }
    ]);
    return TagManagerHandler;
}();
var $4e44526c1b2f2bf0$export$2e2bcd8739ae039 = new $4e44526c1b2f2bf0$var$TagManagerHandler();



var $e88f115a2b325121$var$Cookiebar = /*#__PURE__*/ function() {
    "use strict";
    function Cookiebar() {
        var _this = this;
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Cookiebar);
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "eventListener", function() {
            var targets = document.querySelectorAll("[data-target]");
            targets.forEach(function(target) {
                target.addEventListener("click", function(event) {
                    return _this.onAccept(event);
                });
            });
        });
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "onAccept", function(e) {
            e.preventDefault();
            var cookieGroupName = e.target.attributes["data-cookie-allowed-group-name"].value;
            if (cookieGroupName !== _this.defaultCookieGroup) {
                cookieGroupName = [
                    _this.defaultCookieGroup,
                    cookieGroupName
                ].join(",").replace('"', "");
                if (0, $4e44526c1b2f2bf0$export$2e2bcd8739ae039) (0, $4e44526c1b2f2bf0$export$2e2bcd8739ae039).dispatchAnalyticsEvent(true, "has_ga_cookie_consent");
                (0, $236abd3863dac270$export$2e2bcd8739ae039).changeState({
                    cookieConsent: true
                });
            }
            if (_this.element && _this.element.classList.contains("cookiebar--visible")) _this.element.classList.remove("cookiebar--visible");
            $e5fba8c51b82c4b4$exports.set(_this.acceptedCookieName, cookieGroupName, {
                expires: 365
            });
        });
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "_stateUpdated", function(next, previous) {
            if (next.cookieConsent && _this.element.classList.contains("cookiebar--visible")) _this.element.classList.remove("cookiebar--visible");
        });
        this.tagManagerHandler = (0, $4e44526c1b2f2bf0$export$2e2bcd8739ae039);
        this.element = document.querySelector(".js--cookiebar");
        this.acceptedCookieName = "";
        this.defaultCookieGroup = "";
        this.accepted = null;
        this.setup();
        this.eventListener();
        (0, $236abd3863dac270$export$2e2bcd8739ae039).on((0, $236abd3863dac270$export$dc7e8c09bf56e28f), this._stateUpdated);
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(Cookiebar, [
        {
            key: "setup",
            value: function setup() {
                if (!this.element) return;
                this.acceptedCookieName = this.element.attributes["data-cookie-notice-dismissed-name"].value;
                this.defaultCookieGroup = this.element.attributes["data-default-cookie-group"].value;
                this.accepted = $e5fba8c51b82c4b4$exports.get(this.acceptedCookieName);
                if (!this.accepted) this.element.classList.add("cookiebar--visible");
            }
        }
    ]);
    return Cookiebar;
}();
var $e88f115a2b325121$export$2e2bcd8739ae039 = $e88f115a2b325121$var$Cookiebar;








var $a7c25baf61577074$var$CookieSettingsMacro = /*#__PURE__*/ function() {
    "use strict";
    function CookieSettingsMacro() {
        var _this = this;
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, CookieSettingsMacro);
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "_stateUpdated", function(state) {
            if (state.cookieConsent === true) {
                if (document.getElementById("cookie-settings-analytics") && !document.getElementById("cookie-settings-analytics").checked) {
                    document.getElementById("cookie-settings-analytics").checked = true;
                    _this.onStatusChange();
                }
            }
        });
        this.tagManagerHandler = (0, $4e44526c1b2f2bf0$export$2e2bcd8739ae039);
        this.acceptedCookieName = "";
        this.checkedGroups = [];
        this.onStatusChange = this.onStatusChange.bind(this);
        this.setup();
        (0, $236abd3863dac270$export$2e2bcd8739ae039).on((0, $236abd3863dac270$export$dc7e8c09bf56e28f), this._stateUpdated);
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(CookieSettingsMacro, [
        {
            key: "setup",
            value: function setup() {
                var componentClass = ".js--cookiesettings";
                var element = document.querySelector(componentClass);
                if (!element) return;
                this.acceptedCookieName = element.attributes["data-cookie-notice-dismissed-name"].value;
                this.defaultCookieGroup = element.attributes["data-default-cookie-group"].value;
                this.setCookieGroups = [
                    "functional"
                ];
                var existingCookie = $e5fba8c51b82c4b4$exports.get(this.acceptedCookieName);
                // If cookies exist, don't show the cookiebar. 
                // Cookiebar should only be shown if no cookie is set.
                if (existingCookie) {
                    this.setCookieGroups = existingCookie.split(",");
                    document.querySelector(".js--cookiebar").classList.remove("cookiebar--visible");
                }
                // Set checkbox status based on cookie groups
                if (this.setCookieGroups) document.getElementById("cookie-settings-analytics").checked = this.setCookieGroups.includes("analytical");
                element.addEventListener("change", this.onStatusChange);
            }
        },
        {
            key: "onStatusChange",
            value: function onStatusChange() {
                // Update checkedGroups based on checkbox status
                this.checkedGroups = [
                    "functional",
                    document.getElementById("cookie-settings-analytics").checked ? "analytical" : ""
                ].filter(Boolean); // filter out any empty strings
                var cookieGroups = this.checkedGroups.join(",").replace('"', "");
                $e5fba8c51b82c4b4$exports.set(this.acceptedCookieName, cookieGroups, {
                    expires: 365
                });
                // Hide the cookie bar if the user toggles the checkbox in the settings
                if (this.checkedGroups.includes("analytical")) {
                    var cookieBar = document.querySelector(".js--cookiebar");
                    if (cookieBar && cookieBar.classList.contains("cookiebar--visible")) cookieBar.classList.remove("cookiebar--visible");
                    if (0, $4e44526c1b2f2bf0$export$2e2bcd8739ae039) (0, $4e44526c1b2f2bf0$export$2e2bcd8739ae039).dispatchAnalyticsEvent(true, "has_ga_cookie_consent");
                }
            }
        }
    ]);
    return CookieSettingsMacro;
}();
var $a7c25baf61577074$export$2e2bcd8739ae039 = $a7c25baf61577074$var$CookieSettingsMacro;










var $55fc29e7ac997fea$export$ea9cbac1a9d08e5 = "menu_open";
var $55fc29e7ac997fea$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Emitter) {
    "use strict";
    (0, $458b276467f5f7f8$export$7e4530ad35d3bb8)(Menu, Emitter);
    var _super = (0, $8bb5c09b2c0b5c8b$export$8dd05c13f5255580)(Menu);
    function Menu() {
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Menu);
        var _this;
        _this = _super.call(this);
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "menuModalSelector", "[data-menu]");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "menuAccordionSelector", "[data-accordion]");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "menuAccordionTriggerClass", "menu__accordion--trigger");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "expandedClass", "expanded");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "menuListClass", "menu__list--phases");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "menuListItemClass", "menu__list__item");
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "firstFocusableElement", null);
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "lastFocusableElement", null);
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "eventListener", function() {
            window.addEventListener("resize", function() {
                _this.handleViewPort();
            });
            var menuTriggers = document.querySelectorAll("[data-accordion-toggle]");
            menuTriggers.forEach(function(trigger) {
                var group = trigger.getAttribute("data-group");
                trigger.addEventListener("click", function(event) {
                    _this.toggleMenuGroup(group, event);
                });
            });
        });
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "handleViewPort", function() {
            var width = window.innerWidth;
            var isMobile = width < 981;
            var accordions = document.querySelectorAll(_this.menuAccordionSelector);
            if (isMobile) accordions.forEach(function(accordion) {
                return _this.closeSubmenu(accordion);
            });
            else accordions.forEach(function(accordion) {
                return _this.openSubmenu(accordion);
            });
        });
        /**
   * Open the menu
   */ (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "open", function() {
            var menu = document.querySelector(_this.menuModalSelector);
            if (menu && !menu.classList.contains("menu--expanded")) {
                menu.classList.add("menu--expanded");
                _this.enableTrapFocus();
                document.body.classList.add("has-overlay");
            }
        });
        /**
   * Close the menu
   */ (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "close", function() {
            var menu = document.querySelector(_this.menuModalSelector);
            if (menu && menu.classList.contains("menu--expanded")) {
                menu.classList.remove("menu--expanded");
                _this.disableTrapFocus();
                document.body.classList.remove("has-overlay");
            }
        });
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "toggleMenuGroup", function(group, event) {
            var trigger = document.querySelector("." + _this.menuAccordionTriggerClass + "-" + group);
            var parent = trigger.closest(_this.menuAccordionSelector);
            var currentList = parent.querySelector("." + _this.menuListClass);
            var accordions = document.querySelectorAll(_this.menuAccordionSelector);
            var shouldOpen = !currentList.classList.contains(_this.expandedClass);
            accordions.forEach(function(accordion) {
                _this.closeSubmenu(accordion);
            });
            if (shouldOpen) _this.openSubmenu(parent);
        });
        // trap focus in modal
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "enableTrapFocus", function() {
            var focusableElements = "button, a";
            var modal = document.querySelector(_this.menuModalSelector); // select the modal by class
            var focusableContent = modal.querySelectorAll(focusableElements);
            _this.firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
            _this.lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal
            document.addEventListener("keydown", _this.keyDownListener);
        });
        /**
     * Accordion is each submenu
     */ (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "openSubmenu", function(accordion) {
            var currentList = accordion.querySelector("." + _this.menuListClass);
            var trigger = accordion.querySelector("." + _this.menuAccordionTriggerClass);
            if (currentList) {
                currentList.classList.add(_this.expandedClass);
                accordion.classList.add(_this.expandedClass);
                var currentListItems = currentList.querySelectorAll(".".concat(_this.menuListItemClass, " a"));
                if (currentListItems) currentListItems.forEach(function(item) {
                    item.removeAttribute("tabIndex", "-1");
                });
            }
            if (trigger) trigger.setAttribute("aria-expanded", true);
        });
        /**
     * Accordion is each submenu
     */ (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "closeSubmenu", function(accordion) {
            var currentList = accordion.querySelector("." + _this.menuListClass);
            var trigger = accordion.querySelector("." + _this.menuAccordionTriggerClass);
            if (currentList) {
                currentList.classList.remove(_this.expandedClass);
                accordion.classList.remove(_this.expandedClass);
                var currentListItems = currentList.querySelectorAll(".".concat(_this.menuListItemClass, " a"));
                if (currentListItems) currentListItems.forEach(function(item) {
                    item.setAttribute("tabIndex", "-1");
                });
            }
            if (trigger) trigger.setAttribute("aria-expanded", false);
        });
        /**
     * Handle state update.
     *
     * @param {Object} next Next state
     * @param {Object} previous Previous state
     */ (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "_stateUpdated", function(next, previous) {
            if (!previous[$55fc29e7ac997fea$export$ea9cbac1a9d08e5] && next[$55fc29e7ac997fea$export$ea9cbac1a9d08e5]) _this.open();
            else if (previous[$55fc29e7ac997fea$export$ea9cbac1a9d08e5] && !next[$55fc29e7ac997fea$export$ea9cbac1a9d08e5]) _this.close();
        });
        _this.eventListener();
        _this.on((0, $236abd3863dac270$export$8b4395497d8b4223), _this._stateUpdated);
        _this.handleViewPort();
        return _this;
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(Menu, [
        {
            key: "keyDownListener",
            value: function keyDownListener(e) {
                var isTabPressed = e.key === "Tab" || e.keyCode === 9;
                if (!isTabPressed) return;
                if (e.shiftKey) // if shift key pressed for shift + tab combination
                {
                    if (document.activeElement === this.firstFocusableElement) {
                        this.lastFocusableElement.focus(); // add focus for the last focusable element
                        e.preventDefault();
                    }
                } else // if tab key is pressed
                if (document.activeElement === this.lastFocusableElement) {
                    // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    this.firstFocusableElement.focus();
                    e.preventDefault();
                }
            }
        },
        {
            key: "disableTrapFocus",
            value: function disableTrapFocus() {
                document.removeEventListener("keydown", this.keyDownListener);
            }
        }
    ]);
    return Menu;
}((0, (/*@__PURE__*/$parcel$interopDefault($057c0fd32ae7196f$exports))));











var $8bbc990aaac10a01$export$2e2bcd8739ae039 = /*#__PURE__*/ function(Emitter) {
    "use strict";
    (0, $458b276467f5f7f8$export$7e4530ad35d3bb8)(SiteHeader, Emitter);
    var _super = (0, $8bb5c09b2c0b5c8b$export$8dd05c13f5255580)(SiteHeader);
    function SiteHeader() {
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, SiteHeader);
        var _this;
        _this = _super.call(this);
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "clickedOpen", function(event) {
            event.preventDefault();
            _this.emit((0, $236abd3863dac270$export$8b4395497d8b4223), (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)({}, (0, $55fc29e7ac997fea$export$ea9cbac1a9d08e5), true));
        });
        (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)((0, $94de31091369a6d0$export$f3b8ed2e4a5d10b8)(_this), "clickedClose", function(event) {
            event.preventDefault();
            _this.emit((0, $236abd3863dac270$export$8b4395497d8b4223), (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)({}, (0, $55fc29e7ac997fea$export$ea9cbac1a9d08e5), false));
        });
        _this.setupComponent();
        return _this;
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(SiteHeader, [
        {
            key: "setupComponent",
            value: function setupComponent() {
                var menuToggle = document.querySelector("[data-menu-toggle]");
                var menuClose = document.querySelector("[data-menu-close]");
                if (menuToggle) menuToggle.addEventListener("click", this.clickedOpen);
                if (menuClose) menuClose.addEventListener("click", this.clickedClose);
            }
        }
    ]);
    return SiteHeader;
}((0, (/*@__PURE__*/$parcel$interopDefault($057c0fd32ae7196f$exports))));




function $d98aac6b0e201d17$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $2775659ad0e2ea5a$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $d98aac6b0e201d17$export$79e617b1955a2616)(arr);
}


function $48fd7e82277bf71f$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $6bedbaa8b9ed18ae$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $13843472f4533342$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $d98aac6b0e201d17$export$79e617b1955a2616)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $d98aac6b0e201d17$export$79e617b1955a2616)(o, minLen);
}


function $b2b84284e67669bd$export$1b5e630bc3aea29f(arr) {
    return (0, $2775659ad0e2ea5a$export$7e0947b5ad3404e2)(arr) || (0, $48fd7e82277bf71f$export$1eb58a6e75231000)(arr) || (0, $13843472f4533342$export$a5be06335b3a083c)(arr) || (0, $6bedbaa8b9ed18ae$export$e6f3c4780d19eb2b)();
}


var $df29039ace22e00c$export$2e2bcd8739ae039 = function Sticky() {
    "use strict";
    var _this = this;
    (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Sticky);
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "asideSelector", "[data-js-aside]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "linkSelector", "[data-js-link]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "sectionSelector", "[data-js-section]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "siteHeaderSelector", "[data-js-site-header]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "activeClass", "js-active");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "setup", function() {
        var aside = document.querySelector(_this.asideSelector);
        var list = document.querySelectorAll(_this.linkSelector);
        var headings = document.querySelectorAll("a[id]");
        if (aside) _this.handleScrollSpy(list, headings);
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "handleScrollSpy", function(list, headings) {
        var hero = document.querySelector(_this.siteHeaderSelector);
        var heroHeight = hero.offsetHeight;
        // null check to allow hero height checker to catch up
        var makeActive = function(link) {
            if (list[link]) list[link].classList.add(_this.activeClass);
        };
        var removeActive = function(link) {
            return list[link].classList.remove(_this.activeClass);
        };
        var removeAllActive = function() {
            return (0, $b2b84284e67669bd$export$1b5e630bc3aea29f)(Array(headings.length).keys()).forEach(function(link) {
                return removeActive(link);
            });
        };
        var currentActive = 0;
        var sectionMargin = 100;
        window.addEventListener("scroll", function() {
            // check if scroll has passed hero and the amount of links and sections correspond
            if (window.scrollY > heroHeight && list.length === headings.length) {
                var current = headings.length - (0, $b2b84284e67669bd$export$1b5e630bc3aea29f)(headings).reverse().findIndex(function(headings) {
                    return window.scrollY >= headings.offsetTop - sectionMargin;
                }) - 1;
                if (current !== currentActive) {
                    removeAllActive();
                    currentActive = current;
                    makeActive(current);
                }
            }
        });
    });
    this.setup();
};


// --------------------------------------------------------------
// Components
// --------------------------------------------------------------
// --------------------------------------------------------------
// Styles
// --------------------------------------------------------------

var $f20b95d9357d23d3$export$2e2bcd8739ae039 = function Root() {
    "use strict";
    (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Root);
};


// --------------------------------------------------------------
// Components
// --------------------------------------------------------------
// --------------------------------------------------------------
// Styles
// --------------------------------------------------------------


var $a79b14f6666c455b$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Survey() {
        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Survey);
        this.init();
    }
    (0, $46c5ec7b680f2ebd$export$d60067ff2358eee8)(Survey, [
        {
            key: "init",
            value: function init() {
                var appData;
                var numberOfSections = 0;
                var sectionCounter = 0;
                var allUserChoices = [];
                var surveyFieldsetErrorMsg = "";
                // Start Page Elements
                var startContainer = document.querySelector("[data-survey-page-start]");
                if (!startContainer) // Stop init if not on page.
                return;
                var startHeading = document.querySelector("[data-survey-page-start-heading]");
                // const startPreamble = document.querySelector("[data-survey-page-start-preamble]");
                var startSurveyBtn = document.querySelector("[data-survey-page-start-btn]");
                // Survey Page Elements
                var surveyContainer = document.querySelector("[data-survey-page]");
                var surveyHeading = document.querySelector("[data-survey-page-heading]");
                var surveySections = document.querySelector("[data-survey-page-sections]");
                var nextSectionBtn = document.querySelector("[data-survey-page-section-next-btn]");
                var prevSectionBtn = document.querySelector("[data-survey-page-section-prev-btn]");
                var surveyErrorMsg = document.querySelector("[data-survey-page-error-msg]");
                var surveyErrorMsgText = document.querySelector("[data-survey-page-error-msg-text]");
                var surveyErrorMsgBtn = document.querySelector("[data-survey-page-error-msg-btn]");
                // Result Page Elements
                var resultContainer = document.querySelector("[data-survey-page-result]");
                var resultHeading = document.querySelector("[data-survey-page-result-heading]");
                var resultPreamble = document.querySelector("[data-survey-page-result-preamble]");
                var resultSections = document.querySelector("[data-survey-page-result-sections]");
                var resultPageAdditionalInformation = document.querySelector("[data-survey-page-additional-result-information]");
                var restartBtn = document.querySelector("[data-survey-page-result-restart-btn]");
                var printBtn = document.querySelector("[data-survey-page-result-print-btn]");
                if (document.querySelector("[data-api-pageId]") != null && document.querySelector("[data-api-url]") != null) {
                    var mainUrl = window.location.protocol + "//" + window.location.host + "/";
                    var apiPageId = document.querySelector("[data-api-pageId]").getAttribute("data-api-pageId");
                    var apiUrl = document.querySelector("[data-api-url]").getAttribute("data-api-url");
                    var completeUrl = mainUrl + apiUrl + "?pageId=" + apiPageId;
                    var getJSON = function getJSON(url) {
                        var xhr = new XMLHttpRequest();
                        xhr.open("GET", url, true);
                        xhr.onload = function() {
                            var status = xhr.status;
                            if (status == 200) {
                                var response = JSON.parse(xhr.responseText);
                                appData = response.Result;
                                var currentSurveyHeading = "";
                                if (appData.SurveyPreHeadingLabel.length != 0) currentSurveyHeading = "<span>" + appData.SurveyPreHeadingLabel + "</span>" + appData.SurveyHeading;
                                else currentSurveyHeading = appData.SurveyHeading;
                                startHeading.innerHTML = currentSurveyHeading;
                                surveyHeading.innerHTML = currentSurveyHeading;
                                resultHeading.innerHTML = currentSurveyHeading;
                                surveyErrorMsgText.innerText = appData.MandatoryErrorMessage;
                                surveyFieldsetErrorMsg = appData.MandatoryStatementMessage;
                                numberOfSections = appData.SurveyData.length;
                            } else console.error(status);
                        };
                        xhr.send();
                    };
                    getJSON(completeUrl);
                    // Click handler for the 'Start' button
                    startSurveyBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        renderAllSections();
                        startContainer.style.display = "none";
                        surveyContainer.style.display = "block";
                        displayNextSection(sectionCounter);
                    }, false);
                    // Click handler for the 'Next Section' button
                    nextSectionBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        validateSurveySection();
                    }, false);
                    // Click handler for the 'Prev Section' button
                    prevSectionBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        surveyErrorMsg.style.display = "none";
                        sectionCounter--;
                        displayNextSection();
                    }, false);
                    // Click handler for the 'Restart' button
                    restartBtn.addEventListener("click", function(e) {
                        e.preventDefault();
                        sectionCounter = 0;
                        allUserChoices = [];
                        renderAllSections();
                        resultContainer.classList.remove("visible");
                        resultSections.innerHTML = "";
                        surveyContainer.style.display = "block";
                        displayNextSection();
                    });
                    // Click handler for the 'Print' button
                    printBtn.addEventListener("click", function(e) {
                        window.print();
                    });
                    window.addEventListener("scroll", function(e) {
                        checkIsElementInView(".page--survey__fade-in-element", "visible");
                    });
                    window.addEventListener("resize", function(e) {
                        checkIsElementInView(".page--survey__fade-in-element", "visible");
                    });
                }
                // Creates all survey sections
                function renderAllSections() {
                    surveySections.innerHTML = "";
                    var surveySection = undefined;
                    var surveySectionHeading = undefined;
                    var surveySectionPreamble = undefined;
                    var surveySectionStatements = undefined;
                    var surveySectionStatementsContainer = undefined;
                    for(var i = 0; i < numberOfSections; i++){
                        var currentSectionIndex = i;
                        var currentSection = appData.SurveyData[i].SurveySection[0];
                        surveySectionStatements = currentSection.Statements;
                        surveySection = document.createElement("section");
                        surveySection.setAttribute("data-section-" + currentSectionIndex, "");
                        surveySection.setAttribute("class", "page--survey__main-container__section");
                        surveySectionHeading = document.createElement("h3");
                        surveySectionHeading.setAttribute("class", "h1");
                        surveySectionHeading.innerHTML = "<span class='page--survey__main-container__section-counter'>Del " + (i + 1) + " av " + numberOfSections + "</span>" + currentSection.Heading;
                        surveySection.appendChild(surveySectionHeading);
                        if (currentSection.Preamble != undefined && currentSection.Preamble.length != 0) {
                            surveySectionPreamble = document.createElement("p");
                            surveySectionPreamble.setAttribute("class", "page--survey__main-container__section__preamble");
                            surveySectionPreamble.innerText = currentSection.Preamble;
                            surveySection.appendChild(surveySectionPreamble);
                        }
                        surveySectionStatementsContainer = document.createElement("div");
                        for(var i1 = 0; i1 < surveySectionStatements.length; i1++){
                            var statement = createStatementElement(i1, currentSectionIndex, surveySectionStatements);
                            surveySectionStatementsContainer.appendChild(statement);
                        }
                        surveySection.appendChild(surveySectionStatementsContainer);
                        surveySections.appendChild(surveySection);
                    }
                    window.dataLayer.push({
                        event: "surveyStart"
                    });
                    window._mtm = window._mtm || [];
                    window._mtm.push({
                        event: "surveyStart"
                    });
                }
                // Creates and returns a fieldset that contains the statement and the radio buttons
                function createStatementElement(index, currentSectionIndex, surveySectionStatements) {
                    var qElement = document.createElement("fieldset");
                    qElement.setAttribute("data-section-" + currentSectionIndex + "-fieldset-" + index, "");
                    qElement.setAttribute("class", "page--survey__fade-in-element");
                    var question = document.createElement("legend");
                    question.setAttribute("class", "h2");
                    var questionText = surveySectionStatements[index].Statement.trim();
                    question.innerText = questionText;
                    qElement.appendChild(question);
                    var radioButtons = createRadios(index, currentSectionIndex, surveySectionStatements);
                    qElement.appendChild(radioButtons);
                    return qElement;
                }
                // Creates a list of radio inputs
                function createRadios(statementIndex, sectionIndex, surveySectionStatements) {
                    var radioListContainer = document.createElement("div");
                    radioListContainer.setAttribute("class", "page--survey__radio-list");
                    var radioList = document.createElement("ul");
                    var item = undefined;
                    var input = undefined;
                    var label = undefined;
                    var labelSpan = undefined;
                    var currentAnswer = undefined;
                    var currentScore = undefined;
                    for(var i = 0; i < surveySectionStatements[statementIndex].PossibleAnswers.length; i++){
                        currentAnswer = surveySectionStatements[statementIndex].PossibleAnswers[i].Answer.trim();
                        currentScore = surveySectionStatements[statementIndex].PossibleAnswers[i].Score;
                        item = document.createElement("li");
                        input = document.createElement("input");
                        label = document.createElement("label");
                        label.setAttribute("for", "section-" + sectionIndex + "-statement-" + statementIndex + "-option-" + currentScore);
                        labelSpan = document.createElement("span");
                        input.setAttribute("type", "radio");
                        input.setAttribute("id", "section-" + sectionIndex + "-statement-" + statementIndex + "-option-" + currentScore);
                        input.setAttribute("name", "section-" + sectionIndex + "-statement-" + statementIndex);
                        input.setAttribute("value", currentAnswer);
                        input.setAttribute("data-score", currentScore);
                        input.addEventListener("click", function(e) {
                            validateSingleFieldset(e);
                        });
                        labelSpan.innerText = currentAnswer;
                        label.appendChild(labelSpan);
                        item.appendChild(input);
                        item.appendChild(label);
                        radioList.appendChild(item);
                    }
                    var radioListErrorMsg = document.createElement("p");
                    radioListErrorMsg.setAttribute("class", "page--survey__radio-list-error");
                    radioListErrorMsg.innerText = surveyFieldsetErrorMsg;
                    radioListContainer.appendChild(radioList);
                    radioListContainer.appendChild(radioListErrorMsg);
                    return radioListContainer;
                }
                function validateSingleFieldset(e) {
                    var targetClassList = e.target.closest("fieldset").classList;
                    if (targetClassList.contains("error")) targetClassList.remove("error");
                    var numberOfSectionCheckedRadios = 0;
                    var currentSectionStatementsLength = appData.SurveyData[sectionCounter].SurveySection[0].Statements.length;
                    for(var i = 0; i < currentSectionStatementsLength; i++){
                        var currentFieldset = document.querySelector("[data-section-" + sectionCounter + "-fieldset-" + i + "]");
                        var checkedRadio = currentFieldset.querySelector("input[name='section-" + sectionCounter + "-statement-" + i + "']:checked");
                        if (checkedRadio != undefined) numberOfSectionCheckedRadios++;
                    }
                    if (numberOfSectionCheckedRadios === currentSectionStatementsLength && nextSectionBtn.classList.contains("error")) nextSectionBtn.classList.remove("error");
                }
                // Validates every input field of the current survey section
                function validateSurveySection() {
                    var numberOfCheckedRadios = 0;
                    var currentSectionStatementsLength = appData.SurveyData[sectionCounter].SurveySection[0].Statements.length;
                    for(var i = 0; i < currentSectionStatementsLength; i++){
                        var currentFieldset = document.querySelector("[data-section-" + sectionCounter + "-fieldset-" + i + "]");
                        var checkedRadio = currentFieldset.querySelector("input[name='section-" + sectionCounter + "-statement-" + i + "']:checked");
                        if (checkedRadio != undefined) numberOfCheckedRadios++;
                        else currentFieldset.classList.add("error");
                    }
                    if (numberOfCheckedRadios === currentSectionStatementsLength) {
                        openErrorModal(false);
                        saveUserChoices(currentSectionStatementsLength);
                        sectionCounter++;
                        displayNextSection();
                    } else openErrorModal(true);
                }
                function lockTabbing(e) {
                    surveyErrorMsgBtn.focus();
                    if (e.keyCode === 9 && document.body.classList.contains("survey-error-modal-open")) {
                        e.preventDefault();
                        surveyErrorMsgBtn.focus();
                    }
                }
                function openErrorModal(willOpen) {
                    if (!willOpen) {
                        nextSectionBtn.classList.remove("error");
                        surveyErrorMsg.classList.remove("visible");
                        document.body.classList.remove("survey-error-modal-open");
                    } else {
                        nextSectionBtn.classList.add("error");
                        surveyErrorMsg.classList.add("visible");
                        document.body.classList.add("survey-error-modal-open");
                        surveyErrorMsgBtn.setAttribute("tabindex", 0);
                        window.addEventListener("keydown", function(e) {
                            lockTabbing(e);
                        });
                        surveyErrorMsgBtn.addEventListener("click", function(e) {
                            e.preventDefault();
                            surveyErrorMsg.classList.remove("visible");
                            document.body.classList.remove("survey-error-modal-open");
                            window.removeEventListener("keydown", lockTabbing);
                        }, false);
                    }
                }
                // Reads the user selection and pushes the value to an array
                function saveUserChoices(currentSectionStatementsLength) {
                    // Array for user choices per category
                    var sectionUserChoices = [];
                    // Object containing the statement and the answer and score of the user choice
                    var userChoiceObject = function userChoiceObject(statement, userChoiceAnswer, userChoiceScore) {
                        (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, userChoiceObject);
                        this.Statement = statement;
                        this.UserChoiceAnswer = userChoiceAnswer;
                        this.UserChoiceScore = userChoiceScore;
                    };
                    // Get every user choice per category
                    for(var i = 0; i < currentSectionStatementsLength; i++){
                        var fieldset = document.querySelector("[data-section-" + sectionCounter + "-fieldset-" + i + "]");
                        var fieldsetStatement = fieldset.querySelector("legend").innerText;
                        var fieldsetUserChoice = fieldset.querySelector("input[name='section-" + sectionCounter + "-statement-" + i + "']:checked");
                        var fieldsetUserChoiceAnswer = fieldsetUserChoice.value;
                        var fieldsetUserChoiceScore = fieldsetUserChoice.getAttribute("data-score");
                        var singleUserChoice = new userChoiceObject(fieldsetStatement, fieldsetUserChoiceAnswer, fieldsetUserChoiceScore);
                        sectionUserChoices.push(singleUserChoice);
                    }
                    // Update the array containing all user choices with current category user choices
                    allUserChoices[sectionCounter] = sectionUserChoices;
                }
                // Displays next requested element
                function displayNextSection() {
                    var currentSection = document.querySelector("[data-section-" + sectionCounter + "]");
                    var prevSection = document.querySelector("[data-section-" + (sectionCounter - 1) + "]");
                    var nextSection = document.querySelector("[data-section-" + (sectionCounter + 1) + "]");
                    if (sectionCounter < numberOfSections) {
                        if (prevSection !== null) prevSection.classList.remove("visible");
                        if (nextSection !== null) nextSection.classList.remove("visible");
                        window.scrollTo({
                            top: 0,
                            behavior: "auto"
                        });
                        currentSection.classList.add("visible");
                        // Controls display of 'prev' button
                        if (sectionCounter > 0) prevSectionBtn.style.display = "block";
                        else {
                            prevSectionBtn.style.display = "none";
                            nextSectionBtn.style.display = "block";
                        }
                        if (sectionCounter + 1 < numberOfSections) nextSectionBtn.innerHTML = "N\xe4sta del<i aria-hidden='true' class='icon fas fa-arrow-right'>";
                        else nextSectionBtn.innerHTML = "Slutf\xf6r och visa resultat<i aria-hidden='true' class='icon fas fa-arrow-right'>";
                    } else displayResults();
                }
                // Computes score and returns a paragraph element to be displayed
                function displayResults() {
                    surveyContainer.style.display = "none";
                    resultPreamble.innerText = appData.SurveyResultDescription;
                    if (appData.ResultPageAdditionalInformation.length != 0) {
                        resultPageAdditionalInformation.setAttribute("class", "page--survey__result-container__additional-material");
                        var resultPageAdditionalInformationHeading = document.createElement("h3");
                        resultPageAdditionalInformationHeading.setAttribute("class", "h1 page--survey__result-container__additional-material__headline");
                        resultPageAdditionalInformationHeading.innerHTML = appData.ResultPageAdditionalInformationHeading;
                        var resultPageAdditionalInformationText = document.createElement("p");
                        resultPageAdditionalInformationText.setAttribute("class", "page--survey__result-container__additional-material__content");
                        resultPageAdditionalInformationText.innerHTML = appData.ResultPageAdditionalInformation;
                        resultPageAdditionalInformation.appendChild(resultPageAdditionalInformationHeading);
                        resultPageAdditionalInformation.appendChild(resultPageAdditionalInformationText);
                    }
                    var resultSection = undefined;
                    var resultSectionHeading = undefined;
                    var resultSectionAdditionalMaterial = undefined;
                    // Renders every main section
                    for(var i = 0; i < numberOfSections; i++){
                        var currentResultSectionIndex = i;
                        var currentResultSection = appData.SurveyData[i].SurveySection[0];
                        resultSection = document.createElement("section");
                        resultSection.setAttribute("class", "page--survey__result-container__section");
                        resultSectionHeading = document.createElement("h3");
                        resultSectionHeading.setAttribute("class", "h1");
                        resultSectionHeading.innerHTML = "<span>Del " + (i + 1) + "</span>" + currentResultSection.Heading;
                        resultSection.appendChild(resultSectionHeading);
                        var resultUnderSection = undefined;
                        var resultUnderSectionHeading = undefined;
                        var resultUnderSectionPreamble = undefined;
                        var SurveyResultAnalysis = currentResultSection.SurveyResultAnalysis;
                        // Renders every under section
                        for(var i1 = 0; i1 < SurveyResultAnalysis.length; i1++){
                            var currentResultUnderSection = SurveyResultAnalysis[i1];
                            var currentResultUnderSectionScoreGroup = currentResultUnderSection.ScoreGroup;
                            resultUnderSection = document.createElement("section");
                            resultUnderSection.setAttribute("class", "page--survey__result-container__section__under-section");
                            resultUnderSectionHeading = document.createElement("h3");
                            resultUnderSectionHeading.setAttribute("class", "h2");
                            resultUnderSectionHeading.innerText = currentResultUnderSection.Heading;
                            resultUnderSection.appendChild(resultUnderSectionHeading);
                            if (currentResultUnderSection.Summary != undefined && currentResultUnderSection.Summary.length != 0) {
                                resultUnderSectionPreamble = document.createElement("p");
                                resultUnderSectionPreamble.setAttribute("class", "page--survey__result-container__section__under-section__preamble");
                                resultUnderSectionPreamble.innerText = currentResultUnderSection.Summary;
                                resultUnderSection.appendChild(resultUnderSectionPreamble);
                            }
                            for(var i2 = 0; i2 < currentResultUnderSectionScoreGroup.length; i2++)resultUnderSection.setAttribute("data-result-under-section-" + currentResultSectionIndex + "-score-" + currentResultUnderSectionScoreGroup[i2], "");
                            resultSection.appendChild(resultUnderSection);
                        }
                        if (currentResultSection.AdditionalMaterial !== "") {
                            resultSectionAdditionalMaterial = document.createElement("div");
                            resultSectionAdditionalMaterial.setAttribute("class", "page--survey__result-container__section__additional-material");
                            resultSectionAdditionalMaterial.innerHTML = currentResultSection.AdditionalMaterial;
                            resultSection.appendChild(resultSectionAdditionalMaterial);
                        }
                        resultSections.appendChild(resultSection);
                    }
                    // Renders all user choices and appends them to correct under section
                    for(var i3 = 0; i3 < allUserChoices.length; i3++){
                        var currentUserChoiceSection = allUserChoices[i3];
                        var currentUserChoiceSectionIndex = i3;
                        var resultStatementWithAnswer = undefined;
                        for(var i4 = 0; i4 < currentUserChoiceSection.length; i4++){
                            var currentUserChoice = currentUserChoiceSection[i4];
                            var currentResultUnderSection1 = document.querySelector("[data-result-under-section-" + currentUserChoiceSectionIndex + "-score-" + currentUserChoice.UserChoiceScore + "]");
                            resultStatementWithAnswer = document.createElement("div");
                            resultStatementWithAnswer.setAttribute("class", "page--survey__result-container__section__under-section__statement-with-answer");
                            switch(currentUserChoice.UserChoiceScore){
                                case "1":
                                    resultStatementWithAnswer.classList.add("page--survey__result-container__section__under-section__statement-with-answer--high");
                                    break;
                                case "2":
                                    resultStatementWithAnswer.classList.add("page--survey__result-container__section__under-section__statement-with-answer--medium-high");
                                    break;
                                case "3":
                                    resultStatementWithAnswer.classList.add("page--survey__result-container__section__under-section__statement-with-answer--medium-low");
                                    break;
                                case "4":
                                    resultStatementWithAnswer.classList.add("page--survey__result-container__section__under-section__statement-with-answer--low");
                                    break;
                                case "5":
                                    resultStatementWithAnswer.classList.add("page--survey__result-container__section__under-section__statement-with-answer--unanswered");
                                    break;
                                default:
                            }
                            resultStatementWithAnswer.innerHTML = "<p class='page--survey__result-container__section__under-section__statement-with-answer__statement'>" + currentUserChoice.Statement + "</p><div class='page--survey__result-container__section__under-section__statement-with-answer__answer'><p>" + currentUserChoice.UserChoiceAnswer + "</p></div>";
                            if (currentResultUnderSection1 != null) {
                                currentResultUnderSection1.appendChild(resultStatementWithAnswer);
                                if (!currentResultUnderSection1.classList.contains("visible")) currentResultUnderSection1.classList.add("visible");
                            }
                        }
                    }
                    window._mtm = window._mtm || [];
                    window._mtm.push({
                        event: "surveyComplete"
                    });
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "surveyComplete"
                    });
                    window.scrollTo({
                        top: 0,
                        behavior: "auto"
                    });
                    resultContainer.classList.add("visible");
                }
                function checkIsElementInView(targetClass, activeClass) {
                    var elements = document.querySelectorAll(targetClass);
                    var elementsLength = elements.length;
                    var windowHeight = window.innerHeight;
                    var windowTop = window.pageYOffset;
                    var windowBottom = windowTop + windowHeight;
                    for(var i = 0; i < elementsLength; i++){
                        var trigger = elements[i].querySelector("ul");
                        var triggerHeight = trigger.offsetHeight;
                        var triggerTop = trigger.offsetTop;
                        var triggerBottom = triggerTop + triggerHeight;
                        if (windowBottom >= triggerTop && windowTop <= triggerBottom) elements[i].classList.add(activeClass);
                    }
                }
            }
        }
    ]);
    return Survey;
}();




var $e96361d0b2dea8aa$export$2e2bcd8739ae039 = function Aside() {
    "use strict";
    var _this = this;
    (0, $b748c2928eb486ff$export$2996f80ef42b8419)(this, Aside);
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "asideSelector", "[data-js-aside]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "siteHeaderSelector", "[data-js-site-header]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "toggleButton", "[data-js-toggle-button]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "menuContent", "[data-js-menu-content]");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "stickyClass", "js-sticky");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "showClass", "js-show");
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "breakGridMobile", 980);
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "setup", function() {
        var viewportSize = document.body.getBoundingClientRect().width;
        var aside = document.querySelector(_this.asideSelector);
        if (viewportSize >= _this.breakGridMobile) {
            if (aside) _this.handleSticky(aside);
        }
        var button = document.querySelector(_this.toggleButton);
        if (button) button.addEventListener("click", function(e) {
            var content = document.querySelector(_this.menuContent);
            if (content) _this.showMenu(content, button);
        });
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "handleSticky", function(aside) {
        var hero = document.querySelector(_this.siteHeaderSelector);
        var heroHeight = hero.offsetHeight;
        window.addEventListener("scroll", function() {
            if (window.scrollY >= heroHeight) aside.classList.add(_this.stickyClass);
            else aside.classList.remove(_this.stickyClass);
        });
    });
    (0, $9dae7d5532d96567$export$1e71eb4bef00f6b0)(this, "showMenu", function(content, button) {
        if (content.classList.contains(_this.showClass)) {
            content.classList.remove(_this.showClass);
            content.setAttribute("aria-hidden", "true");
            button.setAttribute("aria-expanded", "false");
        } else {
            content.classList.add(_this.showClass);
            content.setAttribute("aria-hidden", "false");
            button.setAttribute("aria-expanded", "true");
        }
    });
    this.setup();
};


var $f33a12b94e1dee0b$export$9b5ac10f59f76296 = [
    (0, $75bb565976f344da$export$2e2bcd8739ae039),
    (0, $d1a9fb261fb4bdcb$export$2e2bcd8739ae039),
    (0, $e88f115a2b325121$export$2e2bcd8739ae039),
    (0, $a7c25baf61577074$export$2e2bcd8739ae039),
    (0, $55fc29e7ac997fea$export$2e2bcd8739ae039),
    (0, $8bbc990aaac10a01$export$2e2bcd8739ae039),
    (0, $df29039ace22e00c$export$2e2bcd8739ae039)
];
var $f33a12b94e1dee0b$export$da3bc2f57520e3c3 = [
    (0, $f20b95d9357d23d3$export$2e2bcd8739ae039),
    (0, $a79b14f6666c455b$export$2e2bcd8739ae039),
    (0, $e96361d0b2dea8aa$export$2e2bcd8739ae039)
];


$parcel$global.Promise = (0, (/*@__PURE__*/$parcel$interopDefault($b72fab8558ef5d54$exports)));
new (0, (/*@__PURE__*/$parcel$interopDefault($028104993e391016$exports)))('a[href*="#"]');
// Instatiate GridLayout
new (0, $80772200608a50ba$export$2e2bcd8739ae039)();
(0, $5c14791898ae9094$export$2e2bcd8739ae039)();
// Instatiate Components
(0, $f33a12b94e1dee0b$export$9b5ac10f59f76296).map(function(Component) {
    return new Component();
}).forEach(function(component) {
    if (typeof component.on === "function") component.on((0, $236abd3863dac270$export$8b4395497d8b4223), (0, $236abd3863dac270$export$2e2bcd8739ae039).changeState);
    if (typeof component._stateUpdated === "function") (0, $236abd3863dac270$export$2e2bcd8739ae039).on((0, $236abd3863dac270$export$dc7e8c09bf56e28f), component._stateUpdated);
});
// Instatiate Pages
(0, $f33a12b94e1dee0b$export$da3bc2f57520e3c3).forEach(function(Page) {
    return new Page();
}); /* // Instatiate Macro Partials
macropartials.forEach(Macro => (
  new Macro()
)); */ 

})();
//# sourceMappingURL=index.js.map
